// import logo from '../mlogo.svg'
import React, { useEffect, useState, useRef } from 'react'

import Container from 'react-bootstrap/Container'
import { Toast } from 'react-bootstrap';
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'
import Modal from 'react-bootstrap/Modal'
import { AudioConfig, SpeechConfig, SpeechRecognizer, AutoDetectSourceLanguageConfig, TranslationRecognizer } from 'microsoft-cognitiveservices-speech-sdk'

import stopBtn from './images/stopBtnV2.png'
import startBtn from './images/startBtnV2.png'
import logoImgLeft from '../logo.png'
import logoTextB from '../logoTextB.png'
// import LoginPop from './LoginPop'
import avatar from '../avatar.png'
import vip1 from './images/vip1.png'
import vip2 from './images/vip2.png'
import vip3 from './images/vip3.png'
import Userpage from './Userpage'
import { useUserAuth } from "../context/UserAuthContext";
import e from 'cors'
import { Link, useLocation } from 'react-router-dom';
import TextToSpeech from './TextToSpeech';
import SpeechToTextOffline from './Speechtotextoffline';

import MicRecorder from 'mic-recorder-to-mp3';
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import toWav from 'audiobuffer-to-wav';

import { set } from 'react-hook-form'
import { GPT_KEYWORDS, GPT_PRE_KEYWORDS, INTERFACE_CONTENT_TEXT, GPT_PROMPT_CONTENT, languageOptions, LIMIT_LENGTH_CONTENT_FETCHAI } from './Keywords';
import History from './History';
import Notedetail from './Notedetail';
import LoadingAnimation from './LoadingAnimation'
import axios from 'axios';
import { CSSTransition } from 'react-transition-group';
import SettingsPopup from './SettingsPopup'
import PricePopup from './PricePopup'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
// import { Toast } from 'primereact/toast';
import CongratulationsPopup from './checkout/Congratulations'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faChevronUp, faChevronDown, faCog, faQuestionCircle, faHome, 
  faToggleOn, faPlay, faPause, faLifeRing, faLevelUpAlt, faQuestion, faSignature, faMicrophone, 
  faStop, faFileExport, faICursor, faRocket, faMousePointer, faTimes, faSignOutAlt, faCodeBranch, 
  faHistory, faPencilAlt, faKey, faRobot, faGlobe, faFileAudio, faList, 
  faCloudUploadAlt, faPaperPlane} from '@fortawesome/free-solid-svg-icons';
import FaqsPopup from './FaqsPopup'
import WavRecorder from './recorder/WavRecorder'
import { handleConvertText, stopAudio } from './AudioGenerateAndPlay';
import OfflineTranscription from './OfflineTranscription';
import { jwtDecode } from "jwt-decode";
import { duration } from '@material-ui/core';
import { batch } from 'react-redux';
import { fetchPatient, savePatient,
  listAppointments, createAppointment, updateAppointment,
  fetchDoctors, aiSchedule } from "./firebase/firebaseApi";
import ChatWindow from './ChatWindow';
import lamejs from 'lamejs';
// import RealtimeIntercom  from './realtime/RealtimeIntercom';
// import ChatComponent from './ChatComponent';
// import SignIn from './SignIn'

// import Recorderfunc from './Recorderfunc'
// import eventEmitter from './EventEmitter';

// import { useDispatch, useSelector } from 'react-redux';
// import { startTranscription, stopTranscription, saveTranscription } from './actions/transcriptionActions';

// const API_KEY = process.env.REACT_APP_COG_SERVICE_KEY
// const API_LOCATION = process.env.REACT_APP_COG_SERVICE_LOCATION
// const speechConfig = SpeechConfig.fromSubscription(API_KEY, API_LOCATION)
// speechConfig.speechRecognitionLanguage = "en-US" 



let confirmDisplayed = false;
let countFetch = 0
let freshPageCount = 0
let userDataLocalRefreshCount = 0
// recognizer must be a global variable
let recognizer
// let transcriber = null;
let callGptByKeywordstemp = true;
let callGptByAItemp = false;
let callGptByEntertemp = false;
let callGptBySelcttemp = false;
let inputValueTemp = '';
let previousInputValueTemp = '';
let recognisedTextTemp = '';
let recognisingTextTemp = '';
let textNeedGptFeedback = '';
let modeTitleTemp = '';
// let inputValueYouSayTemp = '';
// let responseTextTemp = '';
// let textValueTempFlag = false;
let startBtnManualClicked = false;
let userTypingTextYouSay = false;
let userTypingText = false;
let askAll = false;
let isInTranscribingProcess = false;
let tokensOFresponseFromAIWhenNotTranscribing = 0;
let hasSoundInput = false;
let freeORVIPTimeInterval;
let freeORVIPBigestRecordTime = 300000; // 5 minute - Free user word recording limited time
let preTextOfRecognized = '';
let preTextOfRecoginzing = '';
let isRecognisingTemp = false;
let isAIthinkingTemp = false;
let isOfflineTranscribingTemp = false;
let isLoggedInTemp = false;
let userDataLocalTemp = null;
let startTimeTemp = null;
let detectedLanguageTemp = '';
let containsTranslateTemp = false;
let userTokenExpired = false;
let soundCheckInterval;
let isRecognitionPaused = false;
let isNetWorkConnected = true;
let wakeLock = null;

const BASE_DELAY = 5000; // 5秒
const MAX_TOTAL_WAIT = 7200e3; // 2 hour
const MAX_GPTBATCH_TASK_WAIT = 14400e3; // 4 hours
const MAX_DELAY = 180 * 1000; // 3 minutes

const Mp3Recorder = new MicRecorder({
  bitRate: 128,
  prefix: "data:audio/wav;base64,",
});

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

//2025.04.20 OpenAI Batch
async function waitForTranscript(taskId) {
  let startTime = Date.now();
  let tries = 1;

  while (true) {
    // 计算本次延时
    let delay = tries * BASE_DELAY;
    if (delay > MAX_DELAY) delay = MAX_DELAY;
    const responseData = await checkTranscriptionStatus(taskId); 
    if (responseData && responseData.transcriptionText !== null && responseData.transcriptionText !== 'Transcript updating...') {
      return responseData;
    }
    
    if (Date.now() - startTime > MAX_TOTAL_WAIT) {
      console.error('Timeout: total wait time exceeded 1 hour.');
      return null;
    }
    tries++;
    await new Promise(r => setTimeout(r, delay));
  }
}

//2025.01.11
const checkTranscriptionStatus = async (id) => {
  try {
    const response = await axios.get('/api/checkTranscriptionStatus', { 
      params: { id }
    });
    if (response.data.status === 'Succeeded') {
      return response.data;
    } else if (response.data.status === 'Failed') {
      console.error('Transcription failed, error or response.data is:', response.data.properties.error || response.data);
      return {transcriptionText: 'Transcription task not found.', subtitleWithTimestamp: ''};
    }  else {
      return {transcriptionText: 'Transcript updating...', subtitleWithTimestamp: ''};
    }
  } catch (error) {
    if (error.response && error.response.data && error.response.data.code && (error.response.data.code === 'Not Found' || error.response.data.code === 'NotFound')) {
      console.error('Transcription task not found, error or response.data is:', error.response.data);
      return {transcriptionText: 'Transcription task not found.', subtitleWithTimestamp: ''};
    } 
    console.error('Error checking transcription status:', error);
    return null;
  }
};
// —————————————————————————————————————————————————

function Transcription() {

  const sdk = require("microsoft-cognitiveservices-speech-sdk")
  const [recognisedText, setRecognisedText] = useState("")
  const [recognisedTextYouSay, setRecognisedTextYouSay] = useState("")
  const [recognisingText, setRecognisingText] = useState("")
  const [recognisingTextYouSay, setRecognisingTextYouSay] = useState("")
  const [responseText, setResponseText] = useState("")
  const [audioDetected, setAudioDetected] = useState(false)

  const [isRecognising, setIsRecognising] = useState(false)
  const [isAIthinking, setIsAIthinking] = useState(false)
  const [isPaused, setIsPaused] = useState(false)
  const [stopBtnClicked, setStopBtnClicked] = useState(false)
  // const [isInTranscribingProcess, setIsInTranscribingProcess] = useState(false)   //it's the value to identify the process of transcribing
  const responseTextRef = useRef()
  const textRef = useRef()
  const textRefYouSay = useRef()

  const timeoutRef = useRef(null)

  const startStopRecordingRef = useRef(null)
  const canvasRef = useRef(null)
  const recordingStartTimeRef = useRef(null)
  let audioContext, analyser, microphone, animationFrameId
  const mediaStreamRef = useRef(null)
  const [showPopup, setShowPopup] = useState(false)
  const [showHistoryPopup, setShowHistoryPopup] = useState(false)
  const [showSettingsPopup, setShowSettingsPopup] = useState(false)

  // const [showTestOnePopup, setShowTestOnePopup] = useState(false)   //need delete
  // const [showTestTwoPopup, setShowTestTwoPopup] = useState(false)   //need delete
  
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [showLoginPopup, setShowLoginPopup] = useState(true)
  const [userInfoAppPage, setUserInfoAppPage] = useState(null)
  const [inputValue, setInputValue] = useState('');
  const [inputValueYouSay, setInputValueYouSay] = useState('');
  const [audioStream, setAudioStream] = useState(null);
  const [audioContextForRecorder, setAudioContextForRecorder] = useState(null);

  // const [recordingStatusSet, setRecordingStatusSet] = useState(false)
  // const dispatch = useDispatch();
  
  const [isRecording, setIsRecording] = useState(false);

  const [isBlocked, setIsBlocked] = useState(false);
  const downloadLink = useRef(null);
  const [startRecordClicked, setStartRecordClicked] = useState(false);
  const [stopRecordClicked, setStopRecordClicked] = useState(false);
  const [saveRecordClicked, setSaveRecordClicked] = useState(false);
  const { user, userVipLevel, signInStatus, logOut, needUpdate, setNeedUpdate, updateUserFirestoreData, userDataLocal, 
    openPricePopup, setOpenPricePopup, shouldCheckPaymentUpdate, setShouldCheckPaymentUpdate, purchaseBtnClicked, 
    setPurchaseBtnClicked, vipLevelUpdatedConfirmed, setVipLevelUpdatedConfirmed, errorInfo, setErrorInfo, 
    needResetGPTPrompt, setNeedResetGPTPrompt, needResetAilaunchmode, setNeedResetAilaunchmode, updatedSuccessfully,
    setUpdatedSuccessfully, renewPaymentMethodConfirmed, setRenewPaymentMethodConfirmed, isOfflineTranscribing,
    updateTranscriptionData, needUpdateFromLocalStorageByAuth, taskIDOfOfflinetranscribe, dataSnapForCreateHistory, 
    setDataSnapForCreateHistory, refreshToken, updateVideoData, currentUpdateReason, setCurrentUpdateReason, checkToken, 
    updateHistory, fetchBatchQueue, upsertBatchQueue, deleteBatchQueue, transcriptDataBuffer, fetchTrascriptionData } = useUserAuth();
  const [avatarNow, setAvatarNow] = useState(avatar);
  const [showSpeechToText, setShowSpeechToText] = useState(false);
  const query = useQuery();
  const [audioBlob, setAudioBlob] = React.useState(null);
  const [blobURL, setBlobURL] = useState('');
  const [selectedNote, setSelectedNote] = useState(null);
  const [userDataChangedAppPage, setUserDataChangedAppPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [showPricePopup, setShowPricePopup] = useState(false);
  // const toast = useRef(null);
  const [usageOverMaxset, setUsageOverMaxset] = useState(false);
  const [needUpgradeUserLevel, setNeedUpgradeUserLevel] = useState(false);
  const [userInforChangedByUserDataLocal, setUserInforChangedByUserDataLocal] = useState(false);
  const [loadingText, setLoadingText] = useState('Loading ...');
  const [usingTime, setUsingTime] = useState(null);
  const [keywordsPreCallGpt, setKeywordsPreCallGpt] = useState(GPT_PRE_KEYWORDS['en-US']);
  const [keywordsCallGpt, setKeywordsCallGpt] = useState(GPT_KEYWORDS['en-US']);
  const [showCongratulationsPopup, setShowCongratulationsPopup] = useState(false);

  const [vipLevelString, setVipLevelString] = useState('Free User');
  const [upgradeBtnTitle, setUpgradeBtnTitle] = useState('Get Nvoice VIP');
  const [usageStatus, setUsageStatus] = useState('10% used');
  const [usageMax, setUsageMax] = useState('10% used');
  const [usageTime, setUsageTime] = useState('10% used');
  const [usageTimeOfCurrentTask, setUsageTimeOfCurrentTask] = useState(0);
  const [expireTime, setExpireTime] = useState();
  const [showFaqsPopup, setShowFaqsPopup] = useState(false);
  const [showSTTPopup, setShowSTTPopup] = useState(false);
  const [showTTSPopup, setShowTTSPopup] = useState(false);


  const [showSoundSignatureWavrecorder, setShowSoundSignatureWavrecorder] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [voiceSignatureStrings, setVoiceSignatureStrings] = useState([]);
  const [currentSpeaker, setCurrentSpeaker] = useState('');
  const [transcriber, setTranscriber] = useState(null);

  const [showSelectTextPopup, setShowSelectTextPopup] = useState(false);
  const [showSelectTextIntervieweePopup, setShowSelectTextIntervieweePopup] = useState(false);
  const [mouseDownLetInputValueSelectTextBeTop, setMouseDownLetInputValueSelectTextBeTop] = useState(false);
  const [mouseDownLetInputValueYouSaySelectTextBeTop, setMouseDownLetInputValueYouSaySelectTextBeTop] = useState(false);
  const [selectTextPopupPosition, setSelectTextPopupPosition] = useState({ top: 50, left: 50 });
  const [selectedText,setSelectedText] = useState('');
  const [callGptByKeywords, setCallGptByKeywords] = useState(true);
  const [callGptByAI, setCallGptByAI] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [callGptByEnter, setCallGptByEnter] = useState(false);
  const [callGptBySelct, setCallGptBySelct] = useState(false);

  const [modeTitle, setModeTitle] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][0]); //AI changes everything, AI achieves everything
  const [interviewerTitle, setInterviewerTitle] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][1]);
  const [interviewerTranscriptPlaceholdText, setInterviewerTranscriptPlaceholdText] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][2]);
  const [aiResponseTitle, setAiResponseTitle] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][3]);
  const [aiResponsePlaceholdText, setAiResponsePlaceholdText] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][4]);
  const [intervieweeTitle, setIntervieweeTitle] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][5]);
  const [intervieweeTranscriptPlaceholdText, setIntervieweeTranscriptPlaceholdText] = useState(INTERFACE_CONTENT_TEXT['Transcribe'][6]);

  const TEXT_LIMIT = LIMIT_LENGTH_CONTENT_FETCHAI;

  const [isLeftPanelVisible, setIsLeftPanelVisible] = useState(false);
  const [isTranscriptPanelVisible, setIsTranscriptPanelVisible] = useState(true);
  const [isAIResponsePanelVisible, setIsAIResponsePanelVisible] = useState(true);
  const [logoSrc, setLogoSrc] = useState(logoTextB);
  const [needLogin, setNeedLogin] = useState(false);

  const [responseFromAI, setResponseFromAI] = useState('');
  const [audioPlayEnd, setAudioPlayEnd] = useState(false);
  const [nvoiceThinkingStatusText, setNvoiceThinkingStatusText] = useState('Nvoice is thinking');
  // const selectRef = useRef(null);
//__________________________________________________________________________________________________________________
  //2024.06.21 TTS Variables setting
  const [audioUrl, setAudioUrl] = useState(null);
  const [textResponse, setTextResponse] = useState('');
  const audioRef = useRef(null);
  const [audioId, setAudioId] = useState(null);
  const [totalTTSToken, setTotalTTSToken] = useState(0);
  const [totalTTSDuration, setTotalTTSDuration] = useState(0);
//__________________________________________________________________________________________________________________
//2024.06.28 Enter key press event cusor position
  const [lastEnterIndex, setLastEnterIndex] = useState(0);
//__________________________________________________________________________________________________________________
//2024.07.08 Horizontal and vertical layout
  const [isHorizontalLayout, setIsHorizontalLayout] = useState(true);
  // const [heightOfAIInterview, setHeightOfAIInterview] = useState(0);
//__________________________________________________________________________________________________________________
//2024.07.30 TranscriptionMode Real-time Offline
  // const [currentTranscriptionMode, setCurrentTranscriptionMode] = useState('Real-time');
  const [enableExportAudio, setEnableExportAudio] = useState(false);
  const audioOfflineTranscriptionRef = useRef();
  // const { recordingBlob } = useAudioRecorder();
  // const [downloadOnSavePressBoolValue, setDownloadOnSavePressBoolValue] = useState(false);
//__________________________________________________________________________________________________________________
//2024.08.05 Notification setting
  const [showNotificationPopup, setShowNotificationPopup] = useState(false);
//2024.08.07 Language judgement
  // const [detectedLanguage, setDetectedLanguage] = useState('English');
//__________________________________________________________________________________________________________________
//2024.08.12 
  const [currentPageChangedSomething, setCurrentPageChangedSomething] = useState(false);
//__________________________________________________________________________________________________________________
//2024.08.30 the pre-name of the audio file saved in the cloud
  const [noteIDOfCloudAudio, setNoteIDOfCloudAudio] = useState('');
  // const [cloudAudioName, setCloudAudioName] = useState('');
  const [audioNameForOfflineTrancription, setAudioNameForOfflineTrancription] = useState('');

  const [endTimeOfAudio, setEndTimeOfAudio] = useState(null);  //2024.09.06 add for record the end time of audio file
  const [inRecoverUnsavedata, setInRecoverUnsavedata] = useState(false);

  const [currentRealtimeBoolValue, setCurrentRealtimeBoolValue] = useState(false);

  const [enterText, setEnterText] = useState('');
  const [isMobilephone, setIsMobilephone] = useState(false);

  //2024.10.28
  const [sttPopupStatus, setSttPopupStatus] = useState(false);
  const [sttPopupShowStatus, setSttPopupShowStatus] = useState('min');

  //2024.11.24
  const [showHistoryVariable, setShowHistoryVariable] = useState(false);

  //2024.11.28
  const timerForRestartRecognizerRef = useRef(null);

  //2024.12.06
  const [currentPresetTitle, setCurrentPresetTitle] = useState('Transcribe');

  //2024.12.13
  const [resumeTranscribe, setResumeTranscribe] = useState(false);
  const [nvoiceLogoImg, setNvoiceLogoImg] = useState(logoImgLeft);

  //2024.02.21
  const soundCheckIntervalRef = useRef(null);
  const lastChangeTimeRef = useRef(Date.now());

  //2025.02.24
  const [videoURLUserPaste, setVideoURLUserPaste] = useState('');

  //2025.03.07
  const [aiChatMessages, setAiChatMessages] = useState([]);

  //2025.04.23 OpenAI Batch   const batchTaskStautsArray = useRef([]);
  const transcriptsForBatch = useRef([]);   
  const [batchStarted, setBatchStarted] = useState(false);
  const currentBatchTaskInfo = useRef(null);   

  //2025.05.12
  const [isSessionActive, setIsSessionActive] = useState(false);
  const [events, setEvents] = useState([]);
  const [dataChannel, setDataChannel] = useState(null);
  const peerConnection = useRef(null);
  const audioElement = useRef(null);
  const [transcripts, setTranscripts] = useState([]);
  const [tokenUsage, setTokenUsage] = useState({ input: 0, output: 0, total: 0 });

  //2025.05.17
  // 新增：用户和预约、医生数据
  const [existingAppointmentId, setExistingAppointmentId] = useState(null);
  const [doctorSchedule, setDoctorSchedule] = useState([]);
  const [recordingEvents, setRecordingEvents] = useState([]);
  const localRecorder = useRef(null);
  const remoteRecorder = useRef(null);
  const sessionStartTime = useRef(0);
  // Remote stream holder
  const remoteStreamRef = useRef(new MediaStream());
  const micStreamRef = useRef(null);
  const mediaStreamRealRef = useRef(null);
  const recordingStarted = useRef(false);
  const hasStartedRemoteRecording = useRef(false);
  const pcRef         = useRef(null);
  const destStreamRef = useRef(null);          // mixed stream
  const recorderRef   = useRef(null);
  const chunksRef     = useRef([]);
  const audioElem     = useRef(null);
  const destNodeRef   = useRef(null);     // AudioContext destination
  const ctxRef        = useRef(null);
  const micStream      = useRef(null);
  const audioCtx       = useRef(null);  // AudioContext
  const mixDest        = useRef(null);  // MediaStreamDestination
  const mediaRec       = useRef(null);  // MediaRecorder
  const recChunks      = useRef([]);    // 录音数据块

  useEffect(() => {
    // 在窗口即将关闭时注销用户
    if(userDataLocal === null || userDataLocal === 'null') setIsLoading(true);
    // window.addEventListener('beforeunload', logOut);
    // // 在组件卸载时移除事件监听器

    function handleResize() {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
      
      setLogoSrc((window.innerWidth <= 800 || isMobile) ? logoImgLeft : logoTextB);
      if(window.innerWidth <= 800 || isMobile) {
        setIsLeftPanelVisible(false);
        setIsHorizontalLayout(false);
        setIsMobilephone(true);
      }
      if(window.innerWidth >= 800) {
        setLogoSrc(logoTextB)
        setIsHorizontalLayout(true);
        if(!isMobile) setIsMobilephone(false);
      }

      if(isMobile){
        if(window.innerWidth >= 800 && isMobile) {
          document.querySelector('.appstyle-right-panel').style.gridTemplateRows = '13% 75% 8%';
        } else {
          document.querySelector('.appstyle-right-panel').style.gridTemplateRows = '8% 84% 8%';   //grid-template-rows: 13% 75% 8%;
        }
      } else {
        document.querySelector('.appstyle-right-panel').style.gridTemplateRows = '7% 84% 9%';
      }

      if (isRecognising) {
        if(isMobile){
          document.querySelector('.appstyle-footer').style.padding = '0px 15px 60px 0px';
        } else {
          document.querySelector('.appstyle-footer').style.padding = '10px 15px 10px 0';
        }
      } else {
        if(isMobile){
          document.querySelector('.appstyle-footer').style.padding = '0px 15px 50px 0px';
        } else {
          document.querySelector('.appstyle-footer').style.padding = '20px 15px 10px 0';
        }
      }
    }

    window.addEventListener('resize', handleResize);
    handleResize();

    //2024.06.04 在页面加载时检查 localStorage是否保存有上次没有更新到服务器的数据，若有，则更新服务器——防止用户关闭页面或者刷新页面时数据没有保存的情况出现
    const handleBeforeUnload = (event) => {
      let shouldPreventDefault = false;
      if((!userTokenExpired || isRecognisingTemp || isAIthinkingTemp || isOfflineTranscribingTemp) && isLoggedInTemp) {
        shouldPreventDefault = true;
      }
      let email = userDataLocalTemp.Email;
      if (shouldPreventDefault) {
        if (isRecognisingTemp || isAIthinkingTemp || (callGptByEntertemp && !isRecognisingTemp && !isAIthinkingTemp && inputValueTemp !== '')) {
          let combineText = inputValueTemp;
          // console.log('combineText is:', combineText);
          if (modeTitleTemp === 'Interview' && inputValueYouSay !== '') {
            combineText = combineTranscript(inputValue, inputValueYouSay);
          }
          
          let usageSum = 0;  //note: this is used to identify it is from batch transcription module or not, if it is, the usageSum will be set to > 0
          
          const end = new Date();
          let diff = 0;
          if (startTimeTemp) {
            diff = end - startTimeTemp; // 时间差（毫秒）
            diff = diff / 60000;
          }
          let usage = diff;
          if(usage < usageTimeOfCurrentTask/60) {
            usage = usageTimeOfCurrentTask/60;
          }
          if (tokensOFresponseFromAIWhenNotTranscribing > 0) {
            usage = usage + tokensOFresponseFromAIWhenNotTranscribing/1000;
          }

          usage = Math.round(usage * 100) / 100;
          usageSum = usage;

          let blobforsave = null;

          Mp3Recorder.stop().getMp3().then(async ([buffer, blob]) => {
            try {
              const db = await openDB();
              const transaction = db.transaction(['audioFiles'], 'readwrite');
              const store = transaction.objectStore('audioFiles');
              
              // 生成唯一ID
              const audioId = Date.now().toString();
              
              // 保存音频数据到 IndexedDB
              await store.put({
                id: audioId,
                blob: blob
              });
              
              // 保存元数据到 localStorage
              localStorage.setItem('unsavedData', JSON.stringify({
                audioId,
                combineText,
                usageSum,
                email,
                endTime: Date.now(),
                realtimeBoolValue: true
              }));
              
            } catch (error) {
              console.error('Error saving audio data:', error);
            }
          }).catch((e) => {
            console.error('Recording error:', e);
          });

          // return ''; // 这是为了兼容某些浏览器
        }
        if(taskIDOfOfflinetranscribe.length > 0) {
          // [{id: id, url: url, email: useremail, duration: duration, endTime: endTimeOfAudio, realtimeValue: realTimeFlag}, ...]; 

          const localStorageKey = 'unclosedOfflineTranscribeID';
          let existingData = localStorage.getItem(localStorageKey);

          if (existingData) {
            existingData = JSON.parse(existingData); // 将字符串解析为数组
          } else {
            existingData = [];
          }

          // 将新数据追加到现有数据中
          const updatedData = [...existingData, taskIDOfOfflinetranscribe];

          // 将合并后的数据存储回 localStorage
          localStorage.setItem(localStorageKey, JSON.stringify(updatedData));
        }

        if(dataSnapForCreateHistory.length > 0) {
          //[{ inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url },...];
          // const snapData = dataSnapForCreateHistory;
          // localStorage.setItem('unFinishedDataForCreateHistory', JSON.stringify({email, snapData})); 

          const localStorageKey = 'unFinishedDataForCreateHistory';
          let existingData = localStorage.getItem(localStorageKey);

          if (existingData) {
            const {email, snapData } = JSON.parse(existingData); // 将字符串解析为数组
            if(email !== userDataLocal?.Email) {
              existingData = [];
            } else {
              existingData = snapData;
            }
          } else {
            existingData = [];
          }

          // 将新数据追加到现有数据中
          const updatedData = [...existingData, dataSnapForCreateHistory];

          // 将合并后的数据存储回 localStorage
          localStorage.setItem(localStorageKey, JSON.stringify({email, snapData: updatedData}));
        }

        event.preventDefault();
        event.returnValue = ''; // 这是为了兼容某些浏览器
      }
      if (audioId) {
          axios.post('/api/delete-audio', {
          audioPath: `/audio/${audioId}.mp3`
        });
        setAudioId(null);
      }
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkTokenMain();
      }
    };
  
    window.addEventListener('beforeunload', handleBeforeUnload);

    document.addEventListener('visibilitychange', handleVisibilityChange);


    return () => {
    //   window.removeEventListener('beforeunload', logOut);
    //   logOut(); 
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('beforeunload', handleBeforeUnload);

      document.removeEventListener('visibilitychange', handleVisibilityChange);
    
      if (transcriber) {
        transcriber.stopTranscribingAsync();
        transcriber.close();
        setTranscriber(null);
      }
      if (recognizer) {
        recognizer.stopContinuousRecognitionAsync();
        recognizer.close();
        recognizer = null;
      }

      if(timerForRestartRecognizerRef){
        clearInterval(timerForRestartRecognizerRef.current);;
        timerForRestartRecognizerRef.current = null;
      }
    };
  }, []); 

  useEffect(() => {
    //|| userInfoAppPage?.History < 1
    if (!userInfoAppPage || userDataLocalRefreshCount <3) return;
    (async () => {
      let cloudTasks = [];
      try {
        cloudTasks = await fetchBatchQueue();
      } catch (err) {
        console.error("Failed to fetch batch queue:", err);
        return;
      }
      // 找到未完成的gpt批量任务
      const cloudTask = cloudTasks.find(t => t.status !== 'completed' && t.status !== 'failed' && t.batchId); //当GPT batch 启动失败，任务poll失败，以及二次create history(携带gpt result)失败状态下，不需要重启Batch任务，因为其实历史记录已新建，transcript也已完成,打开history页面即可自动完成失败的这几步
      const cloudTaskDone = cloudTasks.find(t => t.status === 'completed' && t.batchId);
      if (cloudTaskDone) deleteBatchQueue(cloudTaskDone.batchId, cloudTaskDone.gptBatchId);
      if (cloudTask) {
        // 直接调用批量处理主函数，传入 transcripts 和 batchId
        if(currentBatchTaskInfo.current && currentBatchTaskInfo.current.batchQueueId === cloudTask.batchId && (currentBatchTaskInfo.current.status === 'started' || currentBatchTaskInfo.current.status === 'completed')) {
          // 如果当前批量任务已经开始或完成，则不允许再次启动
          
          console.log('Batch task is already started or have been completed.');
        } else if (!batchStarted || !currentBatchTaskInfo.current) {
          console.log('Found unfinished batch task:', cloudTask.batchId, 'current time is:', new Date().toLocaleTimeString());
          setToastMessage('Restoring previous batch task, please wait...');
          setShowToast(true);
          startGPTBatch(cloudTask.transcripts, cloudTask.batchId, cloudTask?.status, cloudTask?.gptBatchId, cloudTask?.transcribeHistoryStatus, cloudTask?.gptResults);
        } else {
          console.log('Some batch task is already started, please wait.');
        }
      }
    })();
    // eslint-disable-next-line
  }, [userInfoAppPage]);

  // 创建 IndexedDB 数据库
  const openDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('AudioDB', 1);
      
      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
      
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('audioFiles')) {
          db.createObjectStore('audioFiles', { keyPath: 'id' });
        }
      };
    });
  };

  //2024.10.24

  useEffect(() => {
    isAIthinkingTemp = isAIthinking;
    console.log('isAIthinkingTemp is:', isAIthinkingTemp);
  }, [isAIthinking]);

  useEffect(() => {
    isOfflineTranscribingTemp = isOfflineTranscribing;
  }, [isOfflineTranscribing]);

  useEffect(() => {
    isLoggedInTemp = isLoggedIn;
  }, [isLoggedIn]);


  //2024.10.16 check the token
  const checkTokenMain = async () => {
    const token = localStorage.getItem('usertokenForCheck');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        // Check if the token has expired
        if (decoded.exp < currentTime) {
          userTokenExpired = true;      
          if(inputValue !== '' || isRecognising || isAIthinking || isOfflineTranscribing || showSTTPopup) { 
            console.error('Session expired. Refresh token as the some task still not done.');
            await refreshToken(); // 主动刷新令牌
          } else {
            console.error('Session expired. Need refresh current page.');
            window.location.reload(); 
          }
        } else {
          userTokenExpired = false;
          console.log('Token is valid. decoded.exp is:', decoded.exp, 'currentTime is:', new Date().toLocaleTimeString());
        }
      } catch (error) {
        userTokenExpired = true;
        console.error('Error decoding token:', error);
        window.location.reload(); 
      }
    } else {
      userTokenExpired = true;
      // No token found, redirect to login
      console.error('No token found. Need login.');
      window.location.reload(); 
    }
  };


  // useEffect(() => {
  //   console.log('isMobilephone is:', isMobilephone);
  // }, [isMobilephone]);

  // useEffect(() => {
  //   let timeoutRefOne = null;
  //   let timeoutRefTwo = null;
  //   timeoutRefOne = setTimeout(() => {
  //     if(isLoading) {
  //       setLoadingText('Network error. Please try again later.');
  //       timeoutRefTwo = setTimeout(() => {
  //         if(isLoading) {
  //           setIsLoading(false);
  //           handleLoginClick(); //5秒之后若还未登陆成功，则跳转到登录页面
  //           if(timeoutRefOne) {
  //             clearTimeout(timeoutRefOne);
  //           }
  //           if(timeoutRefTwo) {
  //             clearTimeout(timeoutRefTwo);
  //           }
  //         }
  //       } , 2000)
  //     }
  //   }, 10000)

  //   return () => {
  //     if(timeoutRefOne) {
  //       clearTimeout(timeoutRefOne);
  //     }
  //     if(timeoutRefTwo) {
  //       clearTimeout(timeoutRefTwo);
  //     }
  //   }
  // }, [isLoading]);

  useEffect(() => {
    let timeoutRef = null;
  
    if (isLoading) {
      // 设置10秒超时检测
      timeoutRef = setTimeout(() => {
        // 超时后提示网络错误，并取消加载状态
        setLoadingText('Network error. Please try again later.');
        setIsLoading(false);
        // handleLoginClick();
        // 此处不自动调用 handleLoginClick()，由用户手动重试
      }, 15000);
    }
  
    return () => {
      if (timeoutRef) {
        clearTimeout(timeoutRef);
      }
    };
  }, [isLoading]);


  useEffect(() => {
    const mouseMoveHandler = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    document.addEventListener('mousemove', mouseMoveHandler);
    if(!showSelectTextPopup || callGptByKeywords) {
      document.removeEventListener('mousemove', mouseMoveHandler);
    }
    return () => {
      document.removeEventListener('mousemove', mouseMoveHandler);
    }
  }, [selectedText]);

  useEffect(() => {
    if(askAll && selectedText !== '') {
      console.log('selectedText is:', selectedText);
      handleAskAI();
      askAll = false;
    }
  }, [selectedText, askAll]);

  useEffect(() => {
    if(!showSelectTextPopup && !callGptByKeywords) {
      setMouseDownLetInputValueSelectTextBeTop(false);
      setMouseDownLetInputValueYouSaySelectTextBeTop(false);
      setIsPaused(false);
    }else {
      //nothing
    }
  }, [showSelectTextPopup]);  // , showSelectTextIntervieweePopup] remember to add this when speaker identified funtion is added

  useEffect(() => {
    callGptByKeywordstemp = callGptByKeywords;
  }, [callGptByKeywords]);

  useEffect(() => {
    callGptByAItemp = callGptByAI;
  }, [callGptByAI]);

  useEffect(() => {
    startTimeTemp = startTime;
  }, [startTime]);

  useEffect(() => {
    callGptByEntertemp = callGptByEnter;
    setLastEnterIndex(0);

    //下面的代码确保在切换AI启动模式时能够及时保存用户未在转写模式下与AI交互产生的历史记录
    if(!callGptByEnter && !isInTranscribingProcess && inputValue !== '' && tokensOFresponseFromAIWhenNotTranscribing !== 0 && freshPageCount !== 0) {
      createHistoryRecord(inputValue, 1, Date.now(), false);
    }
  }, [callGptByEnter]);

  useEffect(() => {
    callGptBySelcttemp = callGptBySelct;
  }, [callGptBySelct]);

  useEffect(() => {
    if(openPricePopup) {
      let tipText = 'You need to upgrade to access this feature.';
      confirm(tipText);
    } else {
      setShowPricePopup(openPricePopup)
    }
  }, [openPricePopup]);

  useEffect(() => {
    // console.log('needLogin is:', needLogin, 'isLoggedIn is:', isLoggedIn)
    if(needLogin && !signInStatus && !isLoading) {
      setToastMessage('You need to login first.' );
      setShowToast(true);
      setNeedLogin(false);
    } 
  }, [needLogin, signInStatus, isLoading]);

  useEffect(() => {
    if(usageOverMaxset && !confirmDisplayed) {
      let tipText = (
        <>
          You have exceeded the maximum usage time.
          <br />
          Please upgrade your account.
        </>
      );
      confirmDisplayed = true;
      confirm(tipText);
    }
  }, [usageOverMaxset, usingTime]);

  useEffect(() => {
    if(needUpgradeUserLevel && !confirmDisplayed) {
      let tipText = 'You need to upgrade to access this feature.';
      confirmDisplayed = true;
      confirm(tipText);
      setNeedUpgradeUserLevel(false);
      // changeSelectOption('Transcribe');
    }
  }, [needUpgradeUserLevel]);

  useEffect(() => {
    let MAX_USAGE;
    if (userVipLevel === 0) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_FREE;
    } else if (userVipLevel === 1) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP1;
    } else if (userVipLevel === 2) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP2;
    }
    let useageTotal = 0;
    if(isRecognising && startTime ) {
      let usage = (Date.now() - startTime) / 60000;
      usage = Math.round(usage * 100) / 100;
      useageTotal = userDataLocal?.Usage?.time + usage;
    } else {
      if (userDataLocal !== null) useageTotal = userDataLocal?.Usage?.time || 0;
    }
    // console.log('useageTotal is:', useageTotal, 'MAX_USAGE is:', MAX_USAGE, 'isRecognising is:', isRecognising, 'startTime is:', startTime, 'userDataLocal is:', userDataLocal);
    if (useageTotal > MAX_USAGE) {
      if (isRecognising){
        setIsRecognising(false);
        setTimeout(() => {
          setStopBtnClicked(true);
          stopRecognizer();
          setStopRecordClicked(true);
          console.log('Usage time is over the limit. the useageTotal is:', useageTotal, 'MAX_USAGE is:', MAX_USAGE, 'setStopBtnClicked changed to true');
        },30);
      } 
      setUsageOverMaxset(true);
    } else {
      setUsageOverMaxset(false);
    }
  }, [usingTime]);

  useEffect(() => {
    // console.log('userDataLocal:', userDataLocal);
    if(userDataLocal && userDataLocal != null) {
      const userDataLocalSize = new Blob([JSON.stringify(userDataLocal)]).size;
      console.log("The size of userDataLocal:", userDataLocalSize, "bytes");
      userDataLocalTemp = userDataLocal;
      userDataLocalRefreshCount += 1;
      console.log('userDataLocalRefreshCount is:', userDataLocalRefreshCount);
    } 
    if(!userDataChangedAppPage && userDataLocal !== null && userDataLocal != 'null' && !vipLevelUpdatedConfirmed && !renewPaymentMethodConfirmed) {
      setLoadingText('Done');
      
      updateAILaunchMode();
      updateAIAnswerMode();
      updateNotificationSet();
      // checkTrancriptMode();
      
      setKeywordsFunc();
      setTimeout(() => {
        setIsLoading(false);
        setUserInfoAppPage(userDataLocal);
        // updateUserInformation();
        if (!needUpdateFromLocalStorageByAuth) updateFromLocalStorage(); 
      } , 600)
      // setToastMessage('Data updated successfully!' );
      // setShowToast(true);
    } else if(userDataLocal === 'null'){
      setToastMessage('Network error. Please try again later.' );
      setShowToast(true);
      setLoadingText('Network error. Please try again later.');
      setTimeout(() => {
        setIsLoading(false);
      } , 2000)
    }
    
  }, [userDataLocal, vipLevelUpdatedConfirmed, renewPaymentMethodConfirmed]);

  //check local storage for unsaved data - just check 2024.12.26
  const checkLocalStorage = async() => {
    let unsavedDataA = localStorage.getItem('unclosedOfflineTranscribeID');
    let unsavedDataB = localStorage.getItem('unFinishedDataForCreateHistory')
    let unsavedDataC = localStorage.getItem('unsavedData')
    let notFound = true;

    if(unsavedDataA === null && unsavedDataB === null && unsavedDataC === null) {
      setInRecoverUnsavedata(false);
      return true;
    } else {
      if (unsavedDataC) {
        const { email } = JSON.parse(unsavedDataC);
        if (email === userDataLocal?.Email) {
          notFound = false;
          return false;
        }
      }else if (unsavedDataB) {
        unsavedDataB = JSON.parse(unsavedDataB); // 将字符串解析为数组
        const { email, snapData } = JSON.parse(unsavedDataB);
        if (email === userDataLocal?.Email && snapData?.length > 0) {
          notFound = false;
          return false;
        }
      } else if (unsavedDataA) {
        unsavedDataA = JSON.parse(unsavedDataA); 
        for (const data of unsavedDataA) {
          const { email } = data;
          if (email === userDataLocal?.Email) {
            notFound = false;
            return false;
          }
        }
      }
      if(notFound) {
        setInRecoverUnsavedata(false);
        return true;
      }
    }
  }

  useEffect(() => {

    // console.log('updatedSuccessfully is:', updatedSuccessfully);
    // console.log('currentPageChangedSomething is:', currentPageChangedSomething);
    // console.log('showNotificationPopup is:', showNotificationPopup);
    // console.log('showSTTPopup is:', showSTTPopup);
    // console.log('confirmDisplayed is:', confirmDisplayed);
    // console.log('isRecognising is:', isRecognising);
    // console.log('isAIthinking is:', isAIthinking);
    // console.log('inRecoverUnsavedata is:', inRecoverUnsavedata);
    // console.log('sttPopupShowStatus is:', sttPopupShowStatus);

    if(updatedSuccessfully && !showSTTPopup && currentPageChangedSomething) {
      const recoverProcessDone = checkLocalStorage();
      //if(!confirmDisplayed && showNotificationPopup && !inRecoverUnsavedata && !isRecognising && !isAIthinking) {
      if(!confirmDisplayed && showNotificationPopup && recoverProcessDone && !isRecognising && !isAIthinking && (currentUpdateReason === 'mainPageTranscribe' || currentUpdateReason === 'sttTranscribe')) {
        let tipText = (
          <>
            Your conversation has been processed. Click OK to view it or Cancel to ignore it.
          </>);
        confirmDisplayed = true;
        gotoHistoryNotification(tipText);
        setUpdatedSuccessfully(false);
      }else if(!showNotificationPopup){
        setToastMessage('History updated successfully!' );
        setShowToast(true);
        setUpdatedSuccessfully(false);
      } 
      setCurrentPageChangedSomething(false);
    } else if(updatedSuccessfully && showSTTPopup && sttPopupShowStatus === 'min' && currentUpdateReason === 'sttTranscribe') {
      setToastMessage('The audio file you uploaded in Import popup has been processed.' );
      setShowToast(true);
      setShowSTTPopup(false);
      setUpdatedSuccessfully(false);
    } else if(updatedSuccessfully && !showSTTPopup && !currentPageChangedSomething ) {
      setToastMessage('Data updated successfully!' );
      setShowToast(true);
      setUpdatedSuccessfully(false);
    }
    if(updatedSuccessfully) {
      // console.log('updatedSuccessfully is:', updatedSuccessfully);
      // console.log('currentPageChangedSomething is:', currentPageChangedSomething);
      // console.log('showNotificationPopup is:', showNotificationPopup);
      // console.log('showSTTPopup is:', showSTTPopup);
      // console.log('confirmDisplayed is:', confirmDisplayed);
    }
  }, [updatedSuccessfully, currentUpdateReason]);

  // useEffect(() => {
  //   if(inputValue !== '' && isAIthinking) {
  //     let tipText = (
  //       <>
  //         Your conversation has been processed. Click OK to view it or Cancel to ignore it.
  //       </>);
  //     confirmDisplayed = true;
  //     gotoHistoryNotification(tipText);
  //   }
  // }, [inputValue, isAIthinking]);

  useEffect(() => {
    if(showHistoryVariable) {
      showHistory();
    }
  }, [showHistoryVariable]);

  const updateAILaunchMode = () => {
    const launchAIModeTitle = userDataLocal?.Ailaunchmode || 'Keywords';
    selectOrKeywordsLanuchAI(launchAIModeTitle)
    setNeedResetAilaunchmode(false);
    // console.log('launchAIMode is:', launchAIModeTitle);
  }

  const updateNotificationSet = () => {
    const notifyBoolValue = userDataLocal?.NotifyWhenUpdated || false;
    setShowNotificationPopup(notifyBoolValue);
  }

  // const checkTrancriptMode = () => {
  //   if(userDataLocal?.TranscriptionMode === 'Offline') {
  //     setCurrentTranscriptionMode('Offline')
  //   } else {
  //     setCurrentTranscriptionMode('Real-time')
  //   }
  // }

  //2024.07.25 VoiceIntercom in setting page
  const updateAIAnswerMode = () => {
    const answerAIModeTitle = userDataLocal?.AIResponseMode || 'Text';
    let mode = 'Transcribe';
    if(answerAIModeTitle === 'Text') {
      mode = 'Transcribe';
    } else if(answerAIModeTitle === 'Voice') {
      mode = 'VoiceIntercom';
    }

    if(userDataLocal?.TranscriptionMode === 'Offline') {
      mode = 'Offline';
    }

    setInterfaceContentByModeChanged(mode);
    setNeedResetGPTPrompt(true);
  }

  // 在页面加载时检查 localStorage 2024.06.04
  const updateFromLocalStorage = async() => {
    const resumeCreateNoteFirst = await resumeCreateNote();
    if(!resumeCreateNoteFirst) {
      const resumeOfflineTaskSecond = await resumeOfflineTranscribe();
      if(!resumeOfflineTaskSecond) {
        recoverUnsavedData();
      }
    }
  }

  const recoverUnsavedData = async () => {
    try {
      const unsavedData = localStorage.getItem('unsavedData');
      if (!unsavedData) return;
      
      if (unsavedData) {
        const { audioId, combineText, email, endTime, realtimeBoolValue, noteIDnum, usageSum } = JSON.parse(unsavedData);
        if (!audioId) {
          // 无效的 ID，直接清掉
          localStorage.removeItem('unsavedData');
          return;
        }
        
        // 检查邮箱是否匹配
        if (email !== userDataLocal?.Email) {
          return;
        }
  
        // 从 IndexedDB 获取音频数据
        const db = await openDB();
        const tx = db.transaction(['audioFiles'], 'readonly');
        const store = tx.objectStore('audioFiles');
        const audioData = await store.get(audioId);
        if (!audioData?.blob) {
          // 存储里没有，清掉
          localStorage.removeItem('unsavedData');
          return;
        }
  
        if (audioData?.blob) {
          // 恢复状态
          if (endTime) {
            setEndTimeOfAudio(endTime);
          }
          setCurrentRealtimeBoolValue(realtimeBoolValue);
          setInRecoverUnsavedata(true);
          
          // 设置音频数据
          setTimeout(() => {
            // setAudioBlob(audioData.blob);
            if(audioOfflineTranscriptionRef.current) {
              audioOfflineTranscriptionRef.current.processAudio(audioData.blob, combineText, noteIDnum);
              console.log('Recovering unsaved data: audioId:', audioId, 'combineText:', combineText, 'noteIDnum:', noteIDnum);
              // 清理存储的数据
              localStorage.removeItem('unsavedData');
              store.delete(audioId);
            }
          }, 50);
        }
      }
    } catch (error) {
      console.error('Error recovering unsaved data:', error);
    }
  };

  const resumeOfflineTranscribe = async() => {
    let unsavedData = localStorage.getItem('unclosedOfflineTranscribeID');
    if (unsavedData) {
      unsavedData = JSON.parse(unsavedData); // 将字符串解析为数组
      let remainingData = unsavedData;
  
      for (const data of unsavedData) {
        const { id, url, email, duration, endTime, realtimeValue, videoURL, videoID, title, noteIDnum } = data;
        if (email === userDataLocal?.Email) {
          if (endTime) {
            setEndTimeOfAudio(endTime);
          }
          setCurrentRealtimeBoolValue(realtimeValue);
          setInRecoverUnsavedata(true);
          await new Promise((resolve) => {
            setTimeout(() => {
              console.log('Resume offline transcription: check transcribe ID:', id);
              audioOfflineTranscriptionRef.current.resumeCheckTranscribeID(url, id, duration, endTime, realtimeValue, videoURL, videoID, title, noteIDnum);
              resolve();
            }, 100);
          });
  
          // 移除已处理的元素
          remainingData = remainingData.filter(item => item.id !== id);
        } else {
          //
        }
      }
  
      // 全部完成后清空本地存储
      // setInRecoverUnsavedata(false);
      if(remainingData.length === 0) {
        localStorage.removeItem('unclosedOfflineTranscribeID');
        return false;
      } else {
        localStorage.setItem('unclosedOfflineTranscribeID', JSON.stringify(remainingData));
        return true;
      }
      
    } else {
      return false;
    }
  }

  const resumeCreateNote = async() => {
    let unsavedData = localStorage.getItem('unFinishedDataForCreateHistory');
    if (unsavedData) {
      unsavedData = JSON.parse(unsavedData); // 将字符串解析为数组
      const { email, snapData } = JSON.parse(unsavedData);
      let remainingData = snapData;
      let notFound = true;
  
      for (const data of snapData) {
        const { inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url, noteIDnum } = data;
        if (email === userDataLocal?.Email) {
          setInRecoverUnsavedata(true);
          notFound = false;
          await new Promise((resolve) => {
            setTimeout(() => {
              console.log('Resume create history: transcribe ID:', transcribeID);
              createHistoryRecord(inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url, noteIDnum);
              resolve();
            }, 100);
          });
          // 移除已处理的元素
          remainingData = remainingData.filter(item => item.transcribeID !== transcribeID);
        }
      }
  
      // 全部完成后清空本地存储
      // setInRecoverUnsavedata(false);
      if(remainingData.length === 0) {
        localStorage.removeItem('unFinishedDataForCreateHistory');
        return false;
      } else {
        localStorage.setItem('unFinishedDataForCreateHistory', JSON.stringify(remainingData));
        return true;
      }
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (dataSnapForCreateHistory.length > 0) {
      //[{ inputValue, usageSum, endTime,
      //   realtimeBoolValue, transcribeID, url }]
      // const { inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url } = dataSnapForCreateHistory[0];
      // console.log('dataSnapForCreateHistory is:', dataSnapForCreateHistory);
    }
  }, [dataSnapForCreateHistory]);

  useEffect(() => {
    if(isLoading && errorInfo !== null){
      setLoadingText('Network error. Please try again later.');
        setTimeout(() => {
          setIsLoading(false);
        } , 2000)
    }
  }, [errorInfo]);

  useEffect(() => {
    if(!needUpdate && freshPageCount !== 0){
      setLoadingText('Done');
      setTimeout(() => {
        setUserDataChangedAppPage(false);
        setIsLoading(false);
        if (userDataLocal!==null) {
          setUserInfoAppPage(userDataLocal);
          // updateUserInformation();
        }
      } , 600)
    }
  }, [needUpdate]);
  
  useEffect(() => {
    if(purchaseBtnClicked) {
      let tipText = (
        <>
          Please confirm the payment result.
        </>
      );

      if(userDataLocal?.VIPLevel > 0) {
        tipText = (
          <>
            Please confirm the payment update result.
          </>
        );
      }
      
      if(!confirmDisplayed) {
        confirmDisplayed = true;
        setPurchaseBtnClicked(false);
        confirmpayment(tipText);
        // toast.current.show({ severity: 'Congratulations!', summary: 'OK', detail: ` Successfully upgraded to ${levelTxt}!`, life: 3000 });
      }
    }
  }, [purchaseBtnClicked]);

  useEffect(() => {
    if(vipLevelUpdatedConfirmed) {
      let levelTxt = 'FREE';
      if(userDataLocal?.VIPLevel > 0) {
        levelTxt = 'VIP';
      } 
      // else if(userDataLocal?.VIPLevel === 2) {
      //   levelTxt = 'Business';
      // }
      // if(!confirmDisplayed) {
        // toast.current.show({ severity: 'Congratulations!', summary: 'OK', detail: `Successfully upgraded to ${levelTxt}!`, life: 3000 });
        setLoadingText(`Congratulations! Successfully upgraded to ${levelTxt}!`);
        setTimeout(() => {
          setIsLoading(false);
        } , 2000)
      // }
      setVipLevelUpdatedConfirmed(false);
      setShowCongratulationsPopup(true);
    }
  }, [vipLevelUpdatedConfirmed]);

  useEffect(() => {
    if(renewPaymentMethodConfirmed) {
      setToastMessage('Payment method updated successfully.' );
      setShowToast(true);
      setRenewPaymentMethodConfirmed(false);
    }
  }, [renewPaymentMethodConfirmed]);

  //app page user data changed call back
  useEffect(() => {
    if(userDataChangedAppPage){
      setCurrentPageChangedSomething(true);
      setNeedUpdate(true);
    }
  }, [userDataChangedAppPage]);
  
  useEffect(() => {
    
    // console.log("stopBtnClicked is:", stopBtnClicked? 'true':'false')

    if(modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') {
      if(stopBtnClicked) {
        // stopAudio(handleAudioPlayEndChange);
        // stopIntercom();  //2025.05.10
        setIsAIthinking(false);
        setIsRecognising(false);
        setTimeout(() => {
          stopSession();
        }, 100);
        handleSkipPlayingAudio();
        if(!isRecognising && inputValue !== '') {
          let usageSum = 0;  //note: this is used to identify it is from batch transcription module or not, if it is, the usageSum will be set to > 0
          // createHistoryRecord(inputValue, usageSum, Date.now(), true);
        }
      }
    } else {
      if (stopBtnClicked && !isRecognising && inputValue !== '' && userDataLocal?.TranscriptionMode !== 'Offline') {
        let combineText = inputValue;
        if (modeTitle === 'Interview' && inputValueYouSay !== '') {
          combineText = combineTranscript(inputValue, inputValueYouSay);
        }
        let usageSum = 0;  //note: this is used to identify it is from batch transcription module or not, if it is, the usageSum will be set to > 0
        // createHistoryRecord(combineText, usageSum, Date.now(), true);
      }
    }
  }, [stopBtnClicked]);

  // useEffect(() => {
  //   var loginSuccess = localStorage.getItem('loginSuccess');
  //   var usr = localStorage.getItem('usr');  
  //   if (loginSuccess && !userInfoAppPage) {
  //     console.log('登录成功！');

  //   }
  // }, [query]);

  useEffect(() => {
    if (startRecordClicked) {
      startRecorder();
      // 根据需要重置autoStart状态
      setStartRecordClicked(false);
      if(userDataLocal?.VIPLevel > 0) {;
        freeORVIPBigestRecordTime = 720 * 60000; //120分钟 6小时  2024.11.28 Vip用户最大录音时间 Free用户最大录音时间为1分钟
      }

      if(userDataLocal?.TranscriptionMode !== 'Offline') {
        // const autoStopTime = userDataLocal?.AutoStopTime || 300000;
        // let intervalTime = fetchUserIntervalTime();
        // soundCheckInterval = setInterval(checkSoundInput, intervalTime);   //1分钟内无音频输入则自动关闭识别

        freeORVIPTimeInterval = setInterval(() => {
          if (isRecognising) {
            let diff = Date.now() - startTime;
            let diffInMinutes = Math.round(diff / 60000);
            if (diffInMinutes >= freeORVIPBigestRecordTime) {
              startStopRecordingRef.current.click();
              console.log('freeORVIPBigestRecordTime minutes recording time is over. Please start again.');
              setToastMessage('' + freeORVIPBigestRecordTime + ' minutes recording time is over. Please start again.' );
              setShowToast(true);
            }
          }
        }, freeORVIPBigestRecordTime);
      }
      
    }
  }, [startRecordClicked]);

  // useEffect(() => {
  //   if(isRecognising) {
  //     if(userDataLocal?.TranscriptionMode !== 'Offline') {
  //       let intervalTime = fetchUserIntervalTime();
  //       // soundCheckInterval = setInterval(checkSoundInput, intervalTime);   //1分钟内无音频输入则自动关闭识别

  //       soundCheckInterval = setInterval(() => {
  //         if (!audioDetected) {
  //           console.log('Audio detected is negative, stopping transcription.');
  //           // checkSoundInput();
  //           startStopRecordingRef.current.click();
  //           clearInterval(soundCheckInterval);
  //         } else {
  //           console.log('Audio detected is positive.');
  //           if(soundCheckInterval) clearInterval(soundCheckInterval);
  //         }
  //       }, intervalTime);
  //     }
  //   } else if(!isRecognising) {
  //     if(soundCheckInterval) clearInterval(soundCheckInterval);
  //     setAudioDetected(false);
  //   }
  //   return () => {
  //     if(soundCheckInterval) clearInterval(soundCheckInterval);
  //     // setAudioDetected(false);
  //   }
  // }, [isRecognising, audioDetected]);

  const fetchUserIntervalTime = () => {
    const autoStopTime = userDataLocal?.AutoStopTime || 300000;  //默认5分钟
    const intervalTime = parseInt(autoStopTime, 10);
    return intervalTime;
  }

  useEffect(() => {
    if (stopRecordClicked) {
      stopRecorder();
      // 根据需要重置autoStart状态
      setStopRecordClicked(false);

      if(userDataLocal?.TranscriptionMode !== 'Offline') {
        clearInterval(soundCheckInterval);
        clearInterval(freeORVIPTimeInterval);
      }
    }
  }, [stopRecordClicked]);

  useEffect(() => {
    if (saveRecordClicked) {
      saveRecorder();
      // 根据需要重置autoStart状态
      setSaveRecordClicked(false);
    }
  }, [saveRecordClicked]);

  // useEffect(() => {
  //   if((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && responseFromAI !=='') {
  //     setNvoiceThinkingStatusText('Nvoice is speaking');
  //     handleAutoPlayAudio(responseFromAI);
  //   } else if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && responseFromAI ==='' && audioPlayEnd){
  //     setIsAIthinking(false);
  //     setNeedResetGPTPrompt(false);
  //     if((!isRecognising)&&(!stopBtnClicked)) {
  //       startRecognizer()
  //     }
  //   }
  // }, [responseFromAI]);

   useEffect(() => {
    if((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && audioUrl) {
      setNvoiceThinkingStatusText('Nvoice is speaking');
      if (audioUrl && audioRef.current) {
        setAudioPlayEnd(false);
        audioRef.current.play();
      }
      // handleAutoPlayAudio(responseFromAI);
    } else if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && !audioUrl && audioPlayEnd){
      setIsAIthinking(false);
      setNeedResetGPTPrompt(false);
      // if((!isAIthinking)&&(!stopBtnClicked)) {
      //   startRecognizer()
      // }
      if (audioId) {
          axios.post('/api/delete-audio', {
          audioPath: `/audio/${audioId}.mp3`
        });
        setAudioId(null);
      }
    }
  }, [audioUrl]);

  // useEffect(() => {
  //   if(audioPlayEnd) {
  //     setResponseFromAI('');
  //   }
  // }, [audioPlayEnd]);
  useEffect(() => {
    if(audioPlayEnd) {
      setAudioUrl(null);
      if (audioRef.current) {
        audioRef.current.pause();
      }
    }
  }, [audioPlayEnd]);

  useEffect(() => {
    if( noteIDOfCloudAudio !== ''){
      if (audioNameForOfflineTrancription !== '') {
        handleRenameUploadedAudioFile(audioNameForOfflineTrancription, noteIDOfCloudAudio);
        // setCloudAudioName(audioNameForOfflineTrancription);
      } else if (audioNameForOfflineTrancription === '' && audioBlob) {
        const file = new File([audioBlob], noteIDOfCloudAudio + '.mp3', { type: audioBlob.type });
        handleUploadAudioblobToCloud(file);
      } 
    }
  }, [noteIDOfCloudAudio]);

  const handleUploadAudioblobToCloud = async (waveBuffer) => {
    const formData = new FormData();
    const fileformat = userDataLocal?.AudioSet;
    const fileName = user.uid + '-_-' + noteIDOfCloudAudio + '.' + fileformat; // 指定文件名
    formData.append('audio', waveBuffer, fileName);
    

    // console.log('formData.name is:', formData.get('audio').name);
    // console.log('fileName is:', fileName);
    try {
      const response = await axios.post('/api/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        // onUploadProgress: (progressEvent) => {
        //   const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        //   setProgressOfUpload(progress);
        // },
      });
      // setUrl(response.data.url);
      setNoteIDOfCloudAudio('');
      // return response.data.url;
    } catch (error) {
      console.error(error);
      setNoteIDOfCloudAudio('');
    }
  };

  const handleRenameUploadedAudioFile = async (audioFileName, newNameWithNoteID) => {
    if (!audioFileName) {
      console.error('Fiel not exist.');
      return;
    }

    const filename = audioFileName;
    const newFilename = newNameWithNoteID;
    const userid = user.uid;

    try {
      const response = await axios.put(`/api/upload/rename/${userid}/${filename}`, {
        newFilename
      });
      // console.log ('Delete uploaded audio file successfully!', response.data.message);
      // setUrl(null);
      setAudioNameForOfflineTrancription('');
      setNoteIDOfCloudAudio('');
      // console.log(response.data.message);
      // console.log(response.data.newFilename); //newFilename+extension
      return response.data.url;
    } catch (error) {
      console.error(error);
      return null;
    }
  };



  useEffect(() => {
    if (userInfoAppPage) {
      resetUserInfo();
      if(!isRecognising) {
        freshPageCount = 0;
        setStopBtnClicked(false);
        // setTimeout(() => {
          setUserInforChangedByUserDataLocal(!userInforChangedByUserDataLocal);
        // }, 10);
      }
      switch (userVipLevel) {
        case 0:
          setAvatarNow(avatar)
          break;
        case 1:
          setAvatarNow(vip1)
          break;
        case 2:
          setAvatarNow(vip1)
          break;
        case 3:
          setAvatarNow(vip1)
          break;
        default:
          setAvatarNow(avatar)
      }
      if (signInStatus) {
        setIsLoggedIn(true)
      } else {
        setIsLoggedIn(false)
      }
      
    } else {
      setAvatarNow(avatar)
      setIsLoggedIn(false)
    }

  }, [userInfoAppPage]);

  

  // const updateUserInformation = () => {
  //   if(!isRecognising && !isAIthinking) {
  //     if (userDataLocal!==null) {
  //         textValueTempFlag = true;
  //         inputValueTemp = inputValue;
  //         inputValueYouSayTemp = inputValueYouSay;
  //         responseTextTemp = responseText;
  //       setTimeout(() => {
  //         setInputValue('');
  //         setInputValueYouSay('');
  //         setResponseText('');
  //       }, 100);
  //     }
  //   }
  // }

  const setKeywordsFunc = () => {
    // console.log("userDataLocal is:", userDataLocal)
    
    let keywords = GPT_PRE_KEYWORDS[userDataLocal?.Language?.code||'en-US'];
    let keywordsTwo = GPT_KEYWORDS[userDataLocal?.Language?.code||'en-US'];
    // console.log("userDataLocal?.Language.code:", userDataLocal?.Language.code);
    if (!keywords || keywords?.length < 1){
      keywords = ['?'];
    }
    if (!keywordsTwo || keywordsTwo?.length < 1){
      keywordsTwo = ['?'];
    }
    let newKeywords = [];
    if (userDataLocal?.Keywords?.length===0 || (userDataLocal?.Keywords?.length===1 && userDataLocal?.Keywords[0]===''))
    {
      
    } else {
      newKeywords = userDataLocal?.Keywords || [];
      keywords.push(...newKeywords); // 将用户自定义的关键词数组添加到预检查关键词数组中 
      // 使用 Set 去除重复元素
      keywords = [...new Set(keywords)];
      // keywords = newKeywords; // 2024.11.7 若用户自定义了关键词，则使用用户自定义的关键词启动AI；否则使用默认关键词启动AI
      // keywordsTwo.push(...newKeywords); 
      keywordsTwo = newKeywords; // 2024.10.12 若用户自定义了关键词，则使用用户自定义的关键词启动AI；否则使用默认关键词启动AI
      keywordsTwo = [...new Set(keywordsTwo)];
    } 
    if(userDataLocal?.Email === 'lqzai5@126.com') {
      setKeywordsPreCallGpt(newKeywords);
      setKeywordsCallGpt(newKeywords);
    } else {
      // console.log("pre-keywords is:", keywords);
      // console.log("keywordsTwo is:", keywordsTwo);
      setKeywordsPreCallGpt(keywords);
      setKeywordsCallGpt(keywordsTwo);
    }
    
    // console.log("pre-keywords is:", keywords);
    // console.log("keywordsTwo is:", keywordsTwo);
  }



  useEffect(() => {
    //2024.08.31 format text display in text area
    const textOfRecognized = formatAndDisplayText(recognisedText);
    const textOfRecognising = formatAndDisplayText(recognisingText);

    if(currentSpeaker !== 'Candidate' && !mouseDownLetInputValueSelectTextBeTop  && !userTypingText) {
      setInputValue(`${textOfRecognized}${recognisingText}`);
      // console.log('textOfRecognized is:', textOfRecognized, 'recognisingText is:', recognisingText, 'current time is:', new Date().toLocaleTimeString());
      setEnterText(`${textOfRecognized}${recognisingText}`);
    } else if (userTypingText){
      userTypingText = false;
    }
    recognisedTextTemp = textOfRecognized;
    recognisingTextTemp = textOfRecognising;
  }, [recognisedText, recognisingText]);

  useEffect(() => {
    //2024.08.31 format text display in text area
    const textOfRecognizedYouSay = formatAndDisplayText(recognisedTextYouSay);
    if(currentSpeaker === 'Candidate' && !mouseDownLetInputValueYouSaySelectTextBeTop && !userTypingTextYouSay) {
      setInputValueYouSay(`${textOfRecognizedYouSay}${recognisingTextYouSay}`);
    } else if (userTypingTextYouSay){
      userTypingTextYouSay = false;
    }
  }, [recognisedTextYouSay, recognisingTextYouSay]);

  //  function formatAndDisplayText(polishedText) {
  //    return polishedText.replace(/([.!?;。！？；"])\s*/g, '$1\n').trim();
  //  }

   function formatAndDisplayText(polishedText) {
    return polishedText.replace(/([.!?;。！？；"])\s*/g, (match, p1, offset, string) => {
      // 检查是否为小数点
      if (p1 === '.' && /\d\.\d/.test(string.slice(offset - 1, offset + 2))) {
        return match; // 如果是小数点，不进行替换
      }
      return `${p1}\n`; // 否则，替换为标点符号加换行
    }).trim();
  }


  useEffect(() => {

    if(userTypingText) {
      
      setRecognisedText(inputValue)
      
    }else if(userTypingTextYouSay) {
      // userTypingTextYouSay = false
      // userTypingText = false
      setRecognisedTextYouSay(inputValueYouSay)
      
    }
    inputValueTemp = inputValue;
    lastChangeTimeRef.current = Date.now();
    // console.log('inputValue is:', inputValue, 'inputValueTemp is:', inputValueTemp, 'current time is:', new Date().toLocaleTimeString());
  }, [inputValue, inputValueYouSay]);

  useEffect(() => {
    modeTitleTemp = modeTitle;
    if(userDataLocal && userDataLocal !== null) {
      setCurrentPresetTitle(userDataLocal?.PreSet?.defaultSetName || 'Transcribe');
      // console.log('userDataLocal?.PreSet.defaultSetName is:', userDataLocal?.PreSet.defaultSetName);
    }
  }, [modeTitle, userDataLocal]);

  //__________________________________________________________________________________________________________________
  //2024.06.26 Launch AI mode 
  useEffect(() => {
    if(needResetAilaunchmode) {
      updateAILaunchMode()
    }
  }, [needResetAilaunchmode]);

  //__________________________________________________________________________________________________________________
  //2024.07.31 TranscriptionMode Offline
  useEffect(() => {

    if(audioBlob && !inRecoverUnsavedata && userDataLocal?.TranscriptionMode !== 'Offline'){
      setCurrentRealtimeBoolValue(true);
    } else if(audioBlob && !inRecoverUnsavedata && userDataLocal?.TranscriptionMode === 'Offline') {
      setCurrentRealtimeBoolValue(false);
    }

    if(audioBlob && enableExportAudio && !isRecognising && userDataLocal?.TranscriptionMode !== 'Offline' && inputValue !== '') {
      if(!confirmDisplayed && !showNotificationPopup) {
        let tipText = (
          <>
            Your conversation is being processed. Do you want to set a reminder when the process is complete?
          </>
        );
        confirmDisplayed = true;
        confirmNotification(tipText);
      } 
    } else if(audioBlob && enableExportAudio && !isRecognising && userDataLocal?.TranscriptionMode === 'Offline' ){
      if(!confirmDisplayed && !showNotificationPopup) {
        let tipText = (
          <>
            Your conversation is being processed. Do you want to set a reminder when the process is complete?
          </>
        );
        confirmDisplayed = true;
        confirmNotification(tipText);
      } 
    }

    if(audioBlob) {
      console.log('enableExportAudio is:', enableExportAudio, 
        'isRecognising is:', isRecognising, 
        'userDataLocal?.TranscriptionMode is:', userDataLocal?.TranscriptionMode, 
        'inRecoverUnsavedata is:', inRecoverUnsavedata,
        'isAIthinking is:', isAIthinking, 
        'audioOfflineTranscriptionRef.current is:', audioOfflineTranscriptionRef.current)
    }

    // if(audioBlob && userDataLocal?.TranscriptionMode === 'Offline' && enableExportAudio && !isRecognising && !isAIthinking) {
    if(isNetWorkConnected) {
      if(audioBlob && enableExportAudio && !isRecognising && !isAIthinking && !inRecoverUnsavedata && audioOfflineTranscriptionRef.current && inputValueTemp !== '') { 
        // 实时转写模式下，用户点击停止按钮后，将音频文件传递给离线转写模块
        if (audioOfflineTranscriptionRef.current) {
          // let downloadFileName = 'audio.wav';
          // if (userDataLocal?.AudioSet === 'mp3') {
          //   downloadFileName = 'audio.mp3';
          // }
          if(timerForRestartRecognizerRef){
            clearInterval(timerForRestartRecognizerRef.current);;
            timerForRestartRecognizerRef.current = null;
          }

          setTimeout(() => {
            const file = new File([audioBlob], 'audio.mp3', { type: audioBlob.type });
            // saveRecorder();
            audioOfflineTranscriptionRef.current.processAudio(file, inputValue || inputValueTemp);
            console.log('Start batch transcribe task, inputValue is:', inputValue);
          }, 100);
        } 
      //  setAudioBlob(null); 
      } 
    } else {
      // 网络未连接时，将音频文件保存到本地存储
      handleSaveDataLocally();
      // alert ('Network is not connected. Please check your network connection.' );
      handleLoginClick();
    }
  }, [audioBlob, enableExportAudio]);

  const handleSaveDataLocally = async (file, inputValue, noteIDnum) => {
    try {
      const email = userDataLocal?.Email;
      const modeOftrancribe = (userDataLocal?.TranscriptionMode === 'Offline') ? true : false;
      const blobforsave = file || audioBlob;
      
      // 生成唯一ID
      const audioId = Date.now().toString();
      
      // 保存音频数据到 IndexedDB
      const db = await openDB();
      const transaction = db.transaction(['audioFiles'], 'readwrite');
      const store = transaction.objectStore('audioFiles');
      
      await store.put({
        id: audioId,
        blob: blobforsave
      });

      let combineText = inputValue || inputValueTemp;
      // console.log('combineText is:', combineText);
      if (modeTitleTemp === 'Interview' && inputValueYouSay !== '') {
        combineText = combineTranscript(inputValue || inputValueTemp, inputValueYouSay);
      }
      
      let usageSum = 0; //note: this is used to identify it is from batch transcription module or not, if it is, the usageSum will be set to > 0
      const end = new Date();
      let diff = 0;
      if (startTimeTemp) {
        diff = end - startTimeTemp; // 时间差（毫秒）
        diff = diff / 60000;
      }
      let usage = diff;
      if(usage < usageTimeOfCurrentTask/60) {
        usage = usageTimeOfCurrentTask/60;
      }
      if (tokensOFresponseFromAIWhenNotTranscribing > 0) {
        usage = usage + tokensOFresponseFromAIWhenNotTranscribing/1000;
      }

      usage = Math.round(usage * 100) / 100;
      usageSum = usage;
      
      // 只在 localStorage 中保存元数据
      localStorage.setItem('unsavedData', JSON.stringify({ 
        audioId,
        combineText,
        usageSum,
        email, 
        endTime: Date.now(), 
        realtimeBoolValue: modeOftrancribe,
        noteIDnum
      }));
      
    } catch (error) {
      console.error('Error saving local data:', error);
      throw error;
    }
  };

  //2024.07.31 hook for react-audio-voice-recorder
  // useEffect(() => {
  //   if (!recordingBlob) return;
  //   setAudioBlob(recordingBlob);
  //   // recordingBlob will be present at this point after 'stopRecording' has been called
  // }, [recordingBlob])
  // //__________________________________________________________________________________________________________________

  // // 当textRef更新时，滚动到底部
  // useEffect(() => {
  //   if (textRef.current) {
  //     const element = textRef.current
  //     element.scrollTop = element.scrollHeight
  //   }
  // }, [textRef])

  // // 当responseText更新时，滚动到底部
  useEffect(() => {
    if (responseTextRef.current) {
      const element = responseTextRef.current
      element.scrollTop = element.scrollHeight
    }
  }, [responseText])

  //  // 当responseText更新时，滚动到底部
  //  useEffect(() => {
  //   if (textRefYouSay.current) {
  //     const element = textRefYouSay.current
  //     element.scrollTop = element.scrollHeight
  //   }
  // }, [textRefYouSay])
  
  const toggleListener = () => {
    if (!isLoggedIn) {
      setNeedLogin(true);
      window.location.href = '/login';
      } else {
        if (checkAndUpdateTimeUsage()) {
          if(userDataLocal?.TranscriptionMode !== 'Offline'){
            if (!isRecognising) {
              //下面的代码确保在切换AI启动模式时能够及时保存用户未在转写模式下与AI交互产生的历史记录
              if (callGptByEnter && !isInTranscribingProcess && inputValue !== '' && tokensOFresponseFromAIWhenNotTranscribing !== 0){
                createHistoryRecord(inputValue, 1, Date.now(), false);
              }

              isInTranscribingProcess = true;
              startBtnManualClicked = true;
              setStartTime(new Date());
              setIsAIthinking(false);
              setStopBtnClicked(false);
              // console.log('stopBtnClicked changed to false'); 
              if(freshPageCount === 0){
                freshPageCount++
              }
              clearInterfaceContent();
              // setRecognisedText("")
              // setRecognisedTextYouSay("")
              // setInputValue('');
              // setInputValueYouSay('');
              // setResponseText('');

              setStartRecordClicked(true)
              // setTimeout(() => {
                startRecognizer()
              // }, 100)
              launchLimitTimerForRecognizer();
              setCurrentUpdateReason('mainPageTranscribe');
              requestWakeLock(); // 请求屏幕常亮
              // setIsInTranscribingProcess(true);
            } else {
              cancelLimitTimerForRecognizer();
              isInTranscribingProcess = false;
              setStopBtnClicked(true)
              // console.log('stopBtnClicked changed to true');
              stopRecognizer()
              setStopRecordClicked(true)
              // setIsInTranscribingProcess(false);
              releaseWakeLock(); // 释放屏幕常亮
            }
          } else {
            cancelLimitTimerForRecognizer();
            if(!isRecognising) {
              setStartRecordClicked(true);
              clearInterfaceContent();
            } else {
              setStopRecordClicked(true);
              releaseWakeLock(); // 释放屏幕常亮
            }
            setIsRecognising(!isRecognising);
          }
        } else {
          if(isRecognising) {
            isInTranscribingProcess = false;
            cancelLimitTimerForRecognizer();
            setStopBtnClicked(true);
            stopRecognizer();
            setStopRecordClicked(true);
            releaseWakeLock(); // 释放屏幕常亮
          }
        }
      }
  }

  const clearInterfaceContent = () => {
    setRecognisedText("")
    setRecognisedTextYouSay("")
    setInputValue('');
    setInputValueYouSay('');
    setResponseText('');
    setRecognisingText('');
    setRecognisingTextYouSay('');
    setAiChatMessages([]);
    // setAudioBlob(null);
    // setAudioUrl(null);
    // setAudioPlayEnd(true);
    // setAudioId(null);
  }

  // useEffect(() => {
  //   // let timer; 
  //   if(isRecognising) {
  //     if(userDataLocal?.TranscriptionMode !== 'Offline'){
  //         let intervalTime = fetchUserIntervalTime();
  //         soundCheckInterval = setInterval(() => {
  //           const netStatus = checkNetwork();
  //           if (previousInputValueTemp === inputValueTemp || netStatus === false) {
  //             if(previousInputValueTemp === inputValueTemp) {
  //               console.log(`Content has not changed in "${intervalTime/1000}" seconds, transcribing process will te terminated, current time is: ${new Date().toLocaleTimeString()}`);
  //             } else {
  //               console.log(`Network is not connected, transcribing process will te terminated, current time is: ${new Date().toLocaleTimeString()}`);
  //             }
  //             // printSoundCheckInterval();
  //             startStopRecordingRef.current.click();
  //             clearInterval(soundCheckInterval); // 停止计时器
  //           } else {
  //             // console.log('Content has changed, current time is:', new Date().toLocaleTimeString());
  //             previousInputValueTemp = inputValueTemp;
  //           }
  //         }, intervalTime); // 每隔 intervalTime 毫秒检测一次
  //       }
  //     // } 
  //   } else {
  //     if (soundCheckInterval) clearInterval(soundCheckInterval);
  //   }

  //   return () => clearInterval(soundCheckInterval); // 清理定时器
  // }, [isRecognising]);

  useEffect(() => {
    // 如果正在识别并且模式不是 Offline
    if (isRecognising && userDataLocal?.TranscriptionMode !== 'Offline') {
      const intervalTime = fetchUserIntervalTime(); // 返回值单位是毫秒
      
      // 设置定时器，每隔 intervalTime 毫秒检测一次
      soundCheckIntervalRef.current = setInterval(() => {
        const netStatus = checkNetwork();
        const timeSinceLastChange = Date.now() - lastChangeTimeRef.current;
        
        if (!netStatus || timeSinceLastChange >= intervalTime) {
          if (timeSinceLastChange >= intervalTime) {
            console.log(`Content has not changed for ${intervalTime / 1000} seconds. Terminating transcription at ${new Date().toLocaleTimeString()}`);
          } else {
            console.log(`Network disconnected. Terminating transcription at ${new Date().toLocaleTimeString()}`);
          }
          // 执行停止录音操作
          startStopRecordingRef.current.click();
          clearInterval(soundCheckIntervalRef.current);
        } else {
          // 内容有变化时，可以打印调试信息
          // console.log(`Content changed recently, time since last change: ${timeSinceLastChange}ms`);
        }
      }, intervalTime);
    } else {
      // 如果不在识别状态，清除定时器
      if (soundCheckIntervalRef.current) {
        clearInterval(soundCheckIntervalRef.current);
      }
    }
    
    // 清理定时器
    return () => {
      if (soundCheckIntervalRef.current) {
        clearInterval(soundCheckIntervalRef.current);
      }
    };
  }, [isRecognising, lastChangeTimeRef]);

  async function requestWakeLock() {
    if ('wakeLock' in navigator) {
      try {
        wakeLock = await navigator.wakeLock.request('screen');
        wakeLock.addEventListener('release', () => {
          console.log('Wake Lock released');
        });
        console.log('Wake Lock activated');
      } catch (err) {
        console.error(`Unable to request Wake Lock: ${err.name}, ${err.message}`);
      }
    } else {
      console.warn('The current browser does not support the Screen Wake Lock API');
    }
  }

  // 当录音结束时，可以释放唤醒锁
  async function releaseWakeLock() {
    if (wakeLock !== null) {
      await wakeLock.release();
      wakeLock = null;
    }
  }

  //2024.12.16 check websocket connection
  const checkNetwork = async () => {
    try {
      const response = await fetch('https://nvoice.ai');
      isNetWorkConnected = true;
      // console.log('Network check passed:', response);
    } catch (error) {
      console.error('Network check failed:', error);
      alert ('Network is not connected. Please check your network connection.' );
      isNetWorkConnected = false;
    }
    if(isNetWorkConnected) {
      return true;
    } else {
      return false;
    }
  };

  // useEffect(() => {
  //   if (isRecognising) {
  //     let intervalTime = fetchUserIntervalTime();
  //     soundCheckInterval.current = setInterval(() => {
  //       if (textRef.current) {
  //         const currentValue = textRef.current.value;
  //         if (currentValue === previousValue) {
  //           // console.log('Content has not changed:', false);
  //           // printSoundCheckInterval();
  //           startStopRecordingRef.current.click();
  //         } else {
  //           // console.log('Content has changed:', true);
  //           setPreviousValue(currentValue);
  //         }
  //       }
  //     }, intervalTime); // 每隔 intervalTime 毫秒检测一次
  //   } else {
  //     if (soundCheckInterval.current) clearInterval(soundCheckInterval.current);
  //   }

  //   return () => clearInterval(soundCheckInterval.current); // 清除定时器
  // }, [previousValue, isRecognising, textRef]);

  const checkSoundInput = () => {
    // let recognisedTextNotChangedInIntervalTime = true;
    // // if (preTextOfRecognized === inputValueTemp && preTextOfRecoginzing === recognisingTextTemp) {
    // if (textRef.current) {
    //   const currentValue = textRef.current.value;
    //   if (currentValue === previousValue) {
    //     recognisedTextNotChangedInIntervalTime = true;
    //   } else {
    //     // preTextOfRecognized = inputValueTemp;
    //     // preTextOfRecoginzing = recognisingTextTemp;
    //     // setPreviousValue(currentValue);
    //     recognisedTextNotChangedInIntervalTime = false;
    //   }
    // }
    // console.log('isRecognisingTemp is:', isRecognisingTemp? 'true':'false', 'hasSoundInput is:', hasSoundInput? 'true':'false', 'recognisedTextNotChangedInIntervalTime is:', recognisedTextNotChangedInIntervalTime? 'true':'false');
    // if (isRecognisingTemp) {
      // if (!hasSoundInput || recognisedTextNotChangedInIntervalTime) {
      // if (recognisedTextNotChangedInIntervalTime) {
      //   // 步骤3: 如果在1分钟内没有声音输入，模拟点击“关闭”按钮
      //   // printSoundCheckInterval();
      //   // startStopRecordingRef.current.click();
      //   // clearInterval(soundCheckInterval); // 停止计时器
      // } else {
      //   // 步骤4: 如果有声音输入，重置变量并继续计时器循环
      //   hasSoundInput = false; // 重置为 false 以便下一分钟的检测
      // }
      // if(audioDetected) {
      //   console.log('audioDetected is:', audioDetected? 'true':'false');
      // } else {
        printSoundCheckInterval();
        startStopRecordingRef.current.click();
      // }
    // }
  };

  // useEffect(() => {
  //   console.log('current time is:', new Date().toLocaleTimeString()); 
  //   console.log('isRecognising changed to:', isRecognising? 'true':'false');
  //   console.log('audioDetected changed to:', audioDetected? 'true':'false');
  // }, [isRecognising, audioDetected]);

  const printSoundCheckInterval = () => {
    if (soundCheckInterval) {
      let intervalTime = fetchUserIntervalTime();
      const currentTime = new Date();
      console.log(`Sound check interval is set to ${intervalTime / 1000} seconds. Current time is ${currentTime.toLocaleTimeString()}.`);
    } else {
      console.log('Sound check interval is not set.');
    }
  };

  //___________________________________________________________________________
  // 2025.05.12 Attach event listeners to the data channel when a new one is created
  function getIso639FromLabel() {
    const label = userDataLocal?.Language?.lan || 'English';
    const language = languageOptions.find(lang => lang.label === label);
    return language ? language.iso6391 : 'en';
  }

  useEffect(() => {
    if (!dataChannel) return;
    const iso639code = getIso639FromLabel();
    const receptionistPrompt = `
      你是 SpringAI 诊所的前台员工“小美”。  
      负责患者的预约或修改预约事务。  
      记录/修改患者信息：姓名、电话、年龄、症状。  
      根据症状推荐医生：  
      - 张三（内科），周一/三/五，每天最多4位；  
      - 李四（外科），周一/二/四/五，每天最多4位；  
      - 王五（牙医），周二/三/五，每天最多4位；  
      请在用户确认后，输出如下 JSON 格式：  
      {
        "action": "create" 或 "update",
        "patient": { "name": "...", "phone": "...", "age": ... },
        "doctor": "张三"|"李四"|"王五",
        "date": "YYYY-MM-DD",
        "time": "HH:mm",
        "symptom": "..."
      }
      `;
    const defaultPrompt = userDataLocal?.GPTPromptContent || GPT_PROMPT_CONTENT.prompt;
    const needHandleDatabase = defaultPrompt.toLowerCase().includes('诊所') || defaultPrompt.toLowerCase().includes('患者') || defaultPrompt.toLowerCase().includes('clinic') || defaultPrompt.toLowerCase().includes('patient') ? true : false;
    const defaultPromptForAI = needHandleDatabase ? defaultPrompt : receptionistPrompt;
    const onOpen = () => {
      // 1. 打开连接后，立即启用转写
      setResponseText('Session was successfully started.');
      setAiChatMessages(prev =>
        prev.map(msg =>
          msg.content === 'Session starting'
            ? { ...msg, content: 'Session was successfully started.', timestamp: Date.now() }
            : msg
        )
      );
      // setIsSessionActive(true);
      setEvents([]);
      // sendClientEvent({
      //   type: "session.update",
      //   session: {
      //     instructions: defaultPrompt,
      //     input_audio_transcription: { model: "whisper-1", language: iso639code }, 
      //   }
      // });
      // （可选）启动会话欢迎指令
      sendClientEvent({
        type: "response.create",
        response: {
          modalities: ["text", "audio"],
          instructions: "The conversation has started! You can start asking questions right away.",
          max_output_tokens: 100
        }
      });

      if (recognizer) recognizer.startContinuousRecognitionAsync();
    }

    const onMessage = async(e) => {
      // 2. 监听官方事件名，分别处理用户转写、AI 转写和 Token 统计
      const event = JSON.parse(e.data);
      if (!event.timestamp) {
        event.timestamp = new Date().toLocaleTimeString();
      }

      switch (event.type) {
        // 用户语音转写：增量 & 完整
        // case "conversation.item.input_audio_transcription.delta":
        // case "conversation.item.input_audio_transcription.completed":
        //   setAudioDetected(true);
        //   const txt = event.transcript || event.delta;
        //   setRecognisingText(txt);
        //   setRecognisedText(prev => prev + txt);
        //   textRef.current.scrollTop = textRef.current.scrollHeight;
        //   clearTimeout(timeoutRef.current);
        //   const userQuestion = {  
        //     id: Date.now(),
        //     user: fetchUserName() || 'user',
        //     avatar: avatarNow,
        //     content: txt,
        //     timestamp: Date.now() 
        //   };
        //   setAiChatMessages(prev => [...prev, userQuestion]);
        //   const formatQuestion = `${txt}\n`;
        //   setResponseText(prev => prev + formatQuestion); 
        //   setTranscripts(prev => [
        //     ...prev,
        //     { role: "user", text: txt, timestamp: event.timestamp }
        //   ]);
        //   break;

        // AI 语音转写：增量 & 完整
        // case "response.audio_transcript.delta":
        case "response.audio_transcript.done":
          setAudioDetected(true);
          setAiChatMessages(prev => prev.filter(msg => msg.content !== 'Session was successfully started.'));
          const txtSys = event.transcript || event.delta;
          const newUserMessage = {
            id: Date.now()+1,
            user: 'Nvoice',
            avatar: nvoiceLogoImg,
            content: txtSys,
            timestamp: Date.now(),
          };
          setAiChatMessages((prev) => [...prev, newUserMessage]);
          setResponseText(prev => prev.replace(/^Session was successfully started./gm, '') + txtSys + '\n');
          clearTimeout(timeoutRef.current);
          setTranscripts(prev => [
            ...prev,
            { role: "assistant", text: txtSys, timestamp: event.timestamp }
          ]);

          //_________________________________________________
          //2025.05.15 AI 与 firebase 交互
          if (needHandleDatabase) {
            const token = await checkToken();
            const text = event.transcript;
            const match = text.match(/\{[\s\S]*\}/);
            if (match) {
              const cmd = JSON.parse(match[0]);
              // cmd = { action, patient:{…}, doctor, date, time, symptom }
              // 先保存/更新患者信息
              await savePatient(cmd.patient, token);
              // 然后通知后端创建/更新预约
              const result = await aiSchedule(cmd, token);
              // 解析后端返回的 JSON（如果后端也返回 JSON）
              let confirmationText;
              try {
                const resJson = JSON.parse(result.message);
                const { action, doctor, date, time, symptom } = resJson;
                // confirmationText = `已${action==="create"?"创建":"更新"}预约：${doctor}，${date} ${time}；病情：${symptom}`;
                confirmationText = `Appointment ${action === "create" ? "created" : "updated"}: ${doctor}, ${date} ${time}; Symptom: ${symptom}`;
              } catch {
                // 如果不是 JSON，就直接用原文
                confirmationText = result.message;
              }
              // 把后端返回的确认 message 显示给用户
              // sendClientEvent({
              //   type: "conversation.item.create",
              //   item: {
              //     type: "message", role: "system",
              //     content: [{ type:"input_text", text: result.message }]
              //   }
              // });
            // 改为：直接在前端渲染一条小美的“确认”消息
            const confirmationMsg = {
              id: Date.now(),
              user: 'Nvoice',
              avatar: nvoiceLogoImg,
              content: confirmationText,             // 文本格式化后的确认
              timestamp: Date.now()
              };
              setAiChatMessages(prev => [...prev, confirmationMsg]);
            // 如果你也想把它加到 transcripts 里：
              setTranscripts(prev => [
                ...prev,
                { role: "assistant", text: confirmationText, timestamp: new Date().toLocaleTimeString() }
              ]);
            }
          }
          setIsAIthinking(false);
          //_________________________________________________

          break;

        // Token 统计（最终事件）
        case "response.done":
          setResponseText (prev => prev + `\n`);
          const mode = "realTimeIntercom";
          checkAndUpdateTimeUsage(mode);
          // 安全地获取 usage 对象或一个空对象
          const usage = event.response?.usage ?? {};
          // 解构并提供默认值
          const {
            input_tokens  = 0,
            output_tokens = 0,
            total_tokens  = input_tokens + output_tokens
          } = usage;

          setTokenUsage(prev => ({
            input:  prev.input  + input_tokens,
            output: prev.output + output_tokens,
            total:  prev.total  + total_tokens
          }));
          setIsAIthinking(false);
          break;

        // 其他事件一并记录到日志
        default:
          setEvents(prev => [event, ...prev]);
      }
    }
    dataChannel.addEventListener("open", onOpen);
    dataChannel.addEventListener("message", onMessage);

    return () => {
      dataChannel.removeEventListener("open", onOpen);
      dataChannel.removeEventListener("message", onMessage);
    };
  }, [dataChannel]);
  //___________________________________________________________________________

  useEffect(() => {

    isRecognisingTemp = isRecognising;

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);

    if (isRecognising) {
      document.querySelector('.appstyle-footer').style.gridTemplateColumns = '11fr 4fr';
      if(isMobile){
        document.querySelector('.appstyle-footer').style.padding = '0px 15px 60px 0px';
      } else {
        document.querySelector('.appstyle-footer').style.padding = '10px 15px 10px 0';
      }
    } else {
      document.querySelector('.appstyle-footer').style.gridTemplateColumns = '1fr';
      if(isMobile){
        document.querySelector('.appstyle-footer').style.padding = '0px 15px 50px 0px';
      } else {
        document.querySelector('.appstyle-footer').style.padding = '20px 15px 10px 0';
      }
    }

    // console.log(' isRecognising is changeto to:', isRecognising? 'true':'false')  
    const canvas = canvasRef.current // 获取canvas元素的引用
    const startStopRecording = startStopRecordingRef.current
    let stream = null
    let streamPromise = null

    let canvasWidthTemp = 250;
    let canvasHeightTemp = 50;
    let timeLabelX = 5/6;
    
    if(window.innerWidth <= 800 || isMobile) {
      canvasWidthTemp = 200;
      canvasHeightTemp = 40;
      timeLabelX = 4/6;
    }

    if (isRecognising && canvasRef.current) {
      canvas.width = canvasWidthTemp; //250//canvasRef.current.offsetWidth; //300
      canvas.height = canvasHeightTemp; //50; //canvasRef.current.offsetHeight;  //50
      canvas.style.background = '#fffcf7';
      canvas.style.borderRadius = '10px';
      canvas.style.margin = 'auto'; 
    }

    var constraints = {
      video: false,
      audio: {
        channelCount: 1,
        sampleRate: 16000,
        sampleSize: 16,
        volume: 1
      }
    }
    // if(userInforChangedByUserDataLocal) {
      const getMedia = async (constraints) => {
        try {
          // stream = await navigator.mediaDevices.getUserMedia(constraints)
          // if (!stream && !stopBtnClicked) {
          if (!stream) {
            // console.log("getMedia running step2")
            const streamPromise = navigator.mediaDevices.getUserMedia(constraints); // 存储Promise对象
            stream = await streamPromise; // 等待获取媒体流
            mediaStreamRef.current = stream;

            //2024.05.17 mix stream_______________________________________________________


            //____________________________________________________________________________


            setAudioStream(stream);
            initAudioAnalyser(stream);
            loopDrawing(); // 在获取媒体后立即调用loopDrawing函数
            // if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
            //   // nothing here
            // } else {
              if (freshPageCount === 0 && modeTitle !== 'Interview') {
                createRecognizer(stream)
              }
              if(modeTitle === 'Interview' && transcriber===null) {
                createMeetingRecognizer(stream);
              } else if(modeTitle !== 'Interview' && transcriber!==null) {
                transcriber.stopTranscribingAsync();
                transcriber.close();
                setTranscriber(null);
              }
            // }
          }
        } catch (err) {
          /* handle the error */
          if (!isRecognising) {
            if (freshPageCount !== 0) {
              alert("Please allow the microphone permission.");
            } else {
              setToastMessage('Please allow the microphone permission.' );
              setShowToast(true);
            }
            freshPageCount=0;
            if (recognizer) stopRecognizer();
            setStopBtnClicked(false);
            setStopRecordClicked(false);
            setStartRecordClicked(false);
          }
          console.log(err)
        }
      }

      if (!stream) {
        // console.log("getMedia running step1-0 when page initialized")
        getMedia(constraints)
      }

    
      // 0227 释放麦克风权限
      // 0227

      const initAudioAnalyser = (stream) => {
        audioContext = new (window.AudioContext || window.webkitAudioContext)()
        setAudioContextForRecorder(audioContext)
        analyser = audioContext.createAnalyser()
        microphone = audioContext.createMediaStreamSource(stream)
        microphone.connect(analyser)
        analyser.fftSize = 256
      }

      const loopDrawing = () => {

        if (!isRecognising) 
        {
          return
        }
        animationFrameId = requestAnimationFrame(loopDrawing)

        const bufferLength = analyser.frequencyBinCount
        const dataArray = new Uint8Array(bufferLength)
        analyser.getByteFrequencyData(dataArray)

        const ctx = canvas.getContext('2d')
        const width = canvas.width * 7 / 8
        const height = canvas.height * 1 / 2
        const startX = canvas.width / 2 - width / 2
        const startY = canvas.height / 2 + height / 8

        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.fillStyle = '#ff4800' // fe682d 

        const barWidth = width / (bufferLength / 2);
        let barHeight;
        let x = startX;

        for (let i = 0; i < bufferLength/2; i++) {
          barHeight = dataArray[i] / 3;
          ctx.fillRect(x, startY + (height - barHeight), barWidth / 2, barHeight);
          x += barWidth;
        }

        // 计算单次录音时间
        const elapsed = Date.now() - recordingStartTimeRef.current;  
        const minutes = Math.floor(elapsed / 60000).toString().padStart(2, '0');
        const seconds = Math.floor((elapsed % 60000) / 1000).toString().padStart(2, '0');
        const timeText = `${minutes}:${seconds}`;
        const elapsedInSeconds = elapsed / 1000;
        setUsageTimeOfCurrentTask(elapsedInSeconds);
        ctx.font = '16px Fraunces';
        ctx.fillStyle = '#361700';
        ctx.textAlign = 'left';
        ctx.fillText(timeText, canvas.width * timeLabelX, 20);
      }

      const startStopRecordingHandler = () => {
        if(checkAndUpdateTimeUsage()) {
          if (!isRecognising) {
            recordingStartTimeRef.current = Date.now();
            // setTimeout(() => {
              //nothing
              // console.log("call getMedia step1-1 in startStopRecordingHandler")
              getMedia(constraints)
            // }, 1000)
          } else {
            if (audioContext && audioContext.state !== 'closed') {
              audioContext.close()
            }
            cancelAnimationFrame(animationFrameId)

            if (mediaStreamRef.current) {
              mediaStreamRef.current.getTracks().forEach(track => track.stop()); // 停止所有轨道
              mediaStreamRef.current = null;
            }

            // console.log("Stream exists:", stream)
            if (stream) {
              // stream.getTracks().forEach(track => track.stop()) // 取消媒体流
              stream.getTracks().forEach(function(track) {
                track.stop();
              });
              stream = null; // 清除媒体流对象
            }
            // 取消请求的音频流
            if (streamPromise && streamPromise.cancel) {
                streamPromise.cancel();
            }
          }
        }
      }
    
      startStopRecording.addEventListener('click', startStopRecordingHandler);
    //   setUserInforChangedByUserDataLocal(false);
    // }

    return () => {
      startStopRecording.removeEventListener('click', startStopRecordingHandler);

      if (audioContext && audioContext.state !== 'closed') {
          audioContext.close();
        }

      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      // console.log('unmounting...')

      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach(track => track.stop());
      }

      if (recognizer) {
        // stopRecognizer()
        // recognizer.close();
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

    }

  }, [isRecognising, userInforChangedByUserDataLocal, modeTitle])

  // this function will create a speech recognizer based on the audio Stream
  // NB -> it will create it, but not start it
  const createRecognizer = (audioStream) => {
    updateAILaunchMode();
    fetch('/api/speech-config')
      .then(response => response.json())
      .then(config => {
      // 使用配置信息初始化 SpeechRecognizer

      let speechConfig = SpeechConfig.fromSubscription(config.subscriptionKey, config.serviceRegion);
      let audioConfig = AudioConfig.fromStreamInput(audioStream);

      //2024.09.09 log setting
      // speechConfig.enableDiagnosticsLogging = true; // 启用诊断日志记录
      // speechConfig.setProperty("SPEECH-LogLevel", "1"); // 将日志级别设置为 1（详细信息） 
      // const logFilePath = `/logs/speechsdk.log`;
      // speechConfig.setProperty("SPEECH-LogFilename", logFilePath); // 设置日志文件的位置
      //————————————————————————————————————————————————————————————————————————————————

      let customprompt = userDataLocal?.GPTPromptContent || GPT_PROMPT_CONTENT.prompt;
      const containsTranslate = customprompt.includes('翻译') || customprompt.includes('translate') || customprompt.includes('翻譯') || customprompt.includes('translator') || customprompt.includes('Translator')|| customprompt.includes('Translate');
      
      containsTranslateTemp = containsTranslate;
      const lanOne = userDataLocal?.Language?.lan || 'English';
      const lanTwo = userDataLocal?.LanguageOther?.lan || 'English';
      // console.log('lanOne is:', lanOne, 'lanTwo is:', lanTwo);
      // recognizer is a global variable
      if (recognizer) {
        recognizer.stopContinuousRecognitionAsync();
        recognizer.close();
        recognizer = null;
      }
      // if (containsTranslateTemp && lanOne !== lanTwo) {
      //   // 自动检测源语言
      //   const autoDetectSourceLanguageConfig = AutoDetectSourceLanguageConfig.fromLanguages([userDataLocal?.Language?.code, userDataLocal?.LanguageOther?.code]);
      //   // 设置音频输入（例如麦克风）
      //   // 初始化翻译器
      //   recognizer = new TranslationRecognizer(speechConfig, autoDetectSourceLanguageConfig, audioConfig);
      // } else {
        let autoDetectSourceLanguageConfig = null;
        if (lanOne !== lanTwo && userDataLocal?.LanguageOther) {
          autoDetectSourceLanguageConfig = AutoDetectSourceLanguageConfig.fromLanguages(
            [userDataLocal?.Language?.code, userDataLocal?.LanguageOther?.code]
          );
        } else {
          speechConfig.speechRecognitionLanguage = [userDataLocal?.Language?.code || 'en-US'];
        }
        
        if (!autoDetectSourceLanguageConfig){
          recognizer = new SpeechRecognizer(speechConfig, audioConfig);
        } else {
          recognizer = SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);
        }
      // }

      // recognizer = new sdk.ConversationTranscriber(speechConfig, audioConfig)

      recognizer.recognizing = (s, e) => {

        setAudioDetected(true)
        setRecognisingText(e.result.text)
        hasSoundInput = true;
        textRef.current.scrollTop = textRef.current.scrollHeight
        if(e.result.text !== '') {
          if(modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') {
            handleSkipPlayingAudio();
          }
        } else {
          // nothing
        }
      }

      recognizer.recognized = (s, e) => {

        hasSoundInput = true;
        setAudioDetected(true);
        setRecognisingText("");
        if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {
          // console.log(`RECOGNIZED: Text=${e.result.text}`)

          if (autoDetectSourceLanguageConfig){
            const jsonResult = e.result.properties.getProperty(sdk.PropertyId.SpeechServiceResponse_JsonResult);
            const parsedResult = JSON.parse(jsonResult);
            const detectedLangCode = parsedResult.PrimaryLanguage.Language;
            const selectedLanguage = languageOptions.find(option => option.value === detectedLangCode);
            detectedLanguageTemp = selectedLanguage.label;
            // console.log('Detected language:', detectedLanguageTemp);
            // console.log('parsedResult is:', parsedResult);
          }

          // 根据检测到的语言设置翻译的目标语言

          // if (containsTranslateTemp && lanOne !== lanTwo) {
          //   let lanCodeTranslateTo = userDataLocal?.LanguageOther?.code;
          //   // setTranslatedText(e.result.translations.get(detectedLang));
          //   if (detectedLangCode !== userDataLocal?.Language?.code) {
          //     lanCodeTranslateTo = userDataLocal?.Language?.code;
          //   }
          //   setRecognisedText(() => {
          //     const transText = e.result.translations.get(lanCodeTranslateTo);
          //     fetchAndReadStreamForVoiceintercom(transText);
          //     return transText});
          // } else 
          if(currentSpeaker !== 'Candidate' || modeTitle !== 'Interview') {
            setRecognisedText((recognisedText) => {
              return getRecognisedText(recognisedText)
            })
          } else {
            setRecognisedTextYouSay((recognisedTextYouSay) => {
              return getRecognisedText(recognisedTextYouSay)
            })
          }

          checkAndUpdateTimeUsage();

          function getRecognisedText (recognisedText) {
            let returnText = ''
            let fetchFuncParaStr = ''
            let tempText = `${e.result.text}`;

            const offset = Math.floor(e.result.offset / Math.pow(10, 7));
            const offsetHhMmSs = seconds_to_hhmmss(offset);
            if(modeTitle === 'Interview' || transcriber !== null) {
              tempText= `${offsetHhMmSs} ${e.result.text} \n`
            } 
            // console.log("tempText is:", tempText);
            // console.log('modeTitle is:', modeTitle);
            // console.log('currentSpeaker is:', currentSpeaker);
            // console.log('offsetHhMmSs is:',offsetHhMmSs);
            if (recognisedText === '') {
                returnText= `${tempText} \n`;
                setAudioDetected(false);
            } else {
                returnText = `${recognisedText}${tempText} \n`;
            }
            fetchFuncParaStr = `${e.result.text} `
            // console.log("callGptFunc running", countFetch+1)
            // let keywords = GPT_PRE_KEYWORDS[userDataLocal?.Language.code||'en-US'];
            // let keywords = keywordsPreCallGpt;
            let keywords = keywordsCallGpt;
            // console.log("prekeywords is:", keywords);
            textNeedGptFeedback = `${textNeedGptFeedback}${tempText} \n`;

            countFetch++;
            if (countFetch === 2) {
              countFetch = 0
            } //保证对GPT的调用不重复
              if(callGptByKeywordstemp && !callGptByAItemp) {
                let checkContent = fetchFuncParaStr.toLowerCase();
                // if(checkContent){
                if(userDataLocal?.Email === 'lqzai5@126.com'){ 
                  for (let i = 0; i < keywords.length; i++) {
                    const keywordIndex = checkContent.indexOf(keywords[i].toLowerCase());
                    if (keywordIndex !== -1) {
                      callGptFunc(checkContent);
                    }
                  }
                } else {
                  let match;
                  let foundKeyword = false;
                  for (let i = 0; i < keywords.length; i++) {
                    const regex = new RegExp(keywords[i], 'gi'); // 'g' 表示全局搜索
                    while ((match = regex.exec(fetchFuncParaStr)) !== null) {
                      // console.log(`prekeywords "${keywords[i]}" 在字符串中的位置是: ${match.index}`);
                      // console.log("prekeywords is:", keywords[i]);
                      // console.log("fetchFuncParaStr is:", fetchFuncParaStr);
                      foundKeyword = true;
                      break;
                    }
                    if (match || foundKeyword) {
                      break;
                    }

                    // if (fetchFuncParaStr.charAt(fetchFuncParaStr.length-2).toLowerCase() === keywords[i].toLowerCase()) {
                    //   console.log("prekeywords is:", keywords[i]);
                    //   console.log("fetchFuncParaStr is:", fetchFuncParaStr);
                    //   if (countFetch === 1) {
                    //     if(currentSpeaker === 'Candidate') {
                    //       //not need callGpt
                    //     } else if (modeTitle === 'Interview' || modeTitle === 'Transcribe') {
                    //       callGptFunc(fetchFuncParaStr)
                    //     }
                    //     break; // 找到关键词后退出循环
                    //   }
                    // }
                  }
                  if (foundKeyword) {
                    if(currentSpeaker === 'Candidate') {
                      //not need callGpt
                    } else if (modeTitle === 'Interview' || modeTitle === 'Transcribe') {
                      callGptFunc(textNeedGptFeedback)
                      textNeedGptFeedback = '';
                    }
                  }
                }
              } else if (callGptByAItemp){
                callGptFunc(fetchFuncParaStr)
              } else if (callGptByEntertemp) {
                //call GPT just when user press enter key
              } else if (callGptBySelcttemp) {
                //call GPT just when user select text
              }
            // }
            // console.log("returnText is:", returnText);
            return returnText;
          }
          
          textRef.current.scrollTop = textRef.current.scrollHeight
        }
        else if (e.result.reason === sdk.ResultReason.NoMatch) {
          // console.log('NOMATCH: Speech could not be recognized. current time is:', new Date().toLocaleTimeString())
          // hasSoundInput = false;
        }
      }

      recognizer.canceled = (s, e) => {
        // console.log(`CANCELED: Reason=${e.reason}`,'recognizer stopped, current time is:', new Date().toLocaleTimeString());

        if (e.reason === sdk.CancellationReason.Error) {
          console.log(`"CANCELED: ErrorCode=${e.errorCode}`)
          console.log(`"CANCELED: ErrorDetails=${e.errorDetails}`)
          // alert('Network connect error, you can log in again');
          // handleLoginClick();
          if(e.errorCode === 7) {
            console.error('Network connect error, you can log in again. Sys will reboot the recognizer in 30 seconds. current time is:', new Date().toLocaleTimeString());
            if(!isRecognitionPaused) {
              setTimeout(() => {
               startRecognizer();
              }, 30000); 
            }
          }
        }
        recognizer.stopContinuousRecognitionAsync()
      }

      //__________________________________________________________________________________________________________________
      //2024.09.09 log analysis
      //2024.09.09 捕捉状态变化事件
      // recognizer.audioSignalDetected = (s, e) => {
      //   console.log(`Audio signal detected: ${e.offset}`);
      //     setAudioDetected(true)
      // };
      
      // recognizer.audioSignalLost = (s, e) => {
      //   console.log(`Audio signal lost: ${e.offset}`);
      //   setAudioDetected(false)
      // };
      
      // recognizer.speechStartDetected = (s, e) => {
      //   console.log(`Speech started: ${e.offset}`);
      // };
      
      // recognizer.speechEndDetected = (s, e) => {
      //   console.log(`Speech ended: ${e.offset}`);
      // };

      // recognizer.sessionStarted = (s, e) => {
      //   console.log(`Session started: SessionId=${e.sessionId}`);
      // };
      //__________________________________________________________________________________________________________________

      recognizer.sessionStopped = (s, e) => {
        // console.log(`Session stopped: SessionId=${e.sessionId}. Current time is:`, new Date().toLocaleTimeString());
        recognizer.stopContinuousRecognitionAsync()
        clearTimeout(timeoutRef.current)
      }
    });
  }

  const seconds_to_hhmmss = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
    const seconds = totalSeconds - (hours * 3600) - (minutes * 60);
  
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  // this function will start a previously created speech recognizer
  const startRecognizer = () => {
    // const currentTime = new Date();
    // console.log("starRecognizer running, current time is:", currentTime);
    setIsRecognising(true);
    setLastEnterIndex(0);
    countFetch = 0
    if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
      setTimeout(() => {
        startSession();
      }, 500);
    } else {
      if (recognizer && modeTitle !== 'Interview') {
        // recognizer.language = userDataLocal?.Language.code||'en-US';
        recognizer.startContinuousRecognitionAsync();
        // console.log('Recognizer started. isRecognitionPaused is:', isRecognitionPaused? 'true':'false', 'current time is:', new Date().toLocaleTimeString());
      } else {
        // console.error('Recognizer is not initialized or already running.');
      }
      if(modeTitle === 'Interview' && transcriber) {
        startTranscribingAsync();
      } else {
        // console.error('Transcriber is not initialized or already running.');
      }
    }
  }

  // this function will stop a running speech recognizer
  const stopRecognizer = () => {
    if(isRecognitionPaused) setIsRecognising(false);
    // if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
    //   //nothing here
    // } else {
      if (recognizer && modeTitle !== 'Interview')  {
        recognizer.stopContinuousRecognitionAsync();
        // console.log('Recognizer stopped. isRecognitionPaused is:', isRecognitionPaused? 'true':'false', 'current time is:', new Date().toLocaleTimeString());
        if(!isRecognitionPaused && !callGptByAItemp) {
          setTimeout(() => {
            console.log("Resuming recognition..., current time is:", new Date().toLocaleTimeString());
            if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
               recognizer.startContinuousRecognitionAsync();
            } else {
              startRecognizer();
            }
            setResumeTranscribe(false);
          },2000);
        }
      } else {
        console.log('Recognizer is not initialized or already stopped.');
      }
      if(modeTitle === 'Interview' && transcriber) {
        stopTranscribingAsync();
      }else {
        // console.log('Transcriber is not initialized or already stopped.');
      }
    // }
    clearTimeout(timeoutRef.current)
  }

  //2024.11.29
  function cancelLimitTimerForRecognizer() {
    // if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
    //   //nothing here
    // } else {
      isRecognitionPaused = true;
      if(timerForRestartRecognizerRef){
        clearInterval(timerForRestartRecognizerRef.current);;
        timerForRestartRecognizerRef.current = null;
      }
      setResumeTranscribe(false);
    // }
  }

  function launchLimitTimerForRecognizer() {
    // if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
    //   //nothing here
    // } else {
      if(callGptByAItemp) {
        isRecognitionPaused = true;
        return;
      }
      isRecognitionPaused = false;
      let timeMins = 120000;
      let intervalTime = fetchUserIntervalTime();
      timeMins = intervalTime * 5;
      
      if (timeMins < 120000) {
        timeMins = 120000; // The smallest interval time set no less than 1 minutes
      } else if (timeMins > 540000) {
        timeMins = 540000; // The biggest interval time set no more than 9 minutes
      }
      // console.log('timeMins is:', timeMins);
      // Set a timer to stop and restart every 9 minutes
      if(timerForRestartRecognizerRef){
        clearInterval(timerForRestartRecognizerRef.current);;
        timerForRestartRecognizerRef.current = null;
      }
      
      timerForRestartRecognizerRef.current = setInterval(() => {
        // if(soundCheckInterval) clearInterval(soundCheckInterval);
        pauseAndResumeRecognition();
      }, timeMins); // 9 minutes
    // }
  }

  //2024.11.28
  const pauseAndResumeRecognition = () => {
    if (isRecognitionPaused) {
      return;
    }
    setResumeTranscribe(true);
    // console.log("Pausing recognition for 0.5 second...");
    stopRecognizer();
    // console.log('inputValue is:', inputValue, 'current time is:', new Date());
    // setPreviousValue('');
    // setTimeout(() => {
    //   const currentTime = new Date();
    //   console.log("Resuming recognition..., current time is:", currentTime);
    //   // console.log('inputValue is:', inputValue);
    //   startRecognizer();
    //   setResumeTranscribe(false);
    // }, 100); // 0.5-second pause
  };

  const callGptFunc = (returnTextData) => {
    setNvoiceThinkingStatusText('Nvoice is thinking');
    // console.log('callGptFunc running');

      let transcriptionLc = returnTextData.toLowerCase();
        let fullContent = inputValueTemp + returnTextData;
        if(inputValueTemp.length > recognisedTextTemp.length) {
          fullContent = inputValueTemp;
        } else {
          fullContent = recognisedTextTemp + returnTextData;
        }
        // console.log('inputValue:', inputValueTemp);
        // console.log('recognisedText:', recognisedTextTemp);
        fullContent = fullContent.toLowerCase();
        // let keywords = GPT_PRE_KEYWORDS[userDataLocal?.Language.code||'en-US']; // 从环境变量中获取关键词
        // let keywordsTwo = GPT_KEYWORDS[userDataLocal?.Language.code||'en-US']; // 从环境变量中获取关键词
        let keywordsTwo = keywordsCallGpt;
        // if(userDataLocal?.Keywords  && userDataLocal?.Keywords.length > 0) keywords.push(...userDataLocal?.Keywords); // 将用户自定义的关键词数组添加到关键词数组中
        let keywordTwoFound = false; // 标记是否找到关键词
      if(callGptByKeywordstemp) {
        if(userDataLocal?.Email === 'lqzai5@126.com') {  //keywords mode: supper user lqzai5 could use purely custom keywords
        // if(keywordsTwo){
          let needCallGptContent = '';
          let firstKeywordIndex = -1;
          let secondKeywordIndex = -1;

          // console.log('keywordsTwo:', keywordsTwo);
          // console.log('fullContent:', fullContent);

          for (let i = 0; i < keywordsTwo.length; i++) {
            const keywordIndex = fullContent.indexOf(keywordsTwo[i].toLowerCase());
            if (keywordIndex !== -1) {
              if (firstKeywordIndex === -1) {
                firstKeywordIndex = keywordIndex;
              } else if (secondKeywordIndex === -1) {
                secondKeywordIndex = keywordIndex;
                break;
              }
            }
          }

          if (firstKeywordIndex !== -1) {
            setRecognisingText("");
            setRecognisingTextYouSay("");
            setIsAIthinking(true);
            if (secondKeywordIndex !== -1) {
              needCallGptContent = fullContent.substring(firstKeywordIndex, secondKeywordIndex);
            } else {
              needCallGptContent = fullContent.substring(0, firstKeywordIndex);
            }
            console.log('needCallGptContent:', needCallGptContent);
            fetchAndReadStream(needCallGptContent);
          }
        } else {
          // 检查是否包含任一关键词
          // for (let i = 0; i < keywordsTwo.length; i++) {
          //   const regex = new RegExp(keywordsTwo[i], 'gi'); // 'g' 表示全局搜索
          //   let match;
          //   while ((match = regex.exec(transcriptionLc)) !== null) {
          //       console.log("keywordsTwo is:", keywordsTwo);
          //       console.log(`Found keyword: ${keywordsTwo[i]}`);
          //       keywordTwoFound = true;
          //       break; // 找到关键词后退出循环
          //   }
          //   if (keywordTwoFound) {
          //     break;
          //   }
          // }
          // if (keywordTwoFound) {
          //   setIsAIthinking(true)
          //   fetchAndReadStream(transcriptionLc);
          // } 

          // console.log('call fetchAndReadStream...');
          // console.log('transcriptionLc:', transcriptionLc);
          let contentNeedCallGpt = limitTextLength(transcriptionLc);
          setIsAIthinking(true)
          fetchAndReadStream(contentNeedCallGpt);
        }
      } else if(callGptByAItemp) {
        if(!isRecognitionPaused) {
          stopRecognizer();
        }
        setRecognisingText("")
        setRecognisingTextYouSay("")
        setIsAIthinking(true)
        let contentNeedCallGpt = limitTextLength(returnTextData);
        fetchAndReadStream(contentNeedCallGpt); 
      } else if(selectedText!=='' && callGptBySelcttemp) {
        setRecognisingText("")
        setRecognisingTextYouSay("")
        setIsAIthinking(true)
        let contentNeedCallGpt = limitTextLength(returnTextData);
        fetchAndReadStream(contentNeedCallGpt);
      } else if (callGptByEntertemp){
        setRecognisingText("")
        setRecognisingTextYouSay("")
        setIsAIthinking(true)
        let contentNeedCallGpt = limitTextLength(returnTextData);
        fetchAndReadStream(contentNeedCallGpt);
      }
    // }
  }

  function limitTextLength(text) {
    return text.length > TEXT_LIMIT ? text.slice(-TEXT_LIMIT) : text;
  }

  const getGptVersion = () => {
    let gptVersion = 'gpt-4o-mini';
    if(userDataLocal?.GPTVersion) {
      switch (userDataLocal?.GPTVersion) {
        case 'GPT-4':
          gptVersion = 'gpt-4-turbo';
          break;
        case 'GPT-4o':
          gptVersion = 'gpt-4o';
          break;
        case 'GPT-4o mini':
          gptVersion = 'gpt-4o-mini';
          break;
        default:
          gptVersion = 'gpt-4o-mini';
          break;
      }
    }
      return gptVersion;
  }

  // 定义一个函数来发送请求并处理流式响应 customprompt   //needResetGPTPrompt, setNeedResetGPTPrompt
  const fetchAndReadStream = async (questionText) => {
    const userQuestion = {  
        id: Date.now(),
        user: fetchUserName() || 'user',
        avatar: avatarNow,
        content: questionText,
        timestamp: Date.now() 
      };

    setAiChatMessages(prev => [...prev, userQuestion]);
    const formatQuestion = `Question: ${questionText}\n`;
    setResponseText(prev => prev + formatQuestion); 
    const gptVersion = getGptVersion();
    // gptVersion = (!userDataLocal || userDataLocal?.GPTVersion==='GPT-3.5') ? 'gpt-3.5-turbo':userDataLocal?.GPTVersion.toLowerCase();
    let customprompt = userDataLocal?.GPTPromptContent || GPT_PROMPT_CONTENT.prompt;

    const containsTranslate = customprompt.includes('翻译') || customprompt.includes('translate') || customprompt.includes('翻譯') || customprompt.includes('translator') || customprompt.includes('Translator')|| customprompt.includes('Translate');
    const lanOne = userDataLocal?.Language?.lan || 'English';
    const lanTwo = userDataLocal?.LanguageOther?.lan || 'English';
    // console.log('lanOne is:', lanOne, 'lanTwo is:', lanTwo);

    // let translateModeValue = false;
    let questionTextNew = questionText;
    if (containsTranslate && lanOne !== lanTwo) {
      // //2024.08.10 注意当前这个参数还不能使用，因为需要再送给GPT之前就需要提供翻译好的文字，当前还没实现，所以只能设置该参数为否
      // //2024.08.10 当前在server.js对这个参数没有做任何处理，所以当前前端的任何设置都不会起任何作用
      // translateModeValue = true; 
      // if(detectedLanguage === lanOne || detectedLanguageTemp === lanOne) {
      // console.log('detectedLanguageTemp is: ', detectedLanguageTemp)
      if(detectedLanguageTemp === lanOne || detectedLanguageTemp === '') {
        questionTextNew = 'Please translate the following text into ' + lanTwo + ': ' + questionText;
      } else if(detectedLanguageTemp === lanTwo) {
        questionTextNew = 'Please translate the following text into ' + lanOne + ': ' + questionText;
      } else {
        console.log('detectedLanguageTemp is not include in source languages array, will do nothing');
        return;
      }
    }

    // console.log("gptVersion is:", gptVersion, "customprompt is:", customprompt)
    if(modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') {
      // stopRecognizer();   //2024.11.08 当当前模式为Voice intercom时，也不需要停止语音识别转写，相反应该允许用户打断AI的回答
      if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
        sendTextMessage(questionText);
      } else {
        fetchAndReadStreamForVoiceintercom(questionTextNew);
      }
      return;
    }

    //__________________________________________________________________________________________________________________
    //2025.03.07

    customprompt = customprompt + '\n\n If the returned reply contains mathematical formulas, please do not use escape characters, as this will not display properly on the front end.';

    const userMessage = {
      role: 'user',
      content: questionTextNew
    };

    const sysMessage = {
      role: 'system',
      content: customprompt
    }
    const transformedMessages = [sysMessage, userMessage];

    //__________________________________________________________________________________________________________________
    
    const url = `https://www.bingoai.net/chatgpt-clone?question=${encodeURIComponent(questionTextNew)}&gptversion=${encodeURIComponent(gptVersion)}&customprompt=${encodeURIComponent(customprompt)}&reset_prompt=${encodeURIComponent(needResetGPTPrompt)}`;

    if (freshPageCount === 0) {
      setResponseText("");
      freshPageCount++;
    }// 初始化响应文本为空: 只有当刷新页面的时候才会重置两个文本框中的文本
    clearTimeout(timeoutRef.current);

    // fetch(url, {
    //   method: 'POST', // 使用POST方法
    //   headers: {
    //     // 根据需要设置请求头
    //   },
    // })
    // .then(response => {
    //   if (!response.body) {
    //     throw new Error('ReadableStream not supported');
    //   }
    //   const reader = response.body.getReader();
    //   let resoponseCurrent = '';
    //   return new ReadableStream({
    //     start(controller) {
    //       function push() {
    //         reader.read().then(({ done, value }) => {
    //           if (done) {
    //             // if(modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') {
    //             //   setResponseFromAI(resoponseCurrent);
    //             //   setNeedResetGPTPrompt(false);
    //             //   controller.close()
    //             //   return
    //             // } else { 
    //               setNeedResetGPTPrompt(false);
    //               controller.close()
    //               setIsAIthinking(false)
    //               if(!isInTranscribingProcess) {
    //                 tokensOFresponseFromAIWhenNotTranscribing += estimateTokens(resoponseCurrent) + estimateTokens(questionText);
    //               }
    //               // if((!isRecognising)&&(!stopBtnClicked)&&(isInTranscribingProcess)) {
    //               //   startRecognizer()
    //               // }
    //               if(!isRecognitionPaused && callGptByAItemp) {
    //                 startRecognizer();
    //               }
    //               setResponseText (prev => prev + `\n`);
    //               return
    //             // }
    //           }
    //           clearTimeout(timeoutRef.current);
    //           let chunk = new TextDecoder().decode(value);
              
    //           chunk = chunk.replace(/^data: /gm, '').replace(/\n/gm, '').replace(/<br\/>/gm, '\n').replace(/&nbsp;/gm, ' ').replace(/\[DONE\]/gm, '\n');
    //           setResponseText(prev => prev.replace(/^SpringAI thinking.../gm, '') + chunk); // 累加响应文本到状态变量
    //           resoponseCurrent = resoponseCurrent + chunk;
    //           controller.enqueue(value);
    //           push();
    //         });
    //       }
    //       push();
    //     }
    //   });
    // })
    // .catch(err => {
    //   setIsAIthinking(false)
    //   // freshPageCount = 0;
    //   setErrorInfo('Network error. Please try again later.');
    //   // console.error('Fetch error:', err);
    // });

    //__________________________________________________________________________________________________________________
    //2025.03.07

    try {
      const token = await checkToken();
      const response = await fetch('/api/chat/stream', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`, 
        },
        body: JSON.stringify({ messages: transformedMessages })
      })
      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      let resoponseCurrent = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          setNeedResetGPTPrompt(false);
          setIsAIthinking(false)
          if(!isInTranscribingProcess) {
            tokensOFresponseFromAIWhenNotTranscribing += estimateTokens(resoponseCurrent) + estimateTokens(questionText);
          }
          if(!isRecognitionPaused && callGptByAItemp) {
            startRecognizer();
          }
          setResponseText (prev => prev + `\n`);
          const newUserMessage = {
            id: Date.now()+1,
            user: 'Nvoice',
            avatar: nvoiceLogoImg,
            content: resoponseCurrent,
            timestamp: Date.now(),
          };
          setAiChatMessages((prev) => [...prev, newUserMessage]);
          break;
        }
        let chunk = decoder.decode(value);
        chunk = chunk
          .replace(/^data: /gm, '')
          .replace(/\n/gm, '')
          .replace(/<br\/?>/gm, '  ')
          .replace(/&nbsp;/gm, ' ')
          // .replace(/\[DONE\]/gm, '')
          .replace(/\*\*/gm, '')
          .replace(/"+/gm, '')  // 匹配并删除连续的双引号
          .replace(/'/gm, '')  // 匹配并删除单引号
          .replace(/\\\\\[/g, '[')  
          .replace(/\\\\\(/g, '(')   
          .replace(/\\\\\)/g, ')')   
          .replace(/\\\\\]/g, ']'); 
        
        chunk = chunk.replace(/\[DONE\]/gm, `\n`)

        setResponseText(prev => prev.replace(/^Nvoice thinking/gm, '') + chunk); // 累加响应文本到状态变量

        clearTimeout(timeoutRef.current);
        resoponseCurrent = resoponseCurrent + chunk;
      }
      return
    }
    catch (error) {
      setIsAIthinking(false)
      setErrorInfo('Network error. Please try again later.');
    } 
    //__________________________________________________________________________________________________________________
  }

  const fetchUserName = () => {
    const name = userDataLocal?.Name;
    let username = name;
    if (name.includes('@')) {
        username = name.split('@')[0];
    }
    return username;
  }

  // —————————————————————————————————————————————————————————————————————————————————————————————————
  // 定义一个函数来发送请求并处理流式响应 customprompt   //needResetGPTPrompt, setNeedResetGPTPrompt
  const fetchAndReadStreamForVoiceintercom = async(questionText) => {

    let gptVersion = getGptVersion();
    // const gptVersion = (!userDataLocal || userDataLocal?.GPTVersion==='GPT-3.5') ? 'gpt-3.5-turbo':userDataLocal?.GPTVersion.toLowerCase();
    let customprompt = userDataLocal?.GPTPromptContent || GPT_PROMPT_CONTENT.prompt;

    //2024.08.07 Translate mode set prompt
    // userDataLocal?.Language?.code === userDataLocal?.LanguageOther?.code
    //detectedLanguage
    // const containsTranslate = customprompt.includes('翻译') || customprompt.includes('translate') || customprompt.includes('翻譯') || customprompt.includes('translator') || customprompt.includes('Translator')|| customprompt.includes('Translate');
    // const lanOne = userDataLocal?.Language?.lan || 'English';
    // const lanTwo = userDataLocal?.LanguageOther?.lan || 'English';
    // // console.log('lanOne is:', lanOne, 'lanTwo is:', lanTwo);

    // // let translateModeValue = false;
    // let questionTextNew = questionText;
    // if (containsTranslate && lanOne !== lanTwo) {
    //   // //2024.08.10 注意当前这个参数还不能使用，因为需要再送给GPT之前就需要提供翻译好的文字，当前还没实现，所以只能设置该参数为否
    //   // //2024.08.10 当前在server.js对这个参数没有做任何处理，所以当前前端的任何设置都不会起任何作用
    //   // translateModeValue = true; 
    //   // if(detectedLanguage === lanOne || detectedLanguageTemp === lanOne) {
    //   console.log('detectedLanguageTemp is: ', detectedLanguageTemp)
    //   if(detectedLanguageTemp === lanOne) {
    //     questionTextNew = 'Please translate the following text into ' + lanTwo + ': ' + questionText;
    //   } else if(detectedLanguageTemp === lanTwo) {
    //     questionTextNew = 'Please translate the following text into ' + lanOne + ': ' + questionText;
    //   } else {
    //     console.log('detectedLanguageTemp is not include in source languages array, will do nothing');
    //     return;
    //   }
    // }
    // console.log("gptVersion is:", gptVersion, "customprompt is:", customprompt)
    // if(modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') {
    //   customprompt = customprompt + '\n Please keep your responses brief and spoken as much as possible. For example, when answering programming questions, do not use long sections of code to demonstrate. Instead, describe the key points. All responses should be expressed verbally rather than in text.';
    // }
    // let resoponseCurrent = '';
    if (freshPageCount === 0) {
      setResponseText("");
      freshPageCount++;
    }// 初始化响应文本为空: 只有当刷新页面的时候才会重置两个文本框中的文本
    clearTimeout(timeoutRef.current);
    try {
      // 如果有之前的音频文件，先删除它
      if (audioId) {
          axios.post('/api/delete-audio', {
          audioPath: `/audio/${audioId}.mp3`
        });
        setAudioId(null);
      }
      
      const response = await axios.post('/api/get-response-with-audio', {
        gptVersion: gptVersion,
        question: questionText,
        updatePrompt: true, //needResetGPTPrompt
        promptText: customprompt
      });

      const newAudioUrl = response.data.audioDataURL;
      const newAudioId = response.data.audioPath.split('/').pop().split('.').shift();

      setAudioUrl(newAudioUrl);
      setAudioId(newAudioId);
      // setTextResponse(response.data.text);
      let textResponse = response.data.text;

      setTotalTTSToken((totalTTSToken || 0) + (response.data.totalTokens || 0));
      setTotalTTSDuration((totalTTSDuration || 0) + (response.data.duration || 0));

      // console.log('totalTTSToken is:', totalTTSToken);
      // console.log('totalTTSDuration is:', totalTTSDuration);
      // console.log('response.data.token is:', response.data.totalTokens);
      // console.log('response.data.duration is:', response.data.duration);

      let temptext = textResponse.replace(/^data: /gm, '').replace(/\n/gm, '').replace(/<br\/>/gm, '\n').replace(/&nbsp;/gm, ' ').replace(/\[DONE\]/gm, '\n');
      // resoponseCurrent = resoponseCurrent + temptext;
      // setResponseFromAI(resoponseCurrent);
      setNeedResetGPTPrompt(false);

      setResponseText(prev => prev.replace(/^SpringAI thinking.../gm, '')  + temptext + '\n'); // 累加响应文本到状态变量

    } catch (error) {
      console.error('Error fetching audio:', error);
      setIsAIthinking(false)
      // freshPageCount = 0;
      // setErrorInfo('Network error. Please try again later.');
    }
  }
  
  //____________________________________________________________________________________
  // 2025.05.12 https://api.openai.com/v1/realtime/sessions gpt-4o-mini-realtime-preview Realtime Voice Intercom
  async function startSession () {
    if (isSessionActive) {
      console.warn('Intercom already running');
      return;
    }
    if(!isRecognisingTemp) return;
    if (peerConnection.current) return;
    setIsSessionActive(true);
    setAiChatMessages(prev => [
      ...prev,
      { id: Date.now()+1, user: 'Nvoice', avatar: nvoiceLogoImg, content: 'Session starting', timestamp: Date.now() }
    ]);
    setResponseText('Session starting');
    console.log('startIntercom running');
    updateAILaunchMode();
    let gptVersion = getGptVersion();
    clearTimeout(timeoutRef.current);
    freshPageCount++;
    setNeedResetGPTPrompt(false);
    // 重置转写和token消耗记录
    setTranscripts([]);
    setTokenUsage({ input: 0, output: 0, total: 0 });
    try {
      // Get a session token for OpenAI Realtime API
      const tokenResponse = await fetch("/api/temprealtimekey");
      const data = await tokenResponse.json();
      const EPHEMERAL_KEY = data.client_secret.value;

      // 创建系统级事件，记录会话开始
      const sessionStartEvent = {
        type: "system",
        content: "Session Start",
        timestamp: new Date().toLocaleTimeString(),
      };
      setEvents(prev => [sessionStartEvent, ...prev]);

      /* 1. 申请麦克风 */
      micStream.current = await navigator.mediaDevices.getUserMedia({ audio: true });

      /* 2. 建立 PeerConnection 并添加本地音轨 */
      const pc = new RTCPeerConnection();
      micStream.current.getTracks().forEach(t => pc.addTrack(t, micStream.current));
      peerConnection.current = pc;

      /* 3. 远端音轨到来：播放 + 混音 + 开始录制 */
      pc.ontrack = ({ streams }) => {
        const remoteStream = streams[0];

        /* --- 播放远端声音给用户 --- */
        const remoteAudio = new Audio();
        remoteAudio.srcObject = remoteStream;
        remoteAudio.autoplay = true;
        remoteAudio.play().catch(() => {});

        /* --- 使用 AudioContext 做混音 --- */
        audioCtx.current  = new AudioContext();
        mixDest.current   = audioCtx.current.createMediaStreamDestination();

        audioCtx.current.createMediaStreamSource(micStream.current).connect(mixDest.current);
        audioCtx.current.createMediaStreamSource(remoteStream).connect(mixDest.current);

        /* --- 录制混合流 --- */
        mediaRec.current = new MediaRecorder(mixDest.current.stream);
        mediaRec.current.ondataavailable = e => recChunks.current.push(e.data);
        mediaRec.current.start();           // 不设置 timeslice => 结束时导出整段
      };

      /* 4. 创建 dataChannel（事件发送/接收） */
      const dc = pc.createDataChannel('oai-events');
      setDataChannel(dc);

      // Start the session using the Session Description Protocol (SDP)
      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);

      const baseUrl = "https://api.openai.com/v1/realtime";
      const model = "gpt-4o-realtime-preview-2025-06-03"; // gpt-4o-realtime-preview-2024-12-17
      const sdpResponse = await fetch(`${baseUrl}?model=${model}`, {
        method: "POST",
        body: offer.sdp,
        headers: {
          Authorization: `Bearer ${EPHEMERAL_KEY}`,
          "Content-Type": "application/sdp",
        },
      });

      const answer = {
        type: "answer",
        sdp: await sdpResponse.text(),
      };
      await pc.setRemoteDescription(answer);

      // peerConnection.current = pc;
    } catch (err) {
      console.error('[Intercom] Startup failure:', err);
      alert('Voice call initiation failed: ' + err.message);
      setIsRecognising(false);
      setIsSessionActive(false);
      setIsAIthinking(false);
    }
  }

  // Stop current session, clean up peer connection and data channel
  function stopSession() {
    // 添加会话结束事件，包含token统计
    setIsAIthinking(false);
    if (!isSessionActive) {
      setIsRecognising(false);
      return;
    }
    /* 1. 关闭 PeerConnection / 数据通道 / 音轨 */
    peerConnection.current?.getSenders().forEach(s => s.track && s.track.stop());
    peerConnection.current?.close();
    setIsRecognising(false);

    /* 2. 停止录音并导出音频文件 */
    if (mediaRec.current && mediaRec.current.state !== 'inactive') {
      mediaRec.current.stop();
      mediaRec.current.onstop = () => {
        const fullBlob = new Blob(recChunks.current, { type: 'audio/webm' });
        combineInputAndOutputAudio(fullBlob);
        // const url      = URL.createObjectURL(fullBlob);
        // /* 立即自动下载；也可以改成上传到服务器 */
        // const a = document.createElement('a');
        // a.href = url;
        // a.download = `conversation-${Date.now()}.webm`;
        // a.click();
        // URL.revokeObjectURL(url);
        // recChunks.current = [];
      };
    }

    const sessionEndEvent = {
      type: "system",
      content: `Session ends - Token consumption: Input: ${tokenUsage.input}, Output: ${tokenUsage.output}, Total: ${tokenUsage.total}`,
      timestamp: new Date().toLocaleTimeString(),
    };
    setEvents(prev => [sessionEndEvent, ...prev]);
    
    // 将当前所有转写保存到某个地方（可以添加保存到本地或后端的功能）
    console.log("Conversation transcription record:", transcripts);
    console.log("Token consumption statistics:", tokenUsage);

    if (dataChannel) {
      dataChannel.close();
    }

    setIsSessionActive(false);
    setDataChannel(null);
    micStream.current.getTracks().forEach(t => t.stop());
    micStream.current = null;
    audioCtx.current?.close();
    audioCtx.current = null;
    mixDest.current = null;
    mediaRec.current = null;
    remoteRecorder.current = null;
    remoteStreamRef.current = null;
    recChunks.current = [];
    setRecordingEvents([]);
    peerConnection.current = null;
  }

  // Send a message to the model
  function sendClientEvent(message) {
    if (dataChannel) {
      const timestamp = new Date().toLocaleTimeString();
      message.event_id = message.event_id || crypto.randomUUID();

      // send event before setting timestamp since the backend peer doesn't expect this field
      dataChannel.send(JSON.stringify(message));

      // if guard just in case the timestamp exists by miracle
      if (!message.timestamp) {
        message.timestamp = timestamp;
      }
      setEvents((prev) => [message, ...prev]);
    } else {
      console.error(
        "Failed to send message - no data channel available",
        message,
      );
    }
  }

  // Send a text message to the model
  function sendTextMessage(message) {
    // 将发送的文本消息也添加到转写记录中
    const newTranscript = {
      role: 'user',
      text: message,
      timestamp: new Date().toLocaleTimeString()
    };
    setTranscripts(prev => [...prev, newTranscript]);
    
    const event = {
      type: "conversation.item.create",
      item: {
        type: "message",
        role: "user",
        content: [
          {
            type: "input_text",
            text: message,
          },
        ],
      },
    };

    sendClientEvent(event);
    sendClientEvent({ type: "response.create" });
  }
  // ———————————————————————————————————————————————————————————————————————————————————
  // record user auido & AI audio together 2025.05.17
  // Helper: convert AudioBuffer to WAV Blob
  async function bufferToWave(abuffer, len) {
    const numOfChan = abuffer.numberOfChannels;
    const length = len * numOfChan * 2 + 44;
    const buffer = new ArrayBuffer(length);
    const view = new DataView(buffer);
    function writeString(view, offset, string) {
      for (let i = 0; i < string.length; i++) view.setUint8(offset + i, string.charCodeAt(i));
    }
    writeString(view, 0, 'RIFF');
    view.setUint32(4, length - 8, true);
    writeString(view, 8, 'WAVE');
    writeString(view, 12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, numOfChan, true);
    view.setUint32(24, abuffer.sampleRate, true);
    view.setUint32(28, abuffer.sampleRate * numOfChan * 2, true);
    view.setUint16(32, numOfChan * 2, true);
    view.setUint16(34, 16, true);
    writeString(view, 36, 'data');
    view.setUint32(40, length - 44, true);
    let offset = 44;
    const channels = [];
    for (let i = 0; i < numOfChan; i++) channels.push(abuffer.getChannelData(i));
    for (let i = 0; i < len; i++) {
      for (let ch = 0; ch < numOfChan; ch++) {
        const sample = Math.max(-1, Math.min(1, channels[ch][i]));
        view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
        offset += 2;
      }
    }
    return new Blob([view], { type: 'audio/wav' });
  }
  // ———————————————————————————————————————————————————————————————————————————————————


  //transcription text changed ——inputValue
  const handleInputChange = (e) => {
    // setRecognisedText(e.target.value);
    if(userDataLocal?.TranscriptionMode === 'Offline'){
      return;
    }
    userTypingText = true;
    setInputValue(e.target.value);
  }

   //transcription text changed ——inputValueYouSay 2024.05.14
  const handleInputYouSayChange = (e) => {
    if(modeTitle === 'Interview') {
      userTypingTextYouSay = true;
      setInputValueYouSay(e.target.value);
    }
    // setRecognisedTextYouSay(e.target.value)
  }

  //2024.05.18 
  const handleMouseDown = (e) => {
    if(!callGptBySelct || isPaused)  return;
    if ( showSelectTextPopup ) setShowSelectTextPopup(false);
    setMouseDownLetInputValueSelectTextBeTop(true);
    setIsPaused(true);
  }

  const handleMouseDownInterviewee = (e) => {
    if(!callGptBySelct || isPaused) return;
    if ( showSelectTextIntervieweePopup ) setShowSelectTextIntervieweePopup(false);
    setMouseDownLetInputValueYouSaySelectTextBeTop(true);
    setIsPaused(true);
  }

  // —————————————————————————————————————————————————————————————————————————————————————————————————
  //2024.06.27 Enter key down
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // 阻止默认行为，例如插入换行符

  
      // 获取当前光标位置
      const currentEnterIndex = e.target.selectionStart;
  
      // 在当前光标位置插入换行符，更新文本框的值
      const updatedValue = inputValue.slice(0, currentEnterIndex) + '\n' + inputValue.slice(currentEnterIndex);
  
      // 计算本次回车之前的文本（不包括新插入的换行符）
      const textToSend = inputValue.slice(lastEnterIndex, currentEnterIndex).trim();
  
      // 在这里处理 textToSend，例如发送给服务器
      // console.log('发送的文本:', textToSend);
  
      // 更新文本框的值和上次回车的位置
      setInputValue(updatedValue);
      setLastEnterIndex(currentEnterIndex + 1); // 更新上次回车的位置，加1是为了跳过新插入的换行符
      let modeAIAndVoice = false;
      if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
        modeAIAndVoice = true;
      }
      if((textToSend !== '' && callGptByEntertemp) || (textToSend !== '' && modeAIAndVoice)) {
        callGptFunc(textToSend);
      }
    }
  };

  // —————————————————————————————————————————————————————————————————————————————————————————————————
  //2024.09.24 Enter key down
  const handleEnterPress = () => {
    if(enterText !== '') {
      callGptFunc(enterText);
      setTimeout(() => {
        setEnterText('');
      }, 50);
    }
  };

  // —————————————————————————————————————————————————————————————————————————————————————————————————
  const handlePauseResume = () => {
    if(!isPaused) {
      setMouseDownLetInputValueSelectTextBeTop(true);
      setMouseDownLetInputValueYouSaySelectTextBeTop(true);
      setIsPaused(true);
    } else {
      setMouseDownLetInputValueSelectTextBeTop(false);
      setMouseDownLetInputValueYouSaySelectTextBeTop(false);
      setIsPaused(false);
    }
  }

  //2024.05.13 handleTextSelect
  const handleTextSelect = (e) => {
    if(callGptByKeywords || callGptByEnter || callGptByAI) return;
    let selectedText = window.getSelection().toString();
    if (selectedText.length > 2) {
      setSelectedText(selectedText);
      setShowSelectTextPopup(true);
      setSelectTextPopupPosition({
        top: e.clientY, 
        left: e.clientX
      });
    } else {
      setShowSelectTextPopup(false);
      setSelectedText('');
      setMouseDownLetInputValueSelectTextBeTop(false);
      setMouseDownLetInputValueYouSaySelectTextBeTop(false);
      setIsPaused(false);
    }
  };

  const handleTextSelectInterviewee = (e) => {
    if(callGptByKeywords || callGptByEnter || callGptByAI) return;
    let selectedText = window.getSelection().toString();
    setSelectedText(selectedText);
    setShowSelectTextIntervieweePopup(true);
    if (selectedText.length > 0) {
      if(mousePosition.y !== 0) {
        setSelectTextPopupPosition({
          top: mousePosition.y - 100 + window.scrollY, 
          left: mousePosition.x - 280 + window.scrollX
        });
      }
      // console.log("SelectTextPopupPosition is:", selectTextPopupPosition);
      // setShowSelectTextIntervieweePopup(true);
    } else {
      setSelectedText('');
      setShowSelectTextIntervieweePopup(false);
    }
  };

  const handleAskAI = () => {
    setShowSelectTextPopup(false);
    setShowSelectTextIntervieweePopup(false);
    callGptFunc(selectedText);
  };

  //2024.05.19 ask all text to AI
  const helpCallGPTAllText = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    askAll = true;
    if(!mouseDownLetInputValueSelectTextBeTop) {
      setSelectedText(inputValue);
    } else {
      setSelectedText(`${recognisedText}${recognisingText}`);
    }
  };

  const export2txt = (text1, text2) => {

    // if (textValueTempFlag) {
    //   text1 = inputValueTemp;
    //   text2 = inputValueYouSayTemp;
    // }
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }

    if (userDataLocal?.TranscriptionMode !== 'Offline') {
      let combineText = text1;
      if (modeTitle === 'Interview' && text2 !== '') {
        combineText = combineTranscript(text1, text2);
      }
      const blob = new Blob([combineText], { type: "text/plain" })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      const fileformat = 'transcript';
      link.download = `${nameSetbyTime(fileformat)}.txt` //"transcription.txt"  //`${nameSetbyTime()}.txt`
      link.href = url
      link.click()
    }

    setSaveRecordClicked(true)
  } 

  const handleLoginClick = () => {
    // console.log("handleLoginClick running")
    // setShowLoginPopup(true);
    logOut();
    window.location.href = '/login';
  }

  function combineTranscript(inputValue, inputValueYouSay) {

    const parseLogs = (logs, name) => {
      return logs.split('\n').map(log => {
        const [time, ...message] = log.split(' ');
        return { time, message: message.join(' '), name };
      });
    };
  
    const Interviewertext = parseLogs(inputValue, 'Interviewer');
    const Candidatetext = parseLogs(inputValueYouSay, 'Candidate');
  
    const combinedLogs = [...Interviewertext, ...Candidatetext];
    combinedLogs.sort((a, b) => a.time.localeCompare(b.time));
    // return combinedLogs;
    return combinedLogs.join('\n');
  }

  //recording audio
  const startRecorder = () => {
    Mp3Recorder.start()
    // if( userDataLocal?.TranscriptionMode === 'Offline') {
    //   Mp3Recorder.start()
    // } else {
    //   recorderControls.startRecording();
    // }
    setEnableExportAudio(false);
  };

  const stopRecorder = async() => {
    setEndTimeOfAudio(new Date());
    if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
      // await combineInputAndOutputAudio();
      Mp3Recorder.stop()
    } else {
      Mp3Recorder.stop().getMp3().then(([buffer, blob]) => {
        setAudioBlob(blob);
      }).catch((e) => console.log(e));
    }
    setEnableExportAudio(true);

    // if( userDataLocal?.TranscriptionMode === 'Offline') {
    //   Mp3Recorder.stop().getMp3().then(([buffer, blob]) => {
    //     setAudioBlob(blob);
    //   }).catch((e) => console.log(e));
    // } else {
    //   recorderControls.togglePauseResume();
    // }
    // recorderControls.stopRecording();
  };

  /* Float32 [-1,1] → Int16 [-32768,32767] */
  function float32ToInt16(float32) {
    const l = float32.length;
    const int16 = new Int16Array(l);
    for (let i = 0; i < l; i++) {
      const s = Math.max(-1, Math.min(1, float32[i]));   // clip
      int16[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
    }
    return int16;
  }

  async function combineInputAndOutputAudio(webmBlob) {
    /* 解析 WebM → AudioBuffer */
    const arrayBuf   = await webmBlob.arrayBuffer();
    const ctx        = new (window.AudioContext || window.webkitAudioContext)();
    const audioBuf   = await ctx.decodeAudioData(arrayBuf);
  
    /* 如有多声道，简单平均成单声道（也可保留立体声） */
    const { numberOfChannels, length, sampleRate } = audioBuf;
    const monoFloat32 = new Float32Array(length);
    for (let ch = 0; ch < numberOfChannels; ch++) {
      const data = audioBuf.getChannelData(ch);
      for (let i = 0; i < length; i++) monoFloat32[i] += data[i] / numberOfChannels;
    }
  
    /* 转 Int16，再分块编码 MP3 */
    const pcmInt16 = float32ToInt16(monoFloat32);
    const enc      = new lamejs.Mp3Encoder(1, sampleRate, 128); // 单声道 128 kbps
    const block    = 1152;
    const mp3Parts = [];
  
    for (let i = 0; i < pcmInt16.length; i += block) {
      const slice = pcmInt16.subarray(i, i + block);
      const buf   = enc.encodeBuffer(slice);
      if (buf.length) mp3Parts.push(new Uint8Array(buf));
    }
    const end = enc.flush();
    if (end.length) mp3Parts.push(new Uint8Array(end));
  
    /* 得到最终 MP3 Blob */
    const mp3Blob = new Blob(mp3Parts, { type: 'audio/mpeg' });
    setAudioBlob(mp3Blob);       // 你的状态更新
  }

  const saveRecorder = () => {
    
    // console.log("audioBlob is:", audioBlob);
    // if( userDataLocal?.TranscriptionMode === 'Offline') {
      if (audioBlob) {
        if(userDataLocal?.AudioSet === 'wav') {
          saveRecording();
        } else {
          saveRecordingMp3();
        }
      }
    // } else {
    //   recorderControls.stopRecording();
    // }
  };

  // const recorderControls = useAudioRecorder(
  //   {
  //     noiseSuppression: true,
  //     echoCancellation: true,
  //   },
  //   (err) => console.table(err) // onNotAllowedOrFound  
  // );

  // const handleRecordingComplete = (blob) => {
  //   const url = URL.createObjectURL(blob);
  //   setAudioBlob(blob);
  //   setBlobURL(url);
  // };

  // const addAudioElement = (blob) => {
  //   setAudioBlob(blob);
  //   // console.log("blob is:", blob);
  //   // setAudioBlob(recorderControls.recordingBlob);
  //   // console.log("blob is:", blob);
  //   // console.log("recorderControls.recordingBlob is:", recorderControls.recordingBlob);
  //   const url = URL.createObjectURL(blob);
  //   const fileformat = userDataLocal?.AudioSet;
  //   const audio = document.createElement(`${nameSetbyTime(fileformat)}`);
  //   audio.src = url;
  //   audio.controls = true;
  //   setBlobURL(url);
  //   // document.body.appendChild(audio);
  // };

  //save .wav file
  const saveRecording = async () => {
    if (audioBlob) {
      // Convert the audio blob to an AudioBuffer
      const arrayBuffer = await audioBlob.arrayBuffer();
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

      //By default, exports with 16-bit PCM (format: 1). You can specify opt.float32 instead, which will write format 3 with 32-bit float data.
      const wav = toWav(audioBuffer,48000);

      // Create a new blob from the WAV file
      const wavBlob = new Blob([new DataView(wav)], { type: 'audio/wav' });
  
      // Create a URL for the blob
      const url = URL.createObjectURL(wavBlob);
      const link = document.createElement('a');
      link.href = url;
      // link.download = `recording_${new Date().toISOString().replace(/:/g, '-')}.wav`; // Custom filename
      const fileformat = userDataLocal?.AudioSet;
      link.download = `${nameSetbyTime(fileformat)}.wav`; // Custom filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
    }
  };

  //save .mp3 file
  const saveRecordingMp3 = () => {
    if (audioBlob) {
      const url = URL.createObjectURL(audioBlob);
      const link = document.createElement('a');
      link.href = url;
      const fileformat = userDataLocal?.AudioSet;
      link.download = `${nameSetbyTime(fileformat)}.mp3`; // Custom filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
    }
  };

  //2024.10.30 save .mp3 file by blob directly, this function just serve for the refresh page save audio locally
  const saveBlobToMP3 = (blob) => {
    if (blob) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const fileformat = userDataLocal?.AudioSet;
      link.download = `${nameSetbyTime(fileformat)}.mp3`; // Custom filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
    }
  };

  const nameSetbyTime = (fileformat) => {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based in JavaScript
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      let filename;
      if(fileformat === 'transcript') {
        filename = `transcript_${year}${month}${day}_${hour}${minute}`;
      } else {
        filename = `recorder_${year}${month}${day}_${hour}${minute}`;
      }
      return filename;
  }

// click Avatar to go to the home page

  const handleClickonAvatar = () => {
      window.location.href = '/home';
    };

  //2024.03.21 STT function
  const handleUpdateTextSTT = (newText) => {
    setRecognisingText(newText);
    textRef.current.scrollTop = textRef.current.scrollHeight
    // console.log("000 handleUpdateTextSTT running")
  };

  const handleUpdateRecognizedTextSTT = (transcriptionTxt) => {
    setRecognisingText('');
    setRecognisedText(transcriptionTxt);
    textRef.current.scrollTop = textRef.current.scrollHeight
    // console.log("111 handleUpdateRecognizedTextSTT running")
  }

  const handleStopSTT = () => {
    // console.log("222 Recognition stopped");
  };

  const handleStartSTT = () => {
    // Clear the recognisedText when starting a new transcription
    setRecognisedText('');
    setRecognisingText('');
    // console.log("333 handleStartSTT running");
    // setResponseText('');
  };

  //2024.03.28 Usage time limit
  // 检查并更新使用时长
  const checkAndUpdateTimeUsage = (mode) => {
    // 计算使用时长，以分minute为单位
    let MAX_USAGE;
    if (userVipLevel === 0) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_FREE;
    } else if (userVipLevel === 1) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP1;
    } else if (userVipLevel === 2) {
      MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP2;
    }
    // if(isRecognising){
      setUsingTime(Date.now());
      let useageTotal = 0;
      if (isRecognising && startTime){
        let usage = (Date.now() - startTime) / 60000;
        if (mode && mode === 'realTimeIntercom') usage = usage * 5; // realtime intercom mode, usage is 5 times than normal mode
        usage = Math.round(usage * 100) / 100;
        useageTotal = (userDataLocal?.Usage?.time || 0) + usage;
      } else {
        useageTotal = userDataLocal?.Usage?.time || 0;
      }
      if (useageTotal > MAX_USAGE) {
        return false;
      } else {
        return true;
      }
    // }
  };

  const createHistoryRecord = async (inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url, noteIDnum, videoURL, videoID, polishedText, title, subtitleWithTimestamp) => {
    await checkTokenMain();
    const end = new Date();
    // let diff = 0;
    // if (startTime && !endTime) {
    //   diff = end - startTime; // 时间差（毫秒）
    //   diff = diff / 60000;
    // }
    // let usage = diff;
    let usage = 0;
    // usage = Math.round(usage * 100) / 100;
    let textForGpt = subtitleWithTimestamp || inputValue;
    if (transcripts && transcripts.length > 0) {
      // 格式化时间戳函数 { role: "assistant", text: txtSys, timestamp: event.timestamp }
      const formatTimestamp = (timestamp) => {
        if (!timestamp) return "[00:00:00]";
        const date = new Date(timestamp);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `[${hours}:${minutes}:${seconds}]`;
      };
      
      // 生成带有时间戳范围的文本
      textForGpt = transcripts.map((item, index) => {
        const currentTimestamp = formatTimestamp(item.timestamp);
        let nextTimestamp;
        
        // 如果不是最后一条，使用下一条的时间戳作为结束时间
        if (index < transcripts.length - 1) {
          nextTimestamp = formatTimestamp(transcripts[index + 1].timestamp);
        } else {
          // 对于最后一条，可以使用当前时间或估算一个结束时间
          const endTime = new Date(item.timestamp);
          // 假设每条记录平均持续30秒
          endTime.setSeconds(endTime.getSeconds() + 30);
          nextTimestamp = formatTimestamp(endTime);
        }
        
        return `Time: ${currentTimestamp} - ${nextTimestamp} ${item.role === 'user' ? 'User: ' : 'Nvoice: '}${item.text}`;
      }).join('\n');
    } 
    // let offlineMode = false;
    if(realtimeBoolValue){
      if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
        //实时对讲模式的时间费率是正常模式的6倍:实时对讲+实时转写（5倍+1倍）
        usage = Math.round((usageSum / 5 + usageSum * 6)* 100) / 100;
      } else {
        usage = Math.round((usageSum / 5 + usageSum)* 100) / 100;
      }
      
    } else {
    // if (usageSum >0) {
      // offlineMode = true;
      // if (usageSum > 0) means the current Transcribe mode is Offline/Batch transcript
      // so we need to recalculate the usage, because the price of Offline/Batch mode is 1/5 vs Online mode.
      usage = Math.round(usageSum / 5 * 100) / 100;
    }

    if (usage > 0 && inputValue !== '') {

      if(transcribeID || noteIDnum) {
        const newRecord = { inputValue, usageSum, endTime, realtimeBoolValue, transcribeID, url, noteIDnum };
        // 检查是否已存在相同 transcribeID 的记录
        setDataSnapForCreateHistory((prevRecords) => {
          const recordExists = prevRecords.some(record => (transcribeID && transcribeID !== 'Failed' && record.transcribeID === transcribeID) || (noteIDnum && record.noteIDnum === noteIDnum));
          if (!recordExists) {
            return [...prevRecords, newRecord];
          } else {
          return prevRecords;
          }
        });
      }

      // 调用 getGPTResponse 函数获取 GPT 响应
      const gptVersion = getGptVersion();
      // const gptVersion = (!userDataLocal || userDataLocal?.GPTVersion==='GPT-3.5') ? 'gpt-3.5-turbo':userDataLocal?.GPTVersion.toLowerCase();
      await checkToken();
      getGPTResponse(textForGpt, userDataLocal?.SummarySet, userDataLocal?.SummaryLength, gptVersion, userDataLocal?.Language?.lan, userDataLocal?.GPTPromptContent||GPT_PROMPT_CONTENT.prompt, userVipLevel, polishedText, title, videoURL).then(result => {
        if((transcribeID || noteIDnum) && result) {
          setDataSnapForCreateHistory((prevRecords) => {
            return prevRecords.filter(record => (transcribeID && transcribeID !== 'Failed' && record.transcribeID !== transcribeID) || (noteIDnum && record.noteIDnum !== noteIDnum));
          });
        }
        console.log('result is:', result);
        let noteIDnumOK = noteIDnum;
        let noteIDChangedHere = false;

        if(noteIDnumOK && noteIDnumOK !== '' && noteIDnumOK !== null) {
          // nothing here
        } else {
          // noteIDnumOK = `${dateNumbers}${startTimeNumbers}${endTimeNumbers}${index}`;
          noteIDnumOK = gereatedUniqueNoteID();
          noteIDChangedHere = true;
        }
        let oldNote = userDataLocal?.History.map(historyItem => {
          if (historyItem.noteID === noteIDnumOK) {
            // 找到相同的 noteID，进行更新
            return historyItem;
          }});
        // 创建一个新的历史记录
        const endTimeDate = new Date(endTime); 
        let currentDate = new Date();
        let formattedDate = currentDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        formattedDate = endTime ? endTimeDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : formattedDate;
        let formattedStartTime;
        let formattedendTime = end.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        if( usageSum === 0 && startTime) {
          formattedStartTime = startTime.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        } else if( usageSum > 0 && endTime) {
          // const startTimett = new Date(currentDate.getTime() - usageSum * 60000);
          const startTimett = new Date(endTimeDate.getTime() - usageSum * 60000);
          formattedStartTime = startTimett.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
          formattedendTime = endTimeDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        }
        
        let tokensOfResultAndResponse = result.tokenusage + estimateTokens(inputValue) + estimateTokens(responseText) + (totalTTSToken || 0) + (tokensOFresponseFromAIWhenNotTranscribing || 0);

        if(result.tokenusage === 0) { 
          tokensOfResultAndResponse = 0;
        }
        
        // if (typeof tokensOfResultAndResponse === 'number' && !isNaN(tokensOfResultAndResponse)) {
        //   tokensOfResultAndResponse = parseInt(usageOfResultAndResponse);
        //   } else {
        //       console.error('tokensOfResultAndResponse 不是一个有效的数字');
        //   }

        // console.log('usage:', usage);
        // console.log('tokensOfResultAndResponse:', tokensOfResultAndResponse);
        // console.log('result.tokenusage:', result.tokenusage);
        // console.log('estimateTokens(inputValue):', estimateTokens(inputValue));
        // console.log('estimateTokens(responseText):', estimateTokens(responseText));
        // console.log('totalTTSToken:', totalTTSToken);
        // console.log('tokensOFresponseFromAIWhenNotTranscribing:', tokensOFresponseFromAIWhenNotTranscribing);
        //if GPT4 or GPT4o, 1000 token === 1 min usage
        let usageOfResultAndResponse = 0;
        //if GPT-3.5, 10000 token === 1 min usage
        //if GPT-4o mini or GPT-4.1-mini, 8000 token === 1 min usage 
        usage = (oldNote?.duration === usageSum && oldNote?.duration > 0) ? 0 : usage;
        if(userDataLocal?.GPTVersion==='GPT-3.5') {
          usageOfResultAndResponse = usage + tokensOfResultAndResponse/10000 + (totalTTSDuration || 0)/60;
        } else if(userDataLocal?.GPTVersion==='GPT-4o mini') {
          usageOfResultAndResponse = usage + tokensOfResultAndResponse/8000 + (totalTTSDuration || 0)/60;
        } else {
          usageOfResultAndResponse = usage + tokensOfResultAndResponse/1000 + (totalTTSDuration || 0)/60;
        }

        //保留小数点后两位
        if (typeof usageOfResultAndResponse === 'number' && !isNaN(usageOfResultAndResponse)) {
          usageOfResultAndResponse = Math.round(usageOfResultAndResponse * 100) / 100;
        } else {
            console.error('usageOfResultAndResponse is invalid number.');
        }

        // let newChapter = aiChatMessages || [];
        let newChapter = Array.isArray(aiChatMessages) ? JSON.parse(JSON.stringify(aiChatMessages)) : [];
        if(result?.chapters && result?.chapters !== 'Updating...') {
          const newGPTMessage = {
            id: Date.now()+1,
            user: 'Nvoice',
            avatar: nvoiceLogoImg,
            content: result.chapters,
            timestamp: Date.now(),
          };
          // newChapter = [...aiChatMessages, newGPTMessage];
          newChapter.push(newGPTMessage);
          // setAiChatMessages((prev) => {
          //   // newChapter = [...prev, newGPTMessage];
          //   return [...prev, newGPTMessage]
          // });
        }

        
        let offlineTranscribeTaskDone = inputValue && (inputValue?.includes('Speaker 0') || inputValue?.includes('Speaker 1') || inputValue?.includes('Speaker 2')) ? true : false;
        offlineTranscribeTaskDone = inputValue?.includes('Transcript updating...') || inputValue === 'Transcript updating...' ? false : offlineTranscribeTaskDone;
        const videoURLOK = (videoURL && videoURL !== '') ? videoURL : '';
        let newTranscriptBody = {
          noteID: noteIDnumOK,
          transcribeID: offlineTranscribeTaskDone ? 'Done' : transcribeID,
          inputValue: inputValue,
          transcript: inputValue,
          polishedText: userVipLevel === 0 ? '' : result?.polishedText,
          summary: result.summary.replace(/^Summary:/, '').replace(/\*\*/g, ''),
          gptresponse: userVipLevel === 0 ? '' : responseText.replace(/\*\*/g, ''),
          videoURL: videoURLOK,
          videoID: videoID,
          title: result.title.replace(/^Title:/, '').replace(/\*\*/g, ''),
          keywords: result.keywords.replace(/^Keywords:/, '').replace(/\*\*/g, ''),
          outline: result.outline.replace(/^Outline:/, '').replace(/\*\*/g, ''),
          message: newChapter,
          subtitleWithTimestamp: subtitleWithTimestamp,
        }

        // 将新的历史记录追加到 History 数组中
        // let updatedHistory = [...userDataLocal?.History, newHistory];
        // 检查是否已有相同的 noteID，若存在则更新，否则新增记录
        let newHistory = {
          title: result.title.replace(/^Title:/, '').replace(/\*\*/g, ''),
          date: oldNote.date || formattedDate,
          starttime: oldNote.starttime || formattedStartTime,
          endtime: oldNote.endtime || formattedendTime,
          transcript: '',
          polishedText: '',
          summary: '',
          gptresponse: '',
          keywords: result.keywords.replace(/^Keywords:/, '').replace(/\*\*/g, ''),
          outline: result.outline.replace(/^Outline:/, '').replace(/\*\*/g, ''),
          tokensusage: (oldNote?.tokensusage || 0) + tokensOfResultAndResponse,
          timeusage: (oldNote?.timeusage || 0) + usageOfResultAndResponse,
          noteID: noteIDnumOK,
          transcribeID: transcribeID,
          videoURL: videoURLOK,
          videoID: videoID,
          duration: usageSum
        };

        let found = false;
        let updatedHistory = userDataLocal?.History.map(historyItem => {
          if (historyItem.noteID === newHistory.noteID) {
            found = true;
            return { ...historyItem, ...newHistory };
          }
          return historyItem;
        });
        if (!found) {
          updatedHistory = [...updatedHistory, newHistory];
        }

        // 更新 History and Usage
        let updatedUsage = userDataLocal?.Usage?.time + usageOfResultAndResponse;
        let updateToken = userDataLocal?.Usage?.tokenusage + tokensOfResultAndResponse;

        // console.log('usage:', usage);
        // console.log('usageSum:', usageSum);
        // console.log('usageOfResultAndResponse is:', usageOfResultAndResponse);
        // console.log('tokensOfResultAndResponse is:', tokensOfResultAndResponse);
        // console.log('updatedUsage is:', updatedUsage);
        // console.log('updateToken is:', updateToken);
        // console.log('userDataLocal?.Usage?.time is:', userDataLocal?.Usage?.time);
        // console.log('userDataLocal?.Usage?.tokenusage is:', userDataLocal?.Usage?.tokenusage);

        if(updatedUsage <= userDataLocal?.Usage?.time && updateToken <= userDataLocal?.Usage?.tokenusage) {
          // console.log('updatedUsage is 0, will not update user data usage');
          // return;
        }

        // updatedUsage = Math.round(updatedUsage * 100) / 100;
        updatedUsage = Number(updatedUsage.toFixed(2));

        updateTranscriptionData(newTranscriptBody);
        //___________________________
        let indexOfNote = updatedHistory.findIndex(note => note.noteID === noteIDnumOK);
        // 如果没找到匹配项，说明是新记录，应该添加到列表末尾
        if (indexOfNote === -1) {
          // 将新记录添加到历史记录末尾
          updatedHistory.push(newHistory);
          indexOfNote = updatedHistory.length - 1; // 使用正确的索引值
        }
        const noteForHisotry = {
          noteIndex: indexOfNote, 
          noteData: newHistory
        }
        console.log('noteForHisotry is:', noteForHisotry);
        updateHistory(noteForHisotry);
        //___________________________

        updateUserFirestoreData({ 
          NotifyWhenUpdated: showNotificationPopup,
          History: updatedHistory,
          Usage: {
            time: updatedUsage,
            tokenusage: updateToken
          }})
        .then(() => {
          setTotalTTSDuration(0);
          setTotalTTSToken(0);
          tokensOFresponseFromAIWhenNotTranscribing = 0;
          resetUserInfo(updatedUsage);    //2024.06.01 update user data in local
          if(usageSum > 0) {
            setNeedUpdate(true);
          }
          setUserDataChangedAppPage(true); 

          if(transcribeID && url) {
            const audioName = url.split('/').pop();
            // handleRenameUploadedAudioFile(audioName, noteIDnumOK);
            if(noteIDChangedHere) {
              handleRenameUploadedAudioFile(audioName, noteIDnumOK);
            }
          } else {
            if(noteIDChangedHere) {
              setNoteIDOfCloudAudio(noteIDnumOK);
            }
          }

          if (videoURL && videoID && !polishedText) {
            const newVideoData = { PolishedText: result?.polishedText }
            updateVideoData(videoID, newVideoData);
          }
        }).catch(error => {
          console.error("Failed to update user data in Firestore", error);
          setUserDataChangedAppPage(false); 
          setNoteIDOfCloudAudio('');
        });
        if ((modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0) {
          //nothing here
        } else {
          setAiChatMessages([]);
        }
      });
    }
  };

  const gereatedUniqueNoteID = () => {
    let index = 0;
    if (userDataLocal?.History) {
      index = userDataLocal?.History?.length;
    }

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
  
    const dateNumbers = `${year}${month}${day}`;
    const timeNumbers = `${hours}${minutes}${seconds}${milliseconds}`;
    const indexString = String(index).padStart(7, '0');

    return `${dateNumbers}${timeNumbers}${indexString}`;
  }

  //——————————————————————————————————————————————————————————————————————————————————————————————————————————————
  // 2024.06.28 
  // 按照字节数估算token数量的函数
  const estimateTokens = (text) => {
    // 计算文本的字节数
    const byteSize = new Blob([text]).size;
    
    // 估算token数量，假设每个token大约4个字节
    const tokens = Math.ceil(byteSize / 4);
    
    return tokens;
  };

  // —————————————————————————————————————————————————————————————————————————————————————————————————————————————

  //2024.04.01 Create history record
  const getGPTResponse = async (transcript, rule, length, GPTVersion, language, systemPromptContent, userVipLevel, polishedText, title, videoURL) => {
    // 捕获调用栈

    // 添加文本长度检查
    const textLength = transcript.trim().length; // 直接计算字符数

    if(!transcript || transcript === 'Transcript updating...' || textLength < 10) {
      const result = {
        polishedText: polishedText || '',
        summary: 'Failed to process the request',
        outline: 'Updating...',
        title: title || 'Title updating...',
        keywords: 'Updating...',
        chapters: 'Updating...',
        tokenusage: 0
      };
      return result;
    }
    const stack = new Error().stack;
    // console.log('getGPTResponse called by:', stack);
    const token = await checkToken();
    const url = '/api/chatgpt';
    const requestOptions = {
      headers: { 
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`,
       },
    };
    const formattedSubtitles = transcript.replace('-__-', ' ');
    // console.log('formattedSubtitles:', formattedSubtitles);
    // console.log('language:', language);
    return await axios.post(url, { transcript: formattedSubtitles, rule, length, GPTVersion, language, systemPromptContent, userVipLevel, polishedText, title, videoURL }, requestOptions)
      .then(response => {
        // 处理响应
        // console.log('Response data:', response.data);
        const result = response.data;
        return result;
      })
      .catch(error => {
        // 根据错误对象展示更详细的信息
        if (error.response) {
          // 服务器响应了请求，但状态码不在2xx范围
          console.error('Server responded with status code:', error.response.status);
          console.error('Response data:', error.response.data);
        } else if (error.request) {
          // 请求已发出，但没有收到响应
          console.error('No response received:', error.request);
        } else {
          // 发送请求时出了点问题
          console.error('There was a problem with getGPTResponse:', error.message);
        }
        setErrorInfo('Network error. Note gereated failed.');
        setToastMessage('Network error. Note gereated failed. Try again later.' );
        setShowToast(true);
        const result = {
          polishedText: polishedText || '',
          summary: 'Failed to process the request',
          outline: 'Updating...',
          title: title || 'Title updating...',
          keywords: 'Updating...',
          tokenusage: 0
        };
        return result;
      });
  };

  const handleAvatarClick = () => {
    setShowPopup(true)
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setOpenPricePopup(false)
    setShowFaqsPopup(false);
    setShowTTSPopup(false);
  }

  //onClose for PricePopup
  const handlePriceClosePopup = () => {
    confirmDisplayed = false;
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setOpenPricePopup(false)
    setShowFaqsPopup(false);
    setShowTTSPopup(false);
    // setShowTestOnePopup(false);
    // setShowTestTwoPopup(false);
  }

  //onClose for FaqsPopup
  const handleCloseFaqsPopup = () => {
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setOpenPricePopup(false)
    setShowFaqsPopup(false);
    setShowTTSPopup(false);
    // setShowTestOnePopup(false);
    // setShowTestTwoPopup(false);
  }

  //onClose for WavRecorder 2024.05.08
  const handleCloseWavRecorder = () => {
    setShowSoundSignatureWavrecorder(false);
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setOpenPricePopup(false)
    setShowFaqsPopup(false);
    setShowTTSPopup(false);
  }
  

  //2024.04.12 onClose for UserpagePopup
  const handleCloseUserpagePopup  = () => {
    setShowPopup(false);
  }

  //2024.11.24 onClose for historyPopup
  const handleCloseHistoryPopup = () => {
    setShowHistoryPopup(false);
    setShowHistoryVariable(false);
  }

  const handleCloseSTTPopup = (shouldClose) => {
    if (shouldClose) {
      setShowSTTPopup(false);  //showSTTPopup
    } else {

    }
    setVideoURLUserPaste('');
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setOpenPricePopup(false)
    setShowFaqsPopup(false);
    setShowTTSPopup(false);
    setModeTitle('Transcribe');
    // setInterfaceContentByModeChanged('Transcribe');
    // changeSelectOption('Transcribe')
  }

  const handleCloseTTSPopup = () => {
    setShowPopup(false);
    setShowHistoryPopup(false);
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setOpenPricePopup(false)
    setShowFaqsPopup(false);
    setShowTTSPopup(false);
    setModeTitle('Transcribe');
    // setInterfaceContentByModeChanged('Transcribe');
    // changeSelectOption('Transcribe')
  }

  //showHistory
  const showHistoryForStt = (note) => {
    showHistory();
    if(note) {
      setTimeout(() => {
        // console.log("note is:", note);  
        setSelectedNote(note);
      }, 200);
    }
  }

  const showHistory = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    const netStatus = checkNetwork();
    if(!netStatus) {
      return;
    }
    setShowHistoryPopup(true)
    setShowPopup(false)
    setShowSettingsPopup(false);
    setShowPricePopup(false);
    setOpenPricePopup(false)
    setShowFaqsPopup(false);
    setShowTTSPopup(false);
  }

  //showSettings
  const showSettings = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    setShowSettingsPopup(true)
    setShowHistoryPopup(false)
    setShowPopup(false)
    setShowPricePopup(false);
    setShowFaqsPopup(false);
    setShowTTSPopup(false);
  }

   //showUpgrade
   const showUpgrade = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    setShowPricePopup(true);
    setShowSettingsPopup(false)
    setShowHistoryPopup(false)
    setShowPopup(false)
    setShowFaqsPopup(false);
    setShowTTSPopup(false);
    // setOpenPricePopup(false)
  }

  //showFaqs
  
  const showFaqs = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    setShowFaqsPopup(true);
    setShowPricePopup(false);
    setShowSettingsPopup(false)
    setShowHistoryPopup(false)
    setShowPopup(false)
    setShowTTSPopup(false);
    // setOpenPricePopup(false)
  }

  const showSTT = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    if(isRecognising || isAIthinking) {
      return
    }
    // if(userVipLevel === 0) {
    //   setNeedUpgradeUserLevel(true);
    //   return
    // }
    setSttPopupStatus(!sttPopupStatus);
    if(!showSTTPopup) {
      setTimeout(() => {
        setShowSTTPopup(true);
      }, 200);
    }
    setShowFaqsPopup(false);
    setShowPricePopup(false);
    setShowSettingsPopup(false)
    setShowHistoryPopup(false)
    setShowPopup(false)
    setShowTTSPopup(false);
    // console.log("showSTT running")
    // setOpenPricePopup(false)
  }

  const showTTS = () => {
    if(!isLoggedIn) {
      setNeedLogin(true);
      return
    }
    setShowTTSPopup(true);
    setShowFaqsPopup(false);
    setShowPricePopup(false);
    setShowSettingsPopup(false)
    setShowHistoryPopup(false)
    setShowPopup(false)
    
    // setOpenPricePopup(false)
  }

   //showTestOne showTestTwo
  //  const showTestOne = () => {
  //   setShowTestOnePopup(true)
  // }

  // const showTestTwo = () => {
  //   setShowTestTwoPopup(true)
  // 

  //2024.08.30 
  const audioNameForOfflineTrancriptionAndSTT = (name) => {
    setAudioNameForOfflineTrancription(name);
  }

  //2024.10.28
  //2024.08.30 
  const sttPopupMinOrMax = (minORMax) => {
    setSttPopupShowStatus(minORMax);
  }

  //settingpage save change call back
  const handleSaveChangeSettings = () => {
    setTimeout(() => {
      setShowSettingsPopup(false);
    }, 2);
  }

  //2024.03.30
  const handleSelectNote = (note) => {
    const netStatus = checkNetwork();
    if(!netStatus) {
      return;
    }
    setSelectedNote(note);
  };

  const handleCloseDetail = async(updatedNote, usage) => {
    setSelectedNote(null);
    if (updatedNote) {
      // console.log("updatedNote is:", updatedNote)
      // const updatedHistory = userDataLocal?.History.map(note => 
      //   note.noteID === updatedNote.id ? updatedNote : note
      // );

      let arrayNewHistory = userDataLocal?.History;
      let index = arrayNewHistory.findIndex(note => note.noteID === updatedNote.noteID);
      if (index === -1) {
          // 将新记录添加到历史记录末尾
          arrayNewHistory.push(updatedNote);
          index = arrayNewHistory.length - 1; // 使用正确的索引值
        } else {
          // 更新现有记录
          arrayNewHistory[index] = { ...arrayNewHistory[index], ...updatedNote };
        }
      
      //____________________________________________
      //2025.04.16
      const note = {
        noteIndex: index, 
        noteData: updatedNote
      }
      updateHistory(note);
      //____________________________________________
      
      // 更新 History and Usage
      setCurrentUpdateReason('noteDetailChanged');
      updateUserFirestoreData({ 
        History: arrayNewHistory,   //2025.04.16
        Usage: usage || userDataLocal.Usage
        })
        .then(() => {
          resetUserInfo();    //2024.06.01 update user data in local
          setUserDataChangedAppPage(true); 
        }).catch(error => {
          console.error("Failed to update user data in Firestore", error);
          setUserDataChangedAppPage(false); 
        });
    }
    setTimeout(() => {
      showHistory();
      // setUserDataChangedAppPage(false);
    },[20]);
    
  };

  //2024.04.27
  const handleCongratulationsClosePopup = () => {
    setShowCongratulationsPopup(false);
  }


  //2024.04.12 confirm dialog
  const accept = () => {
    confirmDisplayed = false;
    // toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    setShowPricePopup(true);
  }

  const reject = () => {
    confirmDisplayed = false;
    setShowPricePopup(false);
    setOpenPricePopup(false);
    // console.log('reject upgrade');
      // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
  }

  const confirm = (tipText) => {
      confirmDialog({
          message: tipText,
          header: () => <div className='confirm-popup-title'>Upgrade Account</div>,
          onHide: reject(),
          className: 'confirm-popup-style',
          acceptClassName: 'confirm-popup-buttonOK',
          rejectClassName: 'confirm-popup-buttonCancel',
          accept,
          reject
      });
  };

  //2024.04.26 payment confirm popup
    const acceptpayment = () => {
      confirmDisplayed = false;
      setShowPricePopup(false);
      handlePriceClosePopup();
      setShouldCheckPaymentUpdate(true);
      // if(!isLoading && !isRecognising) {
        setLoadingText('Retrieving payment data...');
        setIsLoading(true);
        // console.log('accept upgrade, loading tip displayed');
      // }
      // toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    }
  
    const rejectpayment = () => {
      confirmDisplayed = false;
      setShouldCheckPaymentUpdate(false);
      setLoadingText('Done!');
          setIsLoading(false);

      // console.log('reject upgrade');
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }
  
    const confirmpayment = (tipTextpayment) => {
        confirmDialog({
            message: tipTextpayment,
            header: () => <div className='confirm-popup-title'>Confirmation</div>,
            onHide: rejectpayment(),
            className: 'confirm-popup-style',
            acceptClassName: 'confirm-popup-buttonOK',
            rejectClassName: 'confirm-popup-buttonCancel',
            rejectLabel: 'Failure',
            acceptLabel: 'Success',
            accept: acceptpayment,
            reject: rejectpayment,
        });
    };

    //____________________________________________________________________________________________________________________
    //2024.08.05 Notification confirm popup
    //2024.04.12 confirm dialog
    const acceptNotefication = () => {
      confirmDisplayed = false;
      setTimeout(() => {
        setShowNotificationPopup(true);
      }, 20);
    }

    const rejectNotefication = () => {
      confirmDisplayed = false;
      setShowNotificationPopup(false); 
    }

    const confirmNotification = (tipTextNoification) => {
        confirmDialog({
            message: tipTextNoification,
            header: () => <div className='confirm-popup-title-left'>Set a reminder?</div>,
            onHide: rejectNotefication,
            className: 'confirm-popup-style-left',
            acceptClassName: 'confirm-popup-buttonOK',
            rejectClassName: 'confirm-popup-buttonCancel',
            rejectLabel: 'Cancel',
            acceptLabel: 'OK',
            accept: acceptNotefication,
            reject: rejectNotefication,
        });
    };

    const acceptGotoHistory = () => {
      confirmDisplayed = false;
      setShowHistoryVariable(true);
      // console.log('accept goto history');
    }

    const rejectGotoHistory = () => {
      confirmDisplayed = false;
    }

    const gotoHistoryNotification = (tipTextGotoHistory) => {
        confirmDialog({
            message: tipTextGotoHistory,
            header: () => <div className='confirm-popup-title-left'>Processing completed.</div>,
            onHide: rejectGotoHistory,
            className: 'confirm-popup-style-left',
            acceptClassName: 'confirm-popup-buttonOK',
            rejectClassName: 'confirm-popup-buttonCancel',
            rejectLabel: 'Cancel',
            acceptLabel: 'OK',
            accept: acceptGotoHistory,
            reject: rejectGotoHistory,
        });
    };
    

    //2024.05.06 mode change

    // const changeSelectOption = (newValue) => {
    //   if (selectRef.current) {
    //     selectRef.current.value = newValue;
    //     handleModeChange(newValue);  // 手动调用处理函数
    //   }
    // };

    // const handleModeChange = (mode) => {
    //   setModeTitle(INTERFACE_CONTENT_TEXT[mode][0]);
    //   if(!isLoggedIn) {
    //     setModeTitle('Transcribe');
    //     setNeedLogin(true);
    //     return
    //   }
    //   if (userVipLevel === 0 && mode !== 'Transcribe'){
    //     setNeedUpgradeUserLevel(true);
    //     setModeTitle('Transcribe');
    //     return;
    //   } else if (userVipLevel === 1 && mode !== 'Transcribe' &&  mode !== 'Interview' ){
    //     setNeedUpgradeUserLevel(true);
    //     setModeTitle('Transcribe');
    //     return;
    //   } else {
    //     setNeedUpgradeUserLevel(false);
    //   }
    //   // console.log("mode is:", mode)
    //   setInterfaceContentByModeChanged(mode);
    //   switch (mode) {
    //     case "Transcribe":
    //       break
    //     case "Interview":
    //       // setShowSoundSignatureWavrecorder(true);
    //       break
    //     case "STT":
    //       showSTT();
    //       break
    //     case "TTS":
    //       showTTS();
    //       break
    //     case "VoiceIntercom":
    //       setNeedResetGPTPrompt(true);
    //       break
    //     default:
    //         break
    //   }
    // }

    const setInterfaceContentByModeChanged = (mode) => {
      setModeTitle(INTERFACE_CONTENT_TEXT[mode][0]); //AI changes everything, AI achieves everything
      setInterviewerTitle(INTERFACE_CONTENT_TEXT[mode][1]);
      setInterviewerTranscriptPlaceholdText(INTERFACE_CONTENT_TEXT[mode][2]);
      setAiResponseTitle(INTERFACE_CONTENT_TEXT[mode][3]);
      setAiResponsePlaceholdText(INTERFACE_CONTENT_TEXT[mode][4]);
      setIntervieweeTitle(INTERFACE_CONTENT_TEXT[mode][5]);
      setIntervieweeTranscriptPlaceholdText(INTERFACE_CONTENT_TEXT[mode][6]);
    }

    //2024.05.15 privilege check when user change AI lauanch mode(level===0 not allow to use selction launch AI)
    const selectOrKeywordsLanuchAI = (AILaunchMode) => {
      if(!isLoggedIn) {
        setNeedLogin(true);
        return
      }
      switch (AILaunchMode)
        {
          case 'AI':
            if (userVipLevel === 0){
              setNeedUpgradeUserLevel(true);
              setCallGptByAI(false);
            } else {
              setCallGptByAI(true);
              setCallGptByKeywords(false);
              setCallGptByEnter(false);
              setCallGptBySelct(false);
            }
            setShowSelectTextPopup(false);
            break
          case "Keywords":
            setCallGptByKeywords(true);
            setCallGptByAI(false);
            setCallGptBySelct(false);
            setShowSelectTextPopup(false);
            setCallGptByEnter(false);
            break
          case "Select":
            // if (userVipLevel === 0){
            //   setNeedUpgradeUserLevel(true);
            //   setCallGptBySelct(false);
            // } else {
              setCallGptBySelct(true);
              setCallGptByEnter(false);
              setCallGptByKeywords(false);
              setCallGptByAI(false);
            // }
            break
          case "Enter":
            if (userVipLevel === 0){
              setNeedUpgradeUserLevel(true);
              setCallGptByEnter(false);
            } else {
              setCallGptByEnter(true);
              setCallGptByKeywords(false);
              setCallGptByAI(false);
              setCallGptBySelct(false);
              setShowSelectTextPopup(false);
            }
            break
          default:
            break
        }
    }

    //2024.05.07 upgrade button title
    const resetUserInfo = (updatedUsage) => {
      let MAX_USAGE;
      if (userVipLevel === 0) {
        MAX_USAGE = process.env.REACT_APP_MAX_USAGE_FREE;
      } else if (userVipLevel === 1) {
        MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP1;
      } else if (userVipLevel === 2) {
        MAX_USAGE = process.env.REACT_APP_MAX_USAGE_VIP2;
      }
      
      if (signInStatus){
        if (updatedUsage > 0 || userDataLocal?.Usage?.time >= 0 ) {
          let time = Math.floor(updatedUsage || userDataLocal?.Usage?.time);
          setUsageStatus(`${time} of ${MAX_USAGE} monthly minutes used`);
          setUsageMax(MAX_USAGE);
          setUsageTime(time);
        } else {
          // console.log('userDataLocal?.Usage.time is:', userDataLocal?.Usage);
          console.log('usage data error');
        }
      }

      if (userDataLocal?.VIPLevel > 0 && userDataLocal?.VIPLevel <= 3){
        const date = new Date(userDataLocal?.ExpiredTime);
        // const formattedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });

        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
        const day = String(date.getUTCDate()).padStart(2, '0');
        const year = date.getUTCFullYear();
        const formattedDate = `${month}/${day}/${year}`;

        // console.log('formattedDate:', formattedDate);
        // console.log('userDataLocal?.ExpiredTime:', userDataLocal?.ExpiredTime);

        setExpireTime(formattedDate);
        if (userDataLocal?.VIPLevel > 0){
            // setVipLevelString('VIP');
            if (userDataLocal?.CurrentPlanVariantName) {
              if(userDataLocal?.CurrentPlanVariantName === 'Yearly' || userDataLocal?.CurrentPlanVariantName === 'Nvoice VIP yearly plan' || userDataLocal?.CurrentPlanVariantName === 'Nvoice Business yearly plan') {
                setVipLevelString('Annual VIP');
              } else {
                setVipLevelString('Monthly VIP');
              }
            } else {
              setVipLevelString('Monthly VIP');
            }
            // setUpgradeBtnTitle('Upgrade to Business');
            setUpgradeBtnTitle('Renew payment');
          } 
          // else if (userDataLocal?.VIPLevel === 2){
          //   setVipLevelString('Business VIP');
          //   setUpgradeBtnTitle('Renew payment');
          // }
      } else {
        setVipLevelString('Free User');
      }
    };
  // ———————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————— 
    //2024.05.08 Voice Signature Audio save
    // const handleSaveVoiceSignatureAudio = (waveRecoderAudioBlob, duration) => {
    //   if (duration < 30) {
    //     setToastMessage("The audio time is too short, which may lead to inaccurate speaker recognition. Please re-record.");
    //     setShowToast(true);
    //   } else {
    //     // console.log('audioBuffer duration:', duration)
    //     setAudioBlob(waveRecoderAudioBlob);
    //     const formData = new FormData();
    //     formData.append('audioFile', waveRecoderAudioBlob, 'recorded.wav');
    //     axios.post('/api/create-voicesignature', formData, {
    //       headers: {
    //         'Content-Type': 'multipart/form-data',
    //       },})
    //       .then(response => {
    //         setToastMessage('Voice Signature Successfully!' );
    //         // setVoiceSignatureStrings(response.data.voiceSignature);
    //         setVoiceSignatureStrings(prevVoiceSignatureStrings => [...prevVoiceSignatureStrings, response.data.voiceSignature]);
    //         setShowToast(true);
    //       })
    //       .catch(error => {
    //         // console.error('Network error:', error);
    //         setToastMessage('Network error, please try again later!' );
    //         setShowToast(true);
    //       });
    //     }
    // }

  // ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————  
  //2024.05.09 ConversationTranscriber Test Code
  const createMeetingRecognizer = async (stream) => {
    // console.log("createMeetingRecognizer running");
    const config = await fetch('/api/speech-config').then(response => response.json());
    // 使用配置信息初始化 SpeechRecognizer
    var speechConfig = sdk.SpeechConfig.fromSubscription(config.subscriptionKey, config.serviceRegion);
    var audioConfig = sdk.AudioConfig.fromStreamInput(stream)
    speechConfig.speechRecognitionLanguage = [userDataLocal?.Language?.code||'en-US']; 

    if (transcriber) {
      transcriber.stopTranscribingAsync();
      transcriber.close();
      setTranscriber(null);
    }

    let transcriberNow = new sdk.ConversationTranscriber(speechConfig, audioConfig);
    setTranscriber(transcriberNow);
    transcriberNow.transcribing = function(s, e) {
      // console.log("(transcribing) text: " + e.result.text);
      // console.log("(transcribing) speakerId: " + e.result.speakerId);
      let spkiding = e.result.speakerId;

      // console.log("(transcribed) speakerId: " + spkid);

      if (spkiding === 'Guest-1'){
        spkiding = 'Candidate' 
      } else {
        spkiding = 'Interviewer'
        }
      setAudioDetected(true)
      if(spkiding !== 'Candidate') {
        setRecognisingText(e.result.text)
      } else {
        setRecognisingTextYouSay(e.result.text)
      }
      textRefYouSay.current.scrollTop = textRefYouSay.current.scrollHeight
      textRef.current.scrollTop = textRef.current.scrollHeight
    };

    transcriberNow.transcribed = function(s, e) {
      // console.log("(transcribed) text: " + e.result.text);
      // console.log("(transcribed) speakerId: " + e.result.speakerId);
      // let spkid = e.result.participantId
      let spkid = e.result.speakerId;

      // console.log("(transcribed) speakerId: " + spkid);

      if (spkid === 'Guest-1'){
        spkid = 'Candidate' 
        setCurrentSpeaker('Candidate')
      } else {
          spkid = 'Interviewer'
          setCurrentSpeaker('Interviewer')
        }
      console.log("spkid is:", spkid)
      console.log("transcribed:", e.result.text)
      setAudioDetected(true)
      setRecognisingText("")
      setRecognisingTextYouSay("")

      if (e.result.reason === sdk.ResultReason.RecognizedSpeech) {
        checkAndUpdateTimeUsage();
        if(spkid !== 'Candidate') {
          setRecognisedText((recognisedText) => {
            return getRecognisedText(recognisedText)
          })
        } else {
          setRecognisedTextYouSay((recognisedTextYouSay) => {
            return getRecognisedText(recognisedTextYouSay)
          })
        }
        function getRecognisedText (textValue) {
          let returnText = ''
          let fetchFuncParaStr = ''
          let tempText = `${e.result.text}`;
          const offset = Math.floor(e.result.offset / Math.pow(10, 7));
          const offsetHhMmSs = seconds_to_hhmmss(offset);
          if(modeTitle === 'Interview' || transcriber !== null) {
            tempText= `${offsetHhMmSs} ${e.result.text} \n`
          } 
          // console.log("tempText is:", tempText);
          // console.log('modeTitle is:', modeTitle);
          // console.log('currentSpeaker is:', currentSpeaker);
          // console.log('offsetHhMmSs is:',offsetHhMmSs);
          if (textValue === '') {
              returnText= tempText
          } else {
              returnText = `${textValue}${tempText} `
          }
          fetchFuncParaStr = `${e.result.text} `
          // console.log("callGptFunc running", countFetch+1)
          // let keywords = GPT_PRE_KEYWORDS[userDataLocal?.Language.code||'en-US'];
          let keywords = keywordsPreCallGpt;

          countFetch++;
          if (countFetch === 2) {
            countFetch = 0
          } //保证对GPT的调用不重复

          let foundKeywords = false;

          for (let i = 0; i < keywords.length; i++) {

            const regex = new RegExp(keywords[i], 'gi'); // 'g' 表示全局搜索
            let match;
            while ((match = regex.exec(fetchFuncParaStr)) !== null) {
              foundKeywords = true;
              break;
            }
            if (foundKeywords) {
              break;
            }

            // if (fetchFuncParaStr.charAt(fetchFuncParaStr.length-2).toLowerCase() === keywords[i].toLowerCase()) {
            //   if (countFetch === 1) {
            //     // console.log("\n    fetchFuncParaStr is:", fetchFuncParaStr)
            //     // console.log("\n    prekeywords[i] is:", keywords[i])
            //   if (modeTitle === 'Interview' || modeTitle === 'Transcribe') {
            //       callGptFunc(fetchFuncParaStr)
            //     }
                
            //     break; // 找到关键词后退出循环
            //   }
            // }
          }
          if (foundKeywords) {
            if(currentSpeaker === 'Candidate') {
              //not need callGpt
            } else if (modeTitle === 'Interview' || modeTitle === 'Transcribe') {
              callGptFunc(fetchFuncParaStr)
            }
          }
          return returnText;
        }
        
        textRef.current.scrollTop = textRef.current.scrollHeight
        textRefYouSay.current.scrollTop = textRefYouSay.current.scrollHeight
      }
      else if (e.result.reason === sdk.ResultReason.NoMatch) {
        // console.log("NOMATCH: Speech could not be recognized.")
      }
    }

  }

  const stopTranscribingAsync = () => {
    if(transcriber) transcriber.stopTranscribingAsync();
  }

  const startTranscribingAsync = () => {
    if(transcriber) {
      transcriber.startTranscribingAsync(
        function () { },
        function (err) {
          console.trace("err - starting transcription: " + err);
          // Add error handling code here
        }
      )
    }
  }
// ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————

// ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
//2024.05.10 Error: Single channel audio configuration for MeetingTranscriber is currently under private preview,
//please contact diarizationrequest@microsoft.com for more details
  // useEffect(() => {
  //   if (!isRecognising ) return;

  //   const subscriptionKey = process.env.REACT_APP_COG_SERVICE_KEY;
  //   const region = process.env.REACT_APP_COG_SERVICE_LOCATION;

  //   // const audioConfig = sdk.AudioConfig.fromStreamInput(new sdk.PushAudioInputStream(audioBlob));
  //   // const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();
  //   const audioConfig = sdk.AudioConfig.fromStreamInput(audioStream)

  //   const speechTranslationConfig = sdk.SpeechTranslationConfig.fromSubscription(subscriptionKey, region);
  //   speechTranslationConfig.setProperty("ConversationTranscriptionInRoomAndOnline", "true");
  //   speechTranslationConfig.speechRecognitionLanguage = "en-US";

  //   // create meeting and transcriber
    // const meeting = sdk.Meeting.createMeetingAsync(speechTranslationConfig, "myMeeting");
    // const transcriber = new sdk.MeetingTranscriber(audioConfig);

  //   // attach the transcriber to the meeting
  //   transcriber.joinMeetingAsync(meeting,
  //     function () {
  //       // add first participant using voiceSignature created in enrollment step
  //       const user1 = sdk.Participant.From("user1@example.com", "en-us", voiceSignatureStrings[0]);
  //       meeting.addParticipantAsync(user1,
  //         function () {
  //           // add second participant using voiceSignature created in enrollment step
            
  //               transcriber.sessionStarted = function(s, e) {
  //                 console.log("(sessionStarted)");
  //               };
  //               transcriber.sessionStopped = function(s, e) {
  //                 console.log("(sessionStopped)");
  //               };
  //               transcriber.canceled = function(s, e) {
  //                 console.log("(canceled)");
  //               };
  //               transcriber.transcribed = function(s, e) {
  //                 console.log("(transcribed) text: " + e.result.text);
  //                 console.log("(transcribed) speakerId: " + e.result.speakerId);
  //               };

  //               // begin meeting transcription
  //               transcriber.startTranscribingAsync(
  //                 function () { },
  //                 function (err) {
  //                   console.trace("err - starting transcription: " + err);
  //                 });
  //     },
  //     function (err) {
  //       console.trace("err - adding user2: " + err);
  //     });
  //     },
  //     function (err) {
  //     console.trace("err - " + err);
  //     });

  //   return () => {
  //     transcriber.stopTranscribingAsync();
  //   };
  // }, [isRecognising, voiceSignatureStrings, audioStream]);
// ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————

//2024.05.19 left panel subscription card(Left-menu panel hide/show function)
const handleToggleLeftPanel = () => {
  setIsLeftPanelVisible(!isLeftPanelVisible);
};

//2024.05.21 Transcript Panel panel toggle(Interveiwer panel hide/show function)
const handleToggleTranscriptPanel = () => {
  setIsTranscriptPanelVisible(!isTranscriptPanelVisible);
};

//2024.12.06 AIResponse Panel  toggle(AI Feedback panel hide/show function)
const handleToggleAIResponsePanel = () => {
  setIsAIResponsePanelVisible(!isAIResponsePanelVisible);
};

// ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
//2024.06.03 Auto play audio
const handleAudioPlayEndChange = (newAudioPlayEnd) => {
  // 在这里处理 audioPlayEnd 变量的变化
  setAudioPlayEnd(newAudioPlayEnd);
};

const handleAutoPlayAudio = async (audioScriptNeedPlay) => {
  setAudioPlayEnd(false);
  await handleConvertText(audioScriptNeedPlay, handleAudioPlayEndChange);
};

const handleAudioPlayOrPause = () => {
  stopAudio(handleAudioPlayEndChange);
};
// ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
//2024.06.21 Play/Pause audio function for Voice Intercom mode (ai response and audio generated by openAI api together in server side)
const handleSkipPlayingAudio = () => {
  if (audioRef.current) {
    audioRef.current.pause();
    setAudioPlayEnd(true);
  }
};

const handleAudioEnded = () => {
  setAudioPlayEnd(true);
};
// ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
//2025.02.24 
const handleUrlChange = (e) => {
  setVideoURLUserPaste(e.target.value);
};

const handleUrlInputButtonClick = () => {
  if (videoURLUserPaste === '' || !videoURLUserPaste.includes('https://' || 'http://')) {
    setToastMessage('The address entered is invalid, please try again.');
    setShowToast(true);
    return;
  }
  showSTT();
}

// ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
//2025.04.20 OpenAI Batch
  /* ------------------ 启动 GPT Batch 并批量写历史 ------------------ */
  const startGPTBatch = async (batchQueue, recoverBatchId = null, recoverStatus = null, gptBatchTaskID = null, transcribeHistoryStatus = null, batchQueuegptResults = null) => {
    let batchQueueId = recoverBatchId || `batch_${Date.now()}`;
    const uid = user.uid;
    if(!recoverBatchId){
        try {
          await upsertBatchQueue(
            batchQueueId,
            {
              status: 'waiting_transcribe',
              transcripts: batchQueue,
              createdAt: Date.now()
            }
          );
        } catch (err) {
          console.error("Failed to upsert batch queue:", err);
          setBatchStarted(false);
          setToastMessage('Failed to sync batch task to cloud.');
          setShowToast(true);
          return;
        }
      }
    if(batchStarted && currentBatchTaskInfo.current) return;
    transcriptsForBatch.current = batchQueue; //batchQueue it's a array only including all the transcript data: ({ id: videoID,  transcript: newText,  noteIDnum: noteIDnumOK, transcribeID: id,  url,  videoURL,  videoID,  duration,  endTime: Date.now(),  ealtimeBoolValue: false,  polishedText,  title,  subtitleWithTimestamp })
    
    setBatchStarted(true);
    setToastMessage('Batch task is starting...');
    setShowToast(true);
  
    currentBatchTaskInfo.current ={batchQueueId, status: 'started'};
    // —— 新增：检测是否为 mock 模式 ——  
    // const isMockMode = batchQueue.some(item => item.videoURL?.includes('&gptBatchMode=mock'));
    // const isMockMode = !batchQueue.some(item => item.videoURL?.includes('&gptBatchMode=openAI'));
    const queue = Array.isArray(batchQueue) ? batchQueue : [];
    const isMockMode = !queue.some(item => item.videoURL?.includes('&gptBatchMode=openAI'));
    if (isMockMode) {
      console.log('Batch task is starting in mock mode...');
    } else {
      console.log('Batch task is starting in openAI mode...');
    }

    console.log("Batch task started with ID:", batchQueueId, 'in  currentTime is:', new Date().toLocaleTimeString());
    // 1. 云端同步：批量任务入队
    // if(!gptBatchTaskID) {
    //   if (!recoverBatchId) {
    //     try {
    //       await upsertBatchQueue(
    //         batchQueueId,
    //         {
    //           status: 'waiting_transcribe',
    //           transcripts: transcriptsForBatch.current,
    //           createdAt: Date.now()
    //         }
    //       );
    //     } catch (err) {
    //       console.error("Failed to upsert batch queue:", err);
    //       setBatchStarted(false);
    //       setToastMessage('Failed to sync batch task to cloud.');
    //       setShowToast(true);
    //       return;
    //     }
    //   }
    // }

    try {
      let gptBatchId = gptBatchTaskID || null;
      // 2. 等待所有转写任务完成
      // 找到所有 transcript 为 'Transcript updating...' 的项
      const originalQueue = [...transcriptsForBatch.current];
      const needWaitList = originalQueue.filter(t => 
        t.transcript === 'Transcript updating...' && t.transcribeID !== 'Done'
      );
      if (needWaitList.length > 0)  {
        // 并发等待所有转写任务完成，并收集最新结果  
        console.log("Need wait for transcribe task:", needWaitList, 'currentTime is:', new Date().toLocaleTimeString());
        const updatedResults = await Promise.all(
          needWaitList.map(async meta => {
            try {
              const result = await waitForTranscript(meta.transcribeID);
              // 如果超时返回 null，避免直接读取属性时报错
              if (!result) {
                console.error(`transcribeID ${meta.transcribeID} 未返回结果，已超时或出错`);
                return meta;
              }
              return {
                ...meta,
                transcript: result.transcriptionText,
                subtitleWithTimestamp: result.subtitleWithTimestamp,
                transcribeID: 'Done' 
              };
            } catch (err) {
              console.error("Failed to wait for transcript:", err);
              return meta;
            }
          })
        );

        transcriptsForBatch.current = originalQueue.map(item => {
          const upd = updatedResults.find(u => u.id === item.id);
          return upd || item;
        }).filter(item => item.transcript !== 'Transcription task not found.');
      }

      console.log("No transcribe task need wait or all of transcribe task have been done.", 'currentTime is:', new Date().toLocaleTimeString());

      // console.log("Batch task updated with transcribe results:", transcriptsForBatch.current, 'currentTime is:', new Date().toLocaleTimeString());
      // 3. 为已完成转写的任务批量创建历史记录
      //______________________________________
      //2025.04.27
      if (transcribeHistoryStatus !== 'completed') {
        const recordsForTranscribeResults=[];
        transcriptsForBatch.current.forEach(m=>{
          const sum = Math.round(m.duration / 60 * 100) / 100 || 0;
          // 合并数据
          recordsForTranscribeResults.push({
            inputValue: m.transcript,
            usageSum: sum,
            endTime: m.endTime,
            realtimeBoolValue: false,
            transcribeID: m.transcribeID||"Done",
            url: m.url||"",
            noteIDnum: m.noteIDnum,
            videoURL: m.videoURL,
            videoID: m.videoID,
            polishedText: m.polishedText||"",
            title: m.title||"",
            subtitleWithTimestamp: m.subtitleWithTimestamp||"",
            summary: "",
            keywords: "",
            outline: "",
            chapters: "",
            gptError: "",
            tokenUsage: 0
          });
          const transcript = m.transcript;
          //_____________________________________
          //2025.04.27 Update video data and transcript
          const subtitleWithTimestamp = m.subtitleWithTimestamp;
          const newVideoData = { Transcript: transcript, subtitleWithTimestamp: subtitleWithTimestamp}
          updateVideoData(m.id, newVideoData);
          // updateTranscription(transcript, id, audioURL, polishedText, videoURL, videoID, duration, title, noteIDnum, subtitleWithTimestamp);
          // handleDeleteTranscription(id);
          // handleDeleteUploadedAudioFile();
          //_____________________________________
        });

        if(recordsForTranscribeResults.length){
          try {
            await batchCreateHistory(recordsForTranscribeResults);
            await upsertBatchQueue(batchQueueId, { transcribeHistoryStatus: 'completed' });
          } catch (err) {
            console.error("Failed to batch create history when all of the transcribe task done:", err);
            await upsertBatchQueue(batchQueueId, { transcribeHistoryStatus: 'failed', error: `Failed to batch create history when all of the transcribe task done. Error: ${err.message}`});
            currentBatchTaskInfo.current ={batchQueueId, transcribeHistoryStatus: 'failed'};
          }
        }
      }
      //______________________________________

      // 4. 云端同步：转写完成，转写任务已创建历史记录，准备提交GPT
      try {
        await upsertBatchQueue(
          batchQueueId,
          {
            status: 'transcribe_createHistory_batch_done',
            transcripts: transcriptsForBatch.current
          }
        );
      } catch (err) {
        console.error("Failed to upsert batch queue:", err);
        setBatchStarted(false);
        setToastMessage('Failed to sync batch task to cloud.');
        setShowToast(true);
        return;
      }

      // 5. 批量提交 GPT 任务
      // 5.1 检查是否已经提交过 GPT 任务
      // 5.2 如果没有提交过，创建新的 GPT 任务  
      // 5.3 如果已经提交过，直接使用现有的 GPT 任务 ID
      if(recoverStatus !== 'gpt_batch_submitted' && !gptBatchId) {
        try {
          const token = await checkToken();
          // const history = transcriptsForBatch.current.map(t => ({ id: t.id, transcript: t.subtitleWithTimestamp || t.transcript }));
          const history = transcriptsForBatch.current
            // 只保留已经完成转写且带有效时间戳的项
            .filter(t =>
              t.transcript && 
              t.transcript !== 'Transcript updating...' && 
              t.transcript !== '' && 
              t.subtitleWithTimestamp && 
              t.subtitleWithTimestamp !== '' && 
              t.subtitleWithTimestamp !== 'Updating...'
            )
            .map(t => ({
              id: t.id,
              transcript: t.subtitleWithTimestamp || t.transcript
            }));
          // const res = await axios.post(isMockMode ? "/api/mbatch/start" :"/api/batch/start", { history });
          const res = await axios.post(
            isMockMode
              ? "/api/mbatch/start"
              : "/api/batch/start",
            { uid, history, batchQueueId },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
              }
            }
          );
          gptBatchId = res.data.batch_id;
        } catch (err) {
          console.error("Failed to start GPT batch:", err);
          setBatchStarted(false);
          setToastMessage('Failed to start GPT batch.');
          setShowToast(true);
          // 标记云端任务为失败
          await upsertBatchQueue(batchQueueId, { status: 'failed', error: `Failed to start GPT batch. Error: ${err.message}` });
          currentBatchTaskInfo.current ={batchQueueId, status: 'failed'};
          return;
        }
        console.log("Batch task created with GPT ID:", gptBatchId, 'currentTime is:', new Date().toLocaleTimeString());
      }
      
      // 5. 云端同步：GPT任务已提交
      try {
        await upsertBatchQueue(
          batchQueueId,
          {
            status: gptBatchId ? 'gpt_batch_submitted' : 'transcribe_batch_done',
            gptBatchId,
            gptBatchIdCreatedAt: gptBatchTaskID ? batchQueueId.gptBatchIdCreatedAt : (gptBatchId ? Date.now() : null)
          }
        );
        if(!gptBatchId) {
          setToastMessage('Batch task is waiting for GPT.');
          setShowToast(true);
          return;
        }
        
      } catch (err) {
        console.error("Failed to upsert batch queue:", err);
      }

      console.log("Batch task submitted to GPT with ID:", gptBatchId, 'Next we will wait for the GPT Batch task to complete, currentTime is:', new Date().toLocaleTimeString());


      const AXIOS_TIMEOUT    = 30_000;         // 30 s 单次请求超时
      const ERROR_STATUSES   = ['failed', 'cancelled', 'canceled', 'expired'];
      const CANCEL_MAX_WAIT   = 600_000;        // 取消流程最多再等 10 min

      /* ───────────────────────────────触发取消 + 轮询取消结果─────────────────────────────── */
      async function cancelBatchAndFetch(batchId) {
        const start = Date.now();
        let tries   = 0;
        let delay   = BASE_DELAY;

        // 第一次循环里先发送“取消”请求
        while (true) {
          tries += 1;

          if (tries === 1) {
            console.warn(`[cancel] send cancel request ...`);
            await axios.post(`/api/batch/cancel/${batchId}`,
              null,
              { timeout: AXIOS_TIMEOUT }
            );                                                       // 服务端会把批置为 cancelling  [oai_citation:0‡OpenAI Platform](https://platform.openai.com/docs/api-reference/fine-tuning/completions-input?utm_source=chatgpt.com)
          }

          /* 取得最新状态 / 结果 */
          let data;
          try {
            const res = await axios.get(`/api/batch/status/${batchId}`,
              { timeout: AXIOS_TIMEOUT }
            );
            data = res.data;
          } catch (e) {
            console.error('[cancel] status request error:', e.message);
            throw e;
          }

          console.log(`[cancel] status = ${data.status}`);

          /* 已进入终止态：直接返回（可能含部分结果） */
          if (['completed', 'cancelled', 'canceled', 'failed', 'expired']
              .includes(data.status)) {
            console.log(
              `[cancel] finished (${data.status}), rows = ${data.result?.length || 0}`
            );
            return data.result || [];
          }

          /* 仍在 cancelling 中 */
          const elapsed = Date.now() - start;
          if (elapsed > CANCEL_MAX_WAIT) {
            throw new Error(
              `[cancel] timeout: cancel waited ${Math.round(elapsed / 1000)} s`
            );
          }
          console.log(`[cancel] still ${data.status}, retry in ${delay / 1000}s ...`);
          await new Promise(r => setTimeout(r, delay));
          delay = Math.min(delay * 1.5, MAX_DELAY);
        }
      }

      /* ────────────────────────────────────────主轮询逻辑（新增超时→取消）────────────────────────────────────────── */
      async function pollBatchStatus(batchId) {
        const startedAt = Date.now();
        const createdAt = batchQueueId?.gptBatchIdCreatedAt || startedAt;
        let tries = 0;
        let delay = BASE_DELAY;

        while (true) {
          tries += 1;
          const elapsed = Date.now() - startedAt;
          const elapsedSinceCreated = Date.now() - createdAt;
          console.log(`[poll] #${tries}  elapsed ${Math.round(elapsed / 1000)}s`);
          /* ---- 超过单次轮询等待上限2hour 或者 GPT Batch 超过等待上限4hours 则取消GPT Batch 任务 ---- */
          if (elapsed > MAX_TOTAL_WAIT || elapsedSinceCreated > MAX_GPTBATCH_TASK_WAIT) {
            if(isMockMode) { //mock模式因为调用的实时聊天，实时完成，无法取消
              throw new Error(
                `[poll] Timeout: waited ${Math.round(elapsed / 1000)}s (>${MAX_TOTAL_WAIT / 1000}s)`
              );
            } else {
              console.warn(
                `[poll] exceeded ${MAX_TOTAL_WAIT / 1000}s, try to cancel batch ...`
              );
              return await cancelBatchAndFetch(batchId);   // 返回取消后(部分)结果
            }
          }

          /* ---- 调用后端接口 ---- */ //:uid/:gptbatchid/:batchid
          let data;
          try {
            const res = await axios.get(
              isMockMode ? `/api/mbatch/status/${uid}/${batchId}/${batchQueueId}` : `/api/batch/status/${uid}/${batchId}/${batchQueueId}`,
              { timeout: AXIOS_TIMEOUT }                 // **新增：请求超时**
            );
            data = res.data;
            console.log(`[poll] status = ${data.status}`);
          } catch (err) {
            console.error('[poll] Request error:', err.message);
            throw err;                                   // 网络/服务器异常，直接抛出
          }

          /* ---- 根据状态分流 ---- */
          if (data.status === 'completed') {
            console.log(`[poll] Completed, got ${data.result.length} rows`);
            return data.result;                          // **立即返回结果**
          }

          if (ERROR_STATUSES.includes(data.status)) {
            throw new Error(`[poll] Batch ended with status: ${data.status}`);
          }

          /* ---- 未完成：继续等待 ---- */
          console.log(`[poll] Not done yet, retry after ${delay / 1000}s ...`);
          await new Promise((r) => setTimeout(r, delay));

          /* ---- 指数退避，但不超过 MAX_DELAY ---- */
          delay = Math.min(delay * 1.5, MAX_DELAY);
        }
      }

      let gptResults = [];
      try {
        if(recoverStatus !== 'gpt_batch_completed') {
          gptResults = await pollBatchStatus(gptBatchId);
        } else if (batchQueuegptResults && batchQueuegptResults?.length > 0) {
          gptResults = batchQueuegptResults;
        } else {
          throw new Error('No results found in batch queue.');
        }
      } catch (err) {
        console.error("GPT Results batch polling error:", err);
        setBatchStarted(false);
        setToastMessage('Batch polling failed or timed out.');
        setShowToast(true);
        await upsertBatchQueue(batchQueueId, { status: 'failed', gptBatchId, error: `GPT Results batch polling error. Error: ${err.message}`});
        currentBatchTaskInfo.current ={batchQueueId, status: 'failed'};
        return;
      }

      console.log("Batch polling completed:", gptResults, 'currentTime is:', new Date().toLocaleTimeString());

      // 7. 云端同步：GPT任务完成
      try {
        await upsertBatchQueue(
          batchQueueId,
          {
            status: 'gpt_batch_completed',
            gptBatchId,
            gptResults,
            finishedAt: Date.now()
          }
        );
        currentBatchTaskInfo.current ={batchQueueId, status: 'gpt_batch_completed'};
      } catch (err) {
        console.error("Failed to upsert batch queue:", err);
        // 不中断流程
      }

      // 8. 合并结果并批量写历史
      gptResults.forEach(g => {
        const idx = transcriptsForBatch.current.findIndex(t => t.id === g.id);
        if (idx > -1 && ((g?.status && g?.status === 'completed') || !g?.status)) transcriptsForBatch.current[idx].gpt = g;
      });

      const newRecords=[];
      gptResults.forEach(g=>{
        const m = transcriptsForBatch.current.find(t=>t.id===g.id);
        if(m){
          const noteIDnum = m.noteIDnum;
          // 计算 usage usageSum = Math.round(transcription.duration / 60 * 100) / 100;
          const sum = Math.round(m.duration / 60 * 100) / 100 || 0;
          let usage = 0;
          usage = Math.round(sum/5*100)/100;
          // 合并数据
          newRecords.push({
            inputValue:m.transcript,
            usageSum:sum,
            endTime:m.endTime,
            realtimeBoolValue:false,
            transcribeID:m.transcribeID||"Done",
            url:m.url||"",
            noteIDnum,
            videoURL:m.videoURL,
            videoID:m.videoID,
            polishedText:m.polishedText||"",
            title:m.title||"",
            subtitleWithTimestamp:m.subtitleWithTimestamp||"",
            summary:g.summary||"",
            keywords:g.keywords||"",
            outline:g.outline||"",
            chapters:g.chapters||"",
            gptError:g.error||"",
            tokenUsage:g.total_tokens||0
          });
        }
      });

      if(newRecords.length){
        try {
          await batchCreateHistory(newRecords);
          await upsertBatchQueue(
            batchQueueId,
            {
              status: 'completed'
            }
          );
          currentBatchTaskInfo.current ={batchQueueId, status: 'completed'};
        } catch (err) {
          console.error("Failed to batch create history:", err);
          setToastMessage('Failed to batch create history.');
          setShowToast(true);
          await upsertBatchQueue(batchQueueId, { status: 'failed', error: `Failed to batch create history. Error: ${err.message}`});
          currentBatchTaskInfo.current ={batchQueueId, status: 'failed'};
        }
      }

      // 9. 云端同步：批量任务完成后可删除
      try {
        await deleteBatchQueue(batchQueueId, gptBatchId);
      } catch (err) {
        console.error("Failed to delete batch queue:", err);
        // 不中断流程
      }
      console.log("Batch process completed successfully.", 'currentTime is:', new Date().toLocaleTimeString());
      // 10. 显示提示
      setToastMessage('Batch process completed successfully.');
      setShowToast(true);
      setBatchStarted(false);
      currentBatchTaskInfo.current = null; // 清空当前批处理任务信息
    } catch (err) {
      console.error("Batch error", err);
      setBatchStarted(false);
      setToastMessage('Batch process failed.');
      setShowToast(true);
      // 标记云端任务为失败
      await upsertBatchQueue(batchQueueId, { status: 'failed', error: `Batch process failed. Error: ${err.message}`});
      currentBatchTaskInfo.current ={batchQueueId, status: 'failed'};
    }
  };

  /*──────────────── batchCreateHistory – 批量落库 */
  /* 批量更新 Firestore */
  //2025.04.24
  /**
   * 批量写入/更新 History（已修复“旧纪录被清空”问题）
   * 关键修正：
   *   1.  用  find(...)  代替  map(...)  正确取得 oldNote；
   *   2.  先克隆  userDataLocal.History  到  historyCopy，  
   *       再对副本做增改，不再覆盖整张表；
   *   3.  更新或插入时只改动匹配项，其他历史记录原样保留。
   */
  const batchCreateHistory = async (records) => {
    await checkToken();

    // —— 准备 ——  
    const historyCopy = [...(userDataLocal?.History ?? [])];   // 克隆一份，不直接引用
    const transcriptArray = [];
    const noteArray = [];

    let addedTime = 0;
    let addedTokens = 0;

    for (const r of records) {
      console.log('Create history for video:', r.videoURL);

      /* ---------- 1. 取得旧记录 ---------- */
      const oldNote =
        historyCopy.find(
          (h) => h.noteID === r.noteIDnum
        ) ?? null;

      /* ---------- 2. 计算用量 ---------- */
      const now          = new Date();
      const endTimeObj   = r.endTime ? new Date(r.endTime) : now;     // 始终有值
      const videoMinutes = r.usageSum ?? oldNote?.duration ?? 0;      // 本次视频长度 等同于 r.duration
      const tokenCnt = r.tokenusage ?? 0;                             // GPT token 数
      const timeUsage = Math.round(((oldNote?.duration === videoMinutes && videoMinutes > 0 ? 0 : videoMinutes / 5) +
      tokenCnt / 8000) * 100) / 100;                                  // 四舍五入保留 2 位
      const roundedTime = Number(timeUsage.toFixed(2));
      const roundedTokens = Number(tokenCnt.toFixed(2));

      addedTime   += roundedTime;
      addedTokens += roundedTokens;
      // —— 新增：兼容 chapters 可能是对象 ——  
      const rawChapters = r.chapters;
      const chaptersContent = rawChapters != null
        ? (typeof rawChapters === 'string'
            ? rawChapters
            : JSON.stringify(rawChapters))
        : '';

      /* ---------- 3. 新的 transcript ---------- */
      let oldTranscriptData = transcriptDataBuffer.find(item => item.noteID === r.noteIDnum);
      if(!oldTranscriptData) oldTranscriptData = await fetchTrascriptionData(r.noteIDnum);
      if(!oldTranscriptData) {
        transcriptArray.push({
          noteID: oldNote?.noteID ?? r.noteIDnum,
          transcribeID: r?.transcribeID,
          inputValue: r?.inputValue,
          transcript: r?.inputValue,
          polishedText: r?.polishedText,
          summary: r?.summary,
          gptresponse: '',
          videoURL: r?.videoURL,
          videoID: r?.videoID,
          title: r?.title,
          keywords: r?.keywords,
          outline: r?.outline,
          gptError: r?.gptError || '',
          message: chaptersContent.trim()
          ? [{
              id:        Date.now(),
              user:      'Nvoice',
              avatar:    nvoiceLogoImg,
              content:   chaptersContent,
              timestamp: Date.now(),
            }]
          : [],
          // message: r?.chapters && (typeof r?.chapters === 'string' && r.chapters.trim() !== '') ? [
          //   {
          //     id: Date.now(),
          //     user: 'Nvoice',
          //     avatar: nvoiceLogoImg,
          //     content: r.chapters,
          //     timestamp: Date.now(),
          //   },
          // ] : [],
          subtitleWithTimestamp: r?.subtitleWithTimestamp,
        });
      } else {
        const oldInputValueReady = oldTranscriptData?.inputValue === 'Transcript updating...' || oldTranscriptData?.inputValue === '' || !oldTranscriptData?.inputValue ? false : true;;
        const newInputValueReady = r.inputValue === 'Transcript updating...' || r.inputValue === '' || !r.inputValue ? false : true;;
        const oldDataReady = !oldTranscriptData?.subtitleWithTimestamp || oldTranscriptData?.subtitleWithTimestamp === '' ? false : true;
        const newDataReady= !r?.subtitleWithTimestamp || r?.subtitleWithTimestamp === '' ? false : true;
        transcriptArray.push({
          noteID: oldNote?.noteID ?? r.noteIDnum,
          transcribeID: r.transcribeID,
          inputValue: newDataReady ? r?.inputValue : oldTranscriptData?.inputValue,
          transcript: newDataReady ? r?.inputValue : oldTranscriptData?.transcript,
          polishedText: r?.polishedText,
          summary: r?.summary,
          gptresponse: '',
          videoURL: r?.videoURL,
          videoID: r?.videoID,
          title: r?.title,
          keywords: r?.keywords,
          outline: r?.outline,
          gptError: r?.gptError || '',
          message: [
            ...(oldTranscriptData?.message || []),
            ...(chaptersContent.trim()
          ? [{
              id:        Date.now(),
              user:      'Nvoice',
              avatar:    nvoiceLogoImg,
              content:   chaptersContent,
              timestamp: Date.now(),
            }]
          : [])
          ],
            // 只有 chapters 有效时才追加
            // ...(r.chapters && (typeof r?.chapters === 'string' && r.chapters.trim() !== '') ? [{
            //   id: Date.now(),
            //   user: 'Nvoice',
            //   avatar: nvoiceLogoImg,
            //   content: r.chapters,
            //   timestamp: Date.now(),
            // }] : [])
          // ],
          subtitleWithTimestamp: newDataReady ? r?.subtitleWithTimestamp : oldTranscriptData?.subtitleWithTimestamp,
        });
      }
      

      const newHistory = {
        ...oldNote,
        title: r.title,
      
        // —— 日期：取 endTime 的日期部分；若无 endTime，则用当前日期 ——
        date: endTimeObj.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        }),
      
        // —— 起止时间：总是补全，不留空 ——  
        starttime: new Date(endTimeObj.getTime() - videoMinutes * 60000)
          .toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),
      
        endtime: endTimeObj.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        }),
      
        transcript:     '',
        polishedText:   '',
        summary:        '',
        gptresponse:    '',
        keywords:       r.keywords,
        outline:        r.outline,
        tokensusage:   (oldNote?.tokensusage ?? 0) + roundedTokens,
        timeusage:     (oldNote?.timeusage  ?? 0) + roundedTime,
        noteID:         oldNote?.noteID ?? r.noteIDnum,
        transcribeID:   r.transcribeID,
        videoURL:       r.videoURL,
        videoID:        r.videoID,
        duration:       videoMinutes,
      };

      /* ---------- 5. 写回 / 插入 ---------- */
      const idx = historyCopy.findIndex((h) => h.noteID === newHistory.noteID);
      if (idx === -1) {
        historyCopy.push(newHistory);                          // 新纪录
      } else {
        historyCopy[idx] = newHistory;                         // 覆盖旧纪录
      }

      noteArray.push({
        noteIndex: idx === -1 ? historyCopy.length - 1 : idx,
        noteData:  newHistory,
      });
    }

    /* ---------- 6. 持久化 ---------- */
    updateTranscriptionData(transcriptArray);
    updateHistory(noteArray);
    const updatedUsageTime   = Number(((userDataLocal?.Usage?.time        ?? 0) + addedTime).toFixed(2));
    const updatedUsageTokens = (userDataLocal?.Usage?.tokenusage  ?? 0) + addedTokens;

    await updateUserFirestoreData({
      History: historyCopy,
      Usage:   { time: updatedUsageTime, tokenusage: updatedUsageTokens },
    });

    resetUserInfo(updatedUsageTime);
    if (addedTime > 0) setNeedUpdate(true);
  };

  //____________________________________________________________________________________

  return (

    <>

      <div className={isLeftPanelVisible ? "appstyle-body" : "appstyle-body-left-hide"}>

        <div className='appstyle-left-panel' style={{ display: isLeftPanelVisible ? 'block' : 'none' }}>
            <img src={logoSrc} alt="Logo" className="appstyle-logo-left" /> 
            <button className="appstyle-left-item" onClick={handleClickonAvatar} >
              <FontAwesomeIcon icon={faHome} className="appstyle-lighter-icon" /> 
              <span className="btn-text">
              Home&nbsp;&nbsp;</span>
            </button>

            {/* <div className="appstyle-left-item">
                <FontAwesomeIcon icon={faToggleOn} className="appstyle-lighter-icon" /> <span className="btn-text">Mode:&nbsp;&nbsp;</span>
                <select name="mode" className="appstyle-mode-selector"
                  // value = {modeTitle}
                  onChange={(event) => { handleModeChange(event.target.value) }}
                  ref={selectRef}>
                  <option value="Transcribe">{INTERFACE_CONTENT_TEXT['Transcribe'][0]}</option>
                  <option value="Interview">{INTERFACE_CONTENT_TEXT['Interview'][0]}</option>
                  <option value="STT">{INTERFACE_CONTENT_TEXT['STT'][0]}</option>
                  <option value="TTS">{INTERFACE_CONTENT_TEXT['TTS'][0]}</option>
                  <option value="VoiceIntercom">{INTERFACE_CONTENT_TEXT['VoiceIntercom'][0]}</option>
                </select>
            </div> */}
            <button className="appstyle-left-item" onClick={showSettings} >
              <FontAwesomeIcon icon={faCog} className="appstyle-lighter-icon" />
              <span className="btn-text"> Setting&nbsp;&nbsp;</span>
            </button>

            <button className="appstyle-left-item" onClick={showHistory} >
            <FontAwesomeIcon icon={faHistory} className="appstyle-lighter-icon" />
            <span className="btn-text"> History&nbsp;&nbsp;</span>
            </button>


            <button className="appstyle-left-item" onClick={showFaqs} >
              <FontAwesomeIcon icon={faQuestionCircle} className="appstyle-lighter-icon" />
              <span className="btn-text"> FAQs&nbsp;&nbsp;</span>
            </button>

            <div class="appstyle-subscription-card">
              <span className="btn-text"><hr style={{width: '100%'}} /></span>
              <div class="subscription-info">
                <div class="subscription-plan-container">
                  <span class="subscription-plan">{vipLevelString}</span>
                  {userVipLevel > 0 && <span class="validity-period">(Expire at: {expireTime})</span>}
                </div>
                <span class="subscription-usage"> {usageStatus}</span>
                <progress value={usageTime} max={usageMax} class="progress-bar"></progress>
              </div>
              <button class="btn-upgrade" onClick={showUpgrade}>
                <FontAwesomeIcon icon={faLevelUpAlt} className="appstyle-btn-interspace" />
                <span className="btn-text">{upgradeBtnTitle}</span>
              </button>
            </div>
        </div>

        <div className="appstyle-right-panel" style={{ gridColumn: isLeftPanelVisible ? '2' : '1' }}>
            <div className="appstyle-header">
                {isLoading &&
                    <>
                      <div className="overlay"></div> 
                        <div className="apppage-loading-container">
                          <LoadingAnimation />
                          <div className="apppage-loading"> { loadingText }</div>
                        </div>
                    </>}

                    <Button  
                      onClick={handleToggleLeftPanel} 
                      className="appstyle-btn-outline-gray">
                      <FontAwesomeIcon icon={isLeftPanelVisible ? faChevronLeft : faChevronRight} className="appstyle-btn-interspace"/>
                    </Button>
                {/* <div className="appstyle-title">{modeTitle}</div> */}
                <div className="appstyle-title">{currentPresetTitle}</div>
                {/* {modeTitle === 'Interview' && 
                  <Button  
                    onClick={() => setShowSoundSignatureWavrecorder(true)} 
                    className="appstyle-btn-outline">
                      <FontAwesomeIcon icon={faSignature} className="appstyle-btn-interspace"/>
                      <span className="btn-text"> Voice Signature </span>
                  </Button>} */}
                  
                {/* {(modeTitle === 'Interview' || modeTitle === 'Transcribe' )&& 
                  <Button  
                    onClick={() => selectOrKeywordsLanuchAI("Keywords")} 
                    className={callGptByKeywords && !callGptByAI  ? "appstyle-btn-outline":"appstyle-btn-outline-gray"}>
                    <FontAwesomeIcon icon={faKey} className="appstyle-btn-interspace"/> 
                    <span className="btn-text"> AI by Keywords</span>
                  </Button>}
                {(modeTitle === 'Interview' || modeTitle === 'Transcribe' )&& 
                  <Button  
                    onClick={() => selectOrKeywordsLanuchAI('AI')} 
                    className={callGptByKeywords && callGptByAI ? "appstyle-btn-outline":"appstyle-btn-outline-gray"}>
                    <FontAwesomeIcon icon={faRobot} className="appstyle-btn-interspace"/> 
                    <span className="btn-text"> AI by AI</span>
                  </Button>}
                {(modeTitle === 'Interview' || modeTitle === 'Transcribe' )&& 
                  <Button  
                    onClick={() => selectOrKeywordsLanuchAI("Select")} 
                    className={callGptByKeywords ? "appstyle-btn-outline-gray":"appstyle-btn-outline"}>
                    <FontAwesomeIcon icon={faICursor} className="appstyle-btn-interspace"/> 
                    <span className="btn-text"> AI by Select</span>
                  </Button>} */}

                {isLoggedIn && 
                  <button 
                    variant="secondary" 
                    onClick={() => showSTT()} 
                    className={(!isRecognising && !isAIthinking) ? "appstyle-btn-outline":"appstyle-btn-outline-gray"}
                    disabled={isRecognising || isAIthinking}>
                    <FontAwesomeIcon icon={faCloudUploadAlt} className="appstyle-btn-interspace"
                    />
                    <span className="btn-text"> Import </span>
                  </button>}


                {isLoggedIn ? (
                  <img src={ avatarNow } alt="Avatar" className="appstyle-avatarIndex" onClick={handleAvatarClick}/>
                  ) : (
                    <Button variant="primary" style={{ marginLeft: 'auto', marginRight: '10px'}} onClick={handleLoginClick} 
                    className='orange-button'>sign in</Button> 
                )}
            </div>

            <div className= {isHorizontalLayout ? "appstyle-content-horizontalLayout" : "appstyle-content-verticalLayout"} 
              style={{
                gridTemplateAreas: (isTranscriptPanelVisible && isAIResponsePanelVisible) ? (isHorizontalLayout ? '"appstyle-ai-title appstyle-interviewer-title" "appstyle-ai-feedback appstyle-interviewer-speech"' : '"appstyle-ai-title" "appstyle-ai-feedback" "appstyle-interviewer-title" "appstyle-interviewer-speech"') : 
                ((!isTranscriptPanelVisible && isAIResponsePanelVisible) ? ('"appstyle-ai-title" "appstyle-ai-feedback"') : ('"appstyle-interviewer-title" "appstyle-interviewer-speech"')), 
              gridTemplateRows: (isTranscriptPanelVisible && isAIResponsePanelVisible) ? (isHorizontalLayout ? '0.2fr 5fr':'0.3fr 4fr 0.3fr 4fr') : ('0.2fr 5fr'),
              gridTemplateColumns: (isTranscriptPanelVisible && isAIResponsePanelVisible) ? (isHorizontalLayout ? '11fr 5fr':'1fr') : ('1fr') 
              }}>

                <div className="appstyle-ai-title" 
                style={{ 
                  display: isAIResponsePanelVisible ? 'flex' : 'none', 
                  }}>
                  <h2>{aiResponseTitle}</h2>
                  {/* {modeTitle === 'Transcribe' || modeTitle === 'VoiceIntercom' &&  */}
                    <Button  
                      onClick={handleToggleTranscriptPanel} 
                      className="appstyle-btn-outline-white">
                      {isHorizontalLayout &&  
                      <FontAwesomeIcon icon={isTranscriptPanelVisible ? faChevronRight : faChevronLeft} className="appstyle-btn-interspace"/>}
                      {!isHorizontalLayout &&  
                      <FontAwesomeIcon icon={isTranscriptPanelVisible ? faChevronDown : faChevronUp} className="appstyle-btn-interspace"/>}
                    </Button>
                    {/* } */}

                  <Form.Text className="appstyle-text-muted">
                    {isAIthinking ? <span>{nvoiceThinkingStatusText}<span className="dots"> </span></span> : ' '}
                  </Form.Text>
                </div>
                <div className="appstyle-ai-feedback"
                style={{
                  display: isAIResponsePanelVisible ? 'flex' : 'none', 
                  minHeight: isTranscriptPanelVisible && isAIResponsePanelVisible ? (isHorizontalLayout ? '98%' : '50px') : ('50px'),

                  borderRadius: isTranscriptPanelVisible ? (isHorizontalLayout ? '0 0 10px 10px' : '0 0 0 0') : ('0 0 10px 10px'),
                  borderBottom: isTranscriptPanelVisible ? (isHorizontalLayout ?'2px solid #fb8455' : 'none'): ('2px solid #fb8455'), 
                  marginBottom: isTranscriptPanelVisible ? (isHorizontalLayout ? '15px' : '0') : ('15px'),
                  resize: isTranscriptPanelVisible ? (isHorizontalLayout ? 'none' : 'vertical') : ('none'),
                  minHeight: isTranscriptPanelVisible ? (isHorizontalLayout ? '98%' : '100%') : (isHorizontalLayout ? '98%' : '95%'),
                  maxHeight: isTranscriptPanelVisible ? (isHorizontalLayout ? 'none' : `${window.innerHeight * 0.7}px`): ('none'),
                  height: isTranscriptPanelVisible ? (isHorizontalLayout ? '98%' : 'none') : (isHorizontalLayout ? '98%' : '95%')
                  }}>
                    {/* <ChatComponent nvoiceLogo={nvoiceLogoImg} userAvatar={avatarNow}/> */}

                    {responseText !=='' && isLoggedIn && (
                      (modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && callGptByAItemp && userVipLevel > 0 ? 
                        <ChatWindow aiChatMessages={aiChatMessages} /> :
                        <Form.Control as="textarea"
                        placeholder={aiResponsePlaceholdText}
                        value={responseText.replace(/\\n/g, "\n").replace(/\*\*/g, '')}
                        readOnly 
                        className='Form-control'
                        ref={responseTextRef}
                      />
                     )}

                    {responseText ==='' && isLoggedIn && (
                      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <div style={{
                          position: 'absolute',
                          top: '90%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'flex-end',
                          width: '80%',
                          paddingBottom: '10px',
                        }}>
                          <input  //textarea
                            type="text"
                            value={videoURLUserPaste}
                            onChange={handleUrlChange}
                            placeholder="Enter multiple video URLs, separated by commas."
                            className='input-STT'
                          />
                          <button
                            style={{ marginLeft: '5px', width: '50px', height: '30px' }}
                            onClick={handleUrlInputButtonClick}
                            className="appstyle-btn"
                          >
                            GO
                          </button>
                        </div>
                      </div>
                    )}
                </div>

                <div className="appstyle-interviewer-title" 
                  style={{ 
                    display: isTranscriptPanelVisible ? 'flex' : 'none', 
                    borderRadius: isTranscriptPanelVisible ? (isHorizontalLayout ? '10px 10px 0 0' : isAIResponsePanelVisible ? '0 0 0 0' : '10px 10px 0 0') : ('10px 10px 0 0')
                    }}>
                    <h2>{interviewerTitle}</h2>

                    <Button  
                      onClick={handleToggleAIResponsePanel} 
                      className="appstyle-btn-chevron-outline-white">
                      {isHorizontalLayout &&  
                      <FontAwesomeIcon icon={isAIResponsePanelVisible ? faChevronLeft : faChevronRight} className="appstyle-btn-interspace"/>}
                      {!isHorizontalLayout &&  
                      <FontAwesomeIcon icon={isAIResponsePanelVisible ? faChevronUp : faChevronDown} className="appstyle-btn-interspace"/>}
                    </Button>
                </div>

                <div className="appstyle-interviewer-speech" style={{ 
                  display: isTranscriptPanelVisible ? 'flex' : 'none',
                  minHeight: isTranscriptPanelVisible && isAIResponsePanelVisible ? (isHorizontalLayout ? '98%' : '50px') : ('50px'),

                  marginBottom: isAIResponsePanelVisible ? (isHorizontalLayout ? '15px' : '0') : ('15px'),
                  resize: isAIResponsePanelVisible ? (isHorizontalLayout ? 'none' : 'vertical') : ('none'),
                  minHeight: isAIResponsePanelVisible ? (isHorizontalLayout ? '98%' : '90%') : (isHorizontalLayout ? '98%' : '95%'),
                  maxHeight: isAIResponsePanelVisible ? (isHorizontalLayout ? 'none' : `${window.innerHeight * 0.7}px`): ('none'),
                  height: isAIResponsePanelVisible ? (isHorizontalLayout ? '98%' : '90%') : (isHorizontalLayout ? '98%' : '95%')
                  }}>
                  <Form.Control as="textarea"
                    className='Form-control'
                    placeholder={interviewerTranscriptPlaceholdText}
                    value={inputValue}
                    onChange={handleInputChange}
                    readOnly = {(userDataLocal?.TranscriptionMode === 'Offline') ? true : false} 
                    onMouseUp={handleTextSelect}
                    onMouseDown={handleMouseDown}
                    onKeyDown={handleKeyDown}
                    ref={textRef}
                    />
                </div>
            </div>

            <div style={{display:'none'}}>
              <div className="appstyle-interviewee-title" style={{ display:(modeTitle === 'Interview') ? 'block' : 'none' }}>
                  <h2>{intervieweeTitle}</h2>
              </div>
              
              <div className="appstyle-interviewee-answer" style={{ display: (modeTitle === 'Interview') ? 'block' : 'none' }}>
                  <Form.Control as="textarea"
                    className='Form-control'
                    placeholder={intervieweeTranscriptPlaceholdText}
                    value={inputValueYouSay}
                    onChange={handleInputYouSayChange}
                    onMouseUp={handleTextSelectInterviewee}
                    onMouseDown={handleMouseDownInterviewee}
                    ref={textRefYouSay}
                  />

                  {showSelectTextIntervieweePopup && (
                    <div
                      style={{
                        position: 'absolute',
                        top: `${selectTextPopupPosition.top}px`,
                        left: `${selectTextPopupPosition.left}px`,
                        zIndex: 100000
                      }}>
                      <Button variant="secondary"  className='appstyle-btn-selectbtn' onClick={handleAskAI}>Ask AI</Button>
                    </div>)}
              </div>
            </div>

            <div className="appstyle-footer">
              <div className='appstyle-footer-left'>
              <Button variant={isRecognising ? "secondary" : "primary"} onClick={() => toggleListener()} className="appstyle-btn" ref={startStopRecordingRef} disabled={!isLoggedIn}>
                <FontAwesomeIcon icon={isRecognising ? faStop : faMicrophone}  className="appstyle-btn-interspace"/> 
                <span className="btn-text">
                {isRecognising 
                  ? ' Stop'
                  : ' Start'
                }
                </span>
              </Button>
              
              {isRecognising && (userDataLocal?.TranscriptionMode !== 'Offline') && (modeTitle === 'Interview' || modeTitle === 'Transcribe') &&
              <Button  variant="secondary"  onClick={handlePauseResume} className="appstyle-btn">
                <FontAwesomeIcon icon={isPaused ? faPlay : faPause} className="appstyle-btn-interspace"/> 
                <span className="btn-text">
                  {isPaused ? ' Resume' : ' Pause'}
                </span>
              </Button>}

              {/* {(isAIthinking  && (userDataLocal?.TranscriptionMode !== 'Offline') && (modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') && (nvoiceThinkingStatusText === 'Nvoice is speaking' )) || (audioRef.current && audioUrl) && */}
              {audioRef.current && !audioRef.current.paused && (modeTitle === 'Voice intercom' || modeTitleTemp === 'Voice intercom') &&
              <Button  variant="secondary"  onClick={handleSkipPlayingAudio} className="appstyle-btn">
                <FontAwesomeIcon icon={faPause} className="appstyle-btn-interspace"/> 
                <span className="btn-text"> Skip</span>
              </Button>}

              {userVipLevel >0  && (userDataLocal?.TranscriptionMode !== 'Offline') && callGptBySelct && inputValue !== '' &&
              <Button  variant="secondary"  onClick={helpCallGPTAllText} className="appstyle-btn">
                <FontAwesomeIcon icon={faLifeRing} className="appstyle-btn-interspace"/>
                <span className="btn-text"> Ask All</span>
              </Button>}

              {userVipLevel >0  && (userDataLocal?.TranscriptionMode !== 'Offline') && callGptByEnter && inputValue !== '' &&
              <Button  variant="secondary"  onClick={handleEnterPress} className="appstyle-btn">
                <FontAwesomeIcon icon={faPaperPlane} className="appstyle-btn-interspace"/>
                <span className="btn-text"> Enter </span>
              </Button>}

              {/* {!isRecognising && !isAIthinking && isLoggedIn && 
              <Button 
                variant="secondary" 
                onClick={() => showSTT()} 
                className={`appstyle-btn ${(isRecognising || isAIthinking) ? "appstyle-btngray" : ""}`} 
                disabled={isRecognising || isAIthinking}>
                <FontAwesomeIcon icon={faCloudUploadAlt} className="appstyle-btn-interspace"/>
                <span className="btn-text"> Import </span>
              </Button>} */}

              {inputValue !== "" && !isRecognising && !isAIthinking && (userDataLocal?.TranscriptionMode !== 'Offline') && audioBlob && 
              <Button 
                variant="secondary" 
                onClick={() => export2txt(recognisedText, recognisedTextYouSay)} 
                className={`appstyle-btn ${(isRecognising || (recognisedText === "")) ? "appstyle-btngray" : ""}`} 
                disabled={isRecognising || recognisedText === "" }>
                <FontAwesomeIcon icon={faFileExport} className="appstyle-btn-interspace"/>
                <span className="btn-text"> Export</span>
              </Button>}

              {!isRecognising && (userDataLocal?.TranscriptionMode === 'Offline') && enableExportAudio && audioBlob &&
              <Button 
                variant="secondary" 
                onClick={() => export2txt('','')} 
                className={`appstyle-btn ${isRecognising ? "appstyle-btngray" : ""}`} 
                disabled={isRecognising}>
                <FontAwesomeIcon icon={faFileExport} className="appstyle-btn-interspace"/>
                <span className="btn-text"> Export</span>
              </Button>} 

              </div>
              <div className='appstyle-footer-right'>
                {isRecognising && 
                    <canvas ref={canvasRef} />}
              </div>
            </div>
        </div>
        {showPopup && <Userpage onClose={handleCloseUserpagePopup} showHistory={showHistory} showSettings={showSettings} showUpgrade={showUpgrade}/>} 
        {showHistoryPopup && <History isVisible={showHistoryPopup} onClose={handleCloseHistoryPopup} onSelectNote={handleSelectNote} getGPTResponse={getGPTResponse} hidden={selectedNote} nvoiceLogo={nvoiceLogoImg}/>} 

        {showSettingsPopup && <SettingsPopup isVisible={showSettingsPopup} onClose={() => setShowSettingsPopup(false)} onSave={handleSaveChangeSettings}/>} 

        <ConfirmDialog />
        {showPricePopup && <PricePopup isVisible={showPricePopup} onClose={handlePriceClosePopup}/>}
        
        {showCongratulationsPopup &&
        <CongratulationsPopup isVisible={showCongratulationsPopup} onClose={handleCongratulationsClosePopup}/>}

        {showFaqsPopup && <FaqsPopup isVisible={showFaqsPopup} onClose={handleCloseFaqsPopup}/>}    

        {/* {showSoundSignatureWavrecorder && <WavRecorder onClose={handleCloseWavRecorder} onSaveAudio={handleSaveVoiceSignatureAudio}/>} */}

        {selectedNote && (
          <Notedetail note={selectedNote} onClose={handleCloseDetail} getGPTResponse={getGPTResponse} nvoiceLogo={nvoiceLogoImg} userAvatar={avatarNow} upgradeUserLevel={setNeedUpgradeUserLevel}/>
          )}

        {(userVipLevel >= 0 ) && showSTTPopup && <SpeechToTextOffline isVisible={showSTTPopup} onClose={handleCloseSTTPopup} onReceiveData={createHistoryRecord} goHistory={showHistoryForStt} setAudioName={audioNameForOfflineTrancriptionAndSTT} popupStatus={sttPopupStatus} popupMinORMax={sttPopupMinOrMax} videoURLFromHome={videoURLUserPaste}  batchCreateHistory={batchCreateHistory} startGPTBatch={startGPTBatch} upgradeUserLevel={setNeedUpgradeUserLevel}/>} 

        {!isRecognising && (userVipLevel >0 ) && showTTSPopup  && <TextToSpeech isVisible={showTTSPopup} onClose={handleCloseTTSPopup} onReceiveData={createHistoryRecord}/>}
        
        {/* {!isRecognising && (userVipLevel >0 ) && audioBlob && (userDataLocal?.TranscriptionMode === 'Offline') && ( */}
          <OfflineTranscription ref= {audioOfflineTranscriptionRef} createHistory={createHistoryRecord} setAudioName={audioNameForOfflineTrancriptionAndSTT} endTimeOfLocalSave={endTimeOfAudio} realtimeValue={currentRealtimeBoolValue} saveAudioLocally={handleSaveDataLocally}/>
         {/* )} */}
         
         {/* {userDataLocal?.Email === 'support@metaspringai.com' && <RealtimeIntercom/> } */}
         
        {/* {stopBtnClicked &&  
          <div className='audio-control'>
            <audio src={blobURL} controls="controls" crossOrigin="anonymous" />
          </div>
        } */}

        <Toast className="custom-toast-container" onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide>
              <Toast.Body className='custom-toast-content'>{toastMessage}</Toast.Body>
        </Toast>

        <div hidden='true'>
          <audio ref={audioRef} src={audioUrl} onEnded={handleAudioEnded} />
        </div>
        {/* <div hidden='true'>
          <AudioRecorder
            onRecordingComplete={(blob) =>addAudioElement(blob)}
            recorderControls={recorderControls}
            downloadOnSavePress={true} 
            downloadFileExtension={userDataLocal?.AudioSet || "mp3"}
            showVisualizer={false}
          />
        </div> */}

        {showSelectTextPopup && (
                    <div
                      style={{
                        position: 'absolute',
                        top: `${selectTextPopupPosition.top}px`,
                        left: `${selectTextPopupPosition.left}px`,
                        zIndex: 100000
                      }}>
                      <Button variant="secondary"  className='appstyle-btn-selectbtn' onClick={handleAskAI}>Ask AI</Button>
                    </div>)}


      </div>
    </>
  )
}

export default Transcription

